'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactDnd = require('react-dnd');
var reactDndHtml5Backend = require('react-dnd-html5-backend');
var formSchema = require('@graffer-inc/form-schema');
var formGenerator = require('@graffer-inc/form-generator');
var tslib = require('tslib');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var consoleDesignKit = require('@graffer-inc/console-design-kit');
var classNames = require('classnames');
var moment = require('moment');
require('moment/locale/ja');
var OutsideClickHandler = require('@graffer-inc/react-outside-click-handler');
var matcher = require('@graffer-inc/form-schema/dist/utils/matcher');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var OutsideClickHandler__default = /*#__PURE__*/_interopDefaultLegacy(OutsideClickHandler);

var SortFieldTemplate = function (_a) {
    var config = _a.config, children = _a.children;
    var FieldTemplate = formGenerator.DefaultTemplateRegistry.get(config);
    return (React__namespace.createElement("div", { className: "field", style: {
            cursor: "pointer",
        } },
        React__namespace.createElement(FieldTemplate, { config: config }, children)));
};

var ItemType = { CARD: "card" };

var TEST_ID = {
    ToolbarItemList: "ToolbarItemList",
    AddButton: "AddButton",
    EditorBox: "EditorBox",
    AddDropdownMenu: "AddDropdownMenu",
    AddDropdownMenuBetweenElem: "AddDropdownMenuBetweenElem",
    BuilderRepeatableFieldTemplateV2: "BuilderRepeatableFieldTemplateV2",
    FieldSortableWrapper: "FieldSortableWrapper",
    OptionsTextAreaEdit: "OptionsTextAreaEdit",
};

function isToolbarDragItem(item) {
    return !!item.isToolbar;
}
var FieldWrapper = function (_a) {
    var children = _a.children;
    return (React__namespace.createElement("div", null, children));
};
var FieldSortableWrapper = function (_a) {
    var index = _a.index, id = _a.id, moveCard = _a.moveCard, repeatable = _a.repeatable, insertCard = _a.insertCard, disabled = _a.disabled, _b = _a.kind, kind = _b === void 0 ? ItemType.CARD : _b, props = tslib.__rest(_a, ["index", "id", "moveCard", "repeatable", "insertCard", "disabled", "kind"]);
    var ref = React.useRef(null);
    var _c = reactDnd.useDrop({
        accept: kind,
        hover: function (item, monitor) {
            if (!ref.current || disabled) {
                return;
            }
            var dragIndex = item.index;
            var hoverIndex = index;
            if (isToolbarDragItem(item)) {
                if (dragIndex === -1 && item.isToolbar && !item.isAdded) {
                    item.index = hoverIndex;
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    insertCard(item.element, hoverIndex);
                }
                return;
            }
            if (dragIndex === hoverIndex) {
                return;
            }
            if (item.repeatable) {
                if (!repeatable) {
                    return;
                }
                if (repeatable.id !== item.repeatable.id) {
                    return;
                }
            }
            if (!item.repeatable) {
                if (repeatable) {
                    return;
                }
            }
            var hoverBoundingRect = ref.current.getBoundingClientRect();
            var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            var clientOffset = monitor.getClientOffset();
            var hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            moveCard(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    }), drop = _c[1];
    var _d = reactDnd.useDrag({
        type: kind,
        item: function () { return ({
            isToolbar: false,
            id: id,
            index: index,
            repeatable: repeatable,
        }); },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
    }), isDragging = _d[0].isDragging, drag = _d[1];
    var opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    return (React__namespace.createElement("div", { ref: ref, style: { opacity: opacity }, "data-testid": TEST_ID.FieldSortableWrapper }, props.children));
};

var FormSorter = function (_a) {
    var initialSchema = _a.initialSchema, onChange = _a.onChange, _b = _a.InputTemplateRegistry, InputTemplateRegistry = _b === void 0 ? formGenerator.DefaultInputTemplateRegistry : _b;
    var _c = React.useState(formSchema.SchemaBuilder.fromSchema(initialSchema)), schemaBuilder = _c[0], setSchemaBuilder = _c[1];
    var setNewBuilder = function (builder) {
        setSchemaBuilder(formSchema.SchemaBuilder.fromSchema(builder.currentSchema()));
        onChange(schemaBuilder.currentSchema());
    };
    var moveElement = function (dragIndex, hoverIndex) {
        setNewBuilder(schemaBuilder.moveByIndexes(dragIndex, hoverIndex));
    };
    var insertElements = function (elements, index) {
        setNewBuilder(elements.reduce(function (acc, elem, elemIndex) {
            return acc.insertAtIndexes(elem, index + elemIndex);
        }, schemaBuilder));
    };
    return (React__namespace.createElement(reactDnd.DndProvider, { backend: reactDndHtml5Backend.HTML5Backend },
        React__namespace.createElement("div", null, schemaBuilder.currentSection.children.map(function (elem, index) {
            if (formSchema.isInputElement(elem)) {
                var Input = InputTemplateRegistry.get(elem);
                return (React__namespace.createElement(FieldSortableWrapper, { key: elem.id, id: elem.id, index: index, moveCard: moveElement, insertCard: function (elem, index) {
                        insertElements([elem], index);
                    } },
                    React__namespace.createElement(SortFieldTemplate, { key: elem.id, id: elem.id, index: index, config: elem },
                        React__namespace.createElement(Input, { config: elem, value: undefined, touched: false, error: undefined, onChange: console.log, onBlur: console.log, onFocus: console.log, setValue: console.log }),
                        React__namespace.createElement("hr", null))));
            }
            if (formSchema.isRepeatableElement(elem)) {
                return (React__namespace.createElement(FieldSortableWrapper, { id: elem.id, key: elem.id, index: index, moveCard: moveElement, insertCard: function (elem, index) {
                        insertElements([elem], index);
                    } },
                    React__namespace.createElement(SortFieldTemplate, { key: elem.id, id: elem.id, index: index, config: elem },
                        React__namespace.createElement("div", { style: {
                                paddingLeft: "3px",
                            } },
                            React__namespace.createElement("div", { className: "field box", style: {
                                    paddingTop: "12px",
                                    paddingBottom: "12px",
                                    border: "none",
                                    borderRadius: 0,
                                    borderLeft: "2px solid lightgrey",
                                } }, elem.baseUnit.map(function (e, index) {
                                var Input = formGenerator.DefaultInputTemplateRegistry.get(e, elem);
                                return (React__namespace.createElement(FieldSortableWrapper, { id: elem.id, key: elem.id, index: index, moveCard: moveElement, insertCard: function (elem, index) {
                                        insertElements([elem], index);
                                    }, repeatable: elem },
                                    React__namespace.createElement(SortFieldTemplate, { key: elem.id, id: elem.id, index: index, config: elem },
                                        React__namespace.createElement(Input, { config: e, value: undefined, touched: false, error: undefined, onChange: console.log, onBlur: console.log, onFocus: console.log, setValue: console.log }),
                                        React__namespace.createElement("hr", null))));
                            }))),
                        React__namespace.createElement("hr", null))));
            }
            throw new Error("Not implemented yet");
        }))));
};

var IfConditionsViewer = function (_a) {
    var ifConditions = _a.ifConditions, ifCandidates = _a.ifCandidates;
    var conds = ifConditions.conditions;
    return (React__namespace.createElement(React__namespace.Fragment, null, conds.map(function (c, index) {
        var selected = ifCandidates.find(function (s) { return s.id === c.id; });
        return (React__namespace.createElement("div", { key: index, className: "columns is-vcentered" },
            React__namespace.createElement("div", { className: "column is-narrow" },
                React__namespace.createElement("div", { className: "field" }, ifCandidates.find(function (f) { return f.id === c.id; }).label.text)),
            React__namespace.createElement("div", { className: "column is-narrow is-paddingless" },
                React__namespace.createElement("p", null, "\u304C")),
            React__namespace.createElement("div", { className: "column is-narrow" },
                React__namespace.createElement("div", { className: "field" }, selected.enum.find(function (e) { return e.value === c.match.const; }).text)),
            React__namespace.createElement("div", { className: "column is-narrow" }, "\u306E\u3068\u304D\u3001")));
    })));
};

var NoResource = function (_a) {
    var _b = _a.faIcon, faIcon = _b === void 0 ? freeSolidSvgIcons.faExclamationTriangle : _b, title = _a.title, subtitle = _a.subtitle;
    return (React__namespace.createElement("div", { style: {
            border: "1px solid lightgrey",
        } },
        React__namespace.createElement("div", { className: "columns is-centered is-vcentered has-text-centered pt-6 pb-6" },
            React__namespace.createElement("div", { className: "column pt-6 pb-4" },
                React__namespace.createElement("p", { className: "title has-text-weight-normal mt-4", style: {
                        marginBottom: "48px",
                    } },
                    React__namespace.createElement("span", { className: "icon", style: {
                            fontSize: "40px",
                        } },
                        React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: faIcon }))),
                React__namespace.createElement("p", { className: "title has-text-weight-normal" }, title),
                React__namespace.createElement("p", { className: "subtitle" }, subtitle)))));
};

var ThenRuleViewer = function (_a) {
    var thenRule = _a.thenRule, thenCandidates = _a.thenCandidates;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns is-vcentered" },
            React__namespace.createElement("div", { className: "column" }, thenRule.map(function (r) {
                return (React__namespace.createElement(React__namespace.Fragment, { key: r.id }, thenCandidates.find(function (f) {
                    return f.id === r.id;
                }).label.text));
            })),
            React__namespace.createElement("div", { className: "column is-narrow has-text-right" },
                React__namespace.createElement("p", null, "\u306B\u9069\u7528\u3055\u308C\u308B\u8A2D\u5B9A")))));
};

var ConditionalRulesList = function (_a) {
    var schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, formSchema$1 = _a.formSchema, onAdd = _a.onAdd, isAddable = _a.isAddable, onDelete = _a.onDelete, onEdit = _a.onEdit, _b = _a.shouldHide, shouldHide = _b === void 0 ? function () { return false; } : _b;
    var converter = new formSchema.FormSchemaConverter(formSchema$1);
    var ifCandidates = converter.ifCandidates();
    var conditionalRules = formSchema$1.getConditionalRules();
    return (React__namespace.createElement("div", null,
        conditionalRules.map(function (r, index) {
            if (shouldHide(r, index)) {
                return null;
            }
            var key = JSON.stringify(r) + index.toString();
            return (React__namespace.createElement(FieldSortableWrapper, { index: index, key: key, id: key, insertCard: function () { }, moveCard: function (a, b) {
                    setNewBuilder(schemaBuilder.moveRule(a, b));
                } },
                React__namespace.createElement("div", { key: index, className: "columns is-vcentered is-marginless mb-4", style: {
                        borderBottom: "1px solid lightgrey",
                        cursor: "pointer",
                    } },
                    React__namespace.createElement("div", { className: "column is-narrow" },
                        React__namespace.createElement("span", { className: "has-text-weight-bold is-size-5" }, index + 1)),
                    React__namespace.createElement("div", { className: "column" },
                        React__namespace.createElement("p", null,
                            React__namespace.createElement(IfConditionsViewer, { ifConditions: r.if, ifCandidates: ifCandidates })),
                        React__namespace.createElement("p", null,
                            React__namespace.createElement(ThenRuleViewer, { thenRule: r.then.rules, thenCandidates: converter.flatten() }))),
                    React__namespace.createElement("div", { className: "column is-narrow has-text-right is-flex is-align-items-center is-flex-wrap-wrap" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { onClick: function () { return onEdit(index); }, text: "編集", icon: "EditIcon" }),
                        React__namespace.createElement("p", { className: "ml-5" },
                            React__namespace.createElement(consoleDesignKit.TextButton, { color: "danger", onClick: function () { return onDelete(index); }, text: "削除", icon: "TrashIcon" }))))));
        }),
        isAddable ? (conditionalRules.filter(function (r, idx) { return !shouldHide(r, idx); }).length ===
            0 ? (React__namespace.createElement(NoResource, { title: "\u6761\u4EF6\u5206\u5C90\u30EB\u30FC\u30EB\u306F\u307E\u3060\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093", subtitle: React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(React__namespace.Fragment, null,
                    "\u8FFD\u52A0\u30DC\u30BF\u30F3\u3088\u308A\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
                    React__namespace.createElement("br", null),
                    React__namespace.createElement("br", null),
                    React__namespace.createElement("button", { className: "button is-info is-outlined is-rounded", onClick: onAdd }, "\u8FFD\u52A0\u3059\u308B"))) })) : (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement("button", { className: "button is-fullwidth", onClick: onAdd }, "\u8FFD\u52A0\u3059\u308B")))) : (React__namespace.createElement(NoResource, { title: "", subtitle: React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement("p", null, "\u6761\u4EF6\u5206\u5C90\u30EB\u30FC\u30EB\u3092\u8A2D\u5B9A\u3059\u308B\u306B\u306F\u3001"),
                React__namespace.createElement("ul", { className: "mt-1 mb-1" },
                    React__namespace.createElement("li", null,
                        "- \u30BB\u30EC\u30AF\u30C8\u30DC\u30C3\u30AF\u30B9\u3082\u3057\u304F\u306F\u3001\u30E9\u30B8\u30AA\u30DC\u30BF\u30F3\u306E\u8A2D\u5B9A (if\u6761\u4EF6\u9805\u76EE)",
                        " "),
                    React__namespace.createElement("li", null, "- if\u6761\u4EF6\u9805\u76EE\u4EE5\u964D\u306B1\u3064\u4EE5\u4E0A\u306E\u9805\u76EE\u306E\u8A2D\u5B9A")),
                React__namespace.createElement("p", null, "\u304C\u5FC5\u8981\u3067\u3059\u3002")) }))));
};

function useSchemaValidator(elem, factory) {
    var _a = React.useState(factory(elem)), schemaValidator = _a[0], setValidator = _a[1];
    React.useEffect(function () {
        setValidator(factory(elem));
    }, [elem]);
    return schemaValidator;
}
function useFunctionSchemaValidator(elem, factory) {
    var _a = React.useState(factory(elem)), validator = _a[0], setValidator = _a[1];
    React.useEffect(function () {
        setValidator(factory(elem));
    }, [elem]);
    return validator;
}
function useStaticSchemaValidator(elem, factory) {
    var _a = React.useState(factory(elem)), validator = _a[0], setValidator = _a[1];
    React.useEffect(function () {
        setValidator(factory(elem));
    }, [elem]);
    return validator;
}

var ErrorMessage$1 = function (_a) {
    var msg = _a.msg;
    return msg ? React__namespace.createElement("p", { className: "help is-danger" }, msg) : null;
};
var getValidatorName = function (keyword) {
    return new formSchema.ValidatorMatcherState(keyword).matchType({
        allowedCharacters: "許容文字種",
        regexp: "正規表現",
        maxLength: "最大文字数",
        minLength: "最小文字数",
        minimum: "最小値",
        maximum: "最大値",
        corporateNumber: "法人番号",
        postalCode: "郵便番号",
        birthDate: "生年月日",
        allowedTerm: "許容日付期間",
    });
};
var InfoBanner = function (_a) {
    var message = _a.message, description = _a.description, onClose = _a.onClose;
    return (React__namespace.createElement(consoleDesignKit.InformationBanner, { message: message, description: description, onClose: onClose }));
};
var HelpLink = function (_a) {
    var href = _a.href, label = _a.label;
    return (React__namespace.createElement(consoleDesignKit.ExternalLink, { anchor: function (props) { return (React__namespace.createElement("a", tslib.__assign({}, props, { href: href, target: "_blank", rel: "noopener noreferrer" }), props.children)); } }, label));
};

var RequiredHiddenButtons = function (_a) {
    var element = _a.element, onUpdate = _a.onUpdate;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("div", { className: "field has-addons" },
                React__namespace.createElement("p", { className: "control" },
                    React__namespace.createElement("button", { className: classNames__default["default"]("button", {
                            "is-info": formSchema.isRequiredHiddenPattern(element, "REQUIRED_NOT_HIDDEN"),
                        }), onClick: function () {
                            onUpdate(tslib.__assign(tslib.__assign({}, element), { required: true, hidden: false }));
                        } },
                        React__namespace.createElement("span", null, "\u5FC5\u9808"))),
                React__namespace.createElement("p", { className: "control" },
                    React__namespace.createElement("button", { className: classNames__default["default"]("button", {
                            "is-info": formSchema.isRequiredHiddenPattern(element, "NOT_REQUIRED_NOT_HIDDEN"),
                        }), onClick: function () {
                            onUpdate(tslib.__assign(tslib.__assign({}, element), { required: false, hidden: false }));
                        } },
                        React__namespace.createElement("span", null, "\u4EFB\u610F"))),
                React__namespace.createElement("p", { className: "control" },
                    React__namespace.createElement("button", { className: classNames__default["default"]("button", {
                            "is-info": formSchema.isRequiredHiddenPattern(element, "NOT_REQUIRED_HIDDEN"),
                        }), onClick: function () {
                            onUpdate(tslib.__assign(tslib.__assign({}, element), { required: false, hidden: true }));
                        } },
                        React__namespace.createElement("span", null, "\u975E\u8868\u793A"))))),
        formSchema.isRequiredHiddenPattern(element, "INVALID_SETTING") && (React__namespace.createElement("p", { className: "help is-danger" }, "\u8A2D\u5B9A\u9805\u76EE\u304C\u4E0D\u6B63\u306A\u5024\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u3044\u305A\u308C\u304B\u306E\u8A2D\u5B9A\u5024\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002")),
        element.inputType === "formula_result" && element.hidden && (React__namespace.createElement("p", { className: "help is-info" }, "\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A\u3068\u5408\u308F\u305B\u305F\u8A2D\u5B9A\u304C\u975E\u8868\u793A\u3060\u3063\u305F\u5834\u5408\u3001\u8A08\u7B97\u7D50\u679C\u306F\u51FA\u529B\u3055\u308C\u307E\u305B\u3093\u3002"))));
};

var markdownHelpLink = "/help/contents/smartapply-fieldexplanation";

var CommonPropertiesEditor = function (_a) {
    var element = _a.element, subDescription = _a.subDescription, onElementUpdate = _a.onElementUpdate;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.CommonInputSchemaValidator(elem, "warn"); });
    var labelId = "".concat(element.id, "-label");
    var descriptionId = "".concat(element.id, "-description");
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label", htmlFor: labelId }, "\u9805\u76EE\u540D"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { id: labelId, className: "input", type: "text", placeholder: "\u672A\u8A2D\u5B9A", value: element.label.text, onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { label: tslib.__assign(tslib.__assign({}, element.label), { text: e.target.value }) }));
                    } })),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.label() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("div", { className: "label is-flex is-justify-content-space-between is-align-items-baseline mb-0" },
                React__namespace.createElement("label", { className: "mb-2", htmlFor: descriptionId }, "\u8AAC\u660E\u6587"),
                element.description.isMarkdown && (React__namespace.createElement(HelpLink, { href: markdownHelpLink, label: "\u5165\u529B\u65B9\u6CD5\u3084\u30B5\u30F3\u30D7\u30EB\u306F\u3053\u3061\u3089" }))),
            subDescription && (React__namespace.createElement("span", { className: "is-size-7 has-text-grey mb-2" }, subDescription)),
            React__namespace.createElement("div", { className: "control" }, element.description.isMarkdown ? (React__namespace.createElement(consoleDesignKit.MarkdownEditor, { value: element.description.text, layout: "standalone", allowedTagNames: formGenerator.grafferSchemasSuportTagNames, editAreaOptions: {
                    attributes: {
                        id: descriptionId,
                        placeholder: "未設定",
                        rows: 5,
                    },
                }, onChange: function (text) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { description: tslib.__assign(tslib.__assign({}, element.description), { text: text }) }));
                } })) : (React__namespace.createElement("textarea", { id: descriptionId, className: "textarea", rows: 2, placeholder: "\u672A\u8A2D\u5B9A", value: element.description.text, onChange: function (e) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { description: tslib.__assign(tslib.__assign({}, element.label), { text: e.target.value }) }));
                } }))),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.description() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5FC5\u9808\u30FB\u8868\u793A\u8A2D\u5B9A"),
            React__namespace.createElement(RequiredHiddenButtons, { element: element, onUpdate: function (e) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { required: e.required, hidden: e.hidden }));
                } }))));
};

// add all computed initial value in computedInitialValues;
// key must be equal to initialValue.value.name and value is corresponding Japanese name to show in fe-meta
var computedInitialValues = {
    date: "日付",
};
// this func is used to find default initial value kind when selecting existing elements
var getSetInitialValueKind = function (element) {
    if (!element || !element.initialValue) {
        return "neither";
    }
    var initialValue = element.initialValue;
    if (formSchema.isInitialValueDate(initialValue))
        return "date";
    if (formSchema.isFixedInitialValue(initialValue))
        return "fixed";
    return "neither";
};
var FixedValueComponent = function (_a) {
    var onElementUpdate = _a.onElementUpdate, fixedInitialValue = _a.fixedInitialValue, element = _a.element;
    if (getSetInitialValueKind(element) !== "fixed") {
        return null;
    }
    return (React__namespace.createElement("div", { className: "field" },
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("input", { className: "input", type: "text", value: fixedInitialValue.value, onChange: function (e) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { initialValue: tslib.__assign(tslib.__assign({}, element.initialValue), { 
                            // @ts-ignore TODO: fix type
                            value: e.target.value }) }));
                } }))));
};
var InitialCheckBox = function (_a) {
    var initialValueKind = _a.initialValueKind, checkBoxInitialValueKind = _a.checkBoxInitialValueKind, index = _a.index, onChange = _a.onChange;
    return (React__namespace.createElement("div", { key: index, className: "field" },
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("label", { className: "checkbox" },
                React__namespace.createElement("input", { type: "checkbox", checked: initialValueKind === checkBoxInitialValueKind, onChange: function (e) {
                        onChange(e.target.checked);
                    } }),
                checkBoxInitialValueKind in computedInitialValues
                    ? computedInitialValues[checkBoxInitialValueKind]
                    : "初期値",
                "\u3092\u8A2D\u5B9A\u3059\u308B"))));
};
var InitialValueComponent = function (_a) {
    var onElementUpdate = _a.onElementUpdate, element = _a.element, _b = _a.computedInitialValuesName, computedInitialValuesName = _b === void 0 ? [] : _b;
    var _c = React.useState(getSetInitialValueKind(element)), initialValueKind = _c[0], setInitialValueKind = _c[1];
    //Checkbox to choose which initialValue is set
    var InitialValueCheckBox = function (checkBoxInitialValueKind, index) { return (React__namespace.createElement(InitialCheckBox, { initialValueKind: initialValueKind, checkBoxInitialValueKind: checkBoxInitialValueKind, index: index, onChange: function (isChecked) {
            var updateElement = tslib.__assign({}, element);
            if (initialValueKind === checkBoxInitialValueKind) {
                setInitialValueKind("neither");
                if (!isChecked) {
                    delete updateElement.initialValue;
                }
            }
            else {
                setInitialValueKind(checkBoxInitialValueKind);
                if (checkBoxInitialValueKind === "fixed") {
                    updateElement.initialValue = { kind: "fixed", value: "" };
                }
                else {
                    var defaultInitialValueDate = {
                        name: "date",
                        displayFormat: {
                            locale: "ja",
                            format: "YYYY年M月D日(d)",
                        },
                        designatedTime: {
                            diff: { month: 0, day: 0, businessDay: 0 },
                        },
                    };
                    updateElement.initialValue = {
                        kind: "computed",
                        value: defaultInitialValueDate,
                    };
                }
            }
            onElementUpdate(updateElement);
        } })); };
    return (React__namespace.createElement("div", { className: "field" },
        React__namespace.createElement("label", { className: "label" }, "\u521D\u671F\u5024\u8A2D\u5B9A"),
        tslib.__spreadArray(["fixed"], computedInitialValuesName, true).map(function (d, i) { return InitialValueCheckBox(d, i); }),
        initialValueKind === "fixed" &&
            element &&
            element.initialValue &&
            formSchema.isFixedInitialValue(element.initialValue) && (React__namespace.createElement(FixedValueComponent, { element: element, fixedInitialValue: element.initialValue, onElementUpdate: onElementUpdate })),
        initialValueKind === "date" &&
            element &&
            element.initialValue &&
            formSchema.isInitialValueDate(element.initialValue) && (React__namespace.createElement(InitialValueDateComponent, { element: element, computedInitialValue: element.initialValue, onInitialValueDateUpdate: onElementUpdate }))));
};
// month/day => year/month/day
var designatedTime2Form = function (designatedTime) {
    if (!designatedTime.diff) {
        return { year: 0, month: 0, day: 0 };
    }
    var month = designatedTime.diff.month;
    var year = Math.floor(month / 12);
    return { year: year, month: month - year * 12, day: designatedTime.diff.day };
};
// year/month/day => month/day
var form2DesignatedTime = function (formDiff) {
    return {
        diff: {
            month: formDiff.year * 12 + formDiff.month,
            day: formDiff.day,
            businessDay: 0,
        },
    };
};
var InitialValueDateComponent = function (_a) {
    var element = _a.element, computedInitialValue = _a.computedInitialValue, onInitialValueDateUpdate = _a.onInitialValueDateUpdate;
    var _b = React.useState(designatedTime2Form(computedInitialValue.value.designatedTime || {
        year: 0,
        month: 0,
        day: 0,
    })), designatedTimeInForm = _b[0], setDesignatedTimeInForm = _b[1];
    var _c = React.useState(computedInitialValue.value.displayFormat.format || "YYYY年M月D日(d)"), displayFormat = _c[0], setDisplayFormat = _c[1];
    var _d = React.useState(""), testingDisplayFormat = _d[0], setTestingDisplayFormat = _d[1];
    React.useEffect(function () {
        computedInitialValue.value.designatedTime =
            form2DesignatedTime(designatedTimeInForm);
        onInitialValueDateUpdate(element);
    }, [designatedTimeInForm]);
    React.useEffect(function () {
        element.initialValue.value.displayFormat = {
            locale: "ja",
            format: displayFormat,
        };
        onInitialValueDateUpdate(element);
    }, [displayFormat]);
    return (React__namespace.createElement("div", { className: "field" },
        React__namespace.createElement("label", { className: "label" }, "\u521D\u671F\u5024\u8A2D\u5B9A(\u65E5\u4ED8)"),
        React__namespace.createElement("p", { className: "is-size-6 has-text-weight-semibold" }, "\u65E5\u4ED8\u6307\u5B9A"),
        React__namespace.createElement("div", { className: "field is-horizontal" },
            React__namespace.createElement("div", { className: "field-label is-normal" },
                React__namespace.createElement("label", { className: "label" }, "\u5F53\u65E5\u304B\u3089")),
            React__namespace.createElement("div", { className: "field-body" }, [
                ["year", "年"],
                ["month", "月"],
                ["day", "日"],
            ].map(function (d, i) {
                return (React__namespace.createElement("div", { className: "field has-addons", key: i },
                    React__namespace.createElement("div", { className: "control" },
                        React__namespace.createElement("input", { className: "input", type: "number", value: designatedTimeInForm[d[0]], onChange: function (e) {
                                var _a;
                                return setDesignatedTimeInForm(tslib.__assign(tslib.__assign({}, designatedTimeInForm), (_a = {}, _a[d[0]] = parseInt(e.target.value), _a)));
                            } })),
                    React__namespace.createElement("div", { className: "control" },
                        React__namespace.createElement("a", { className: "button is-static" }, d[1]))));
            }))),
        React__namespace.createElement("p", { className: "is-size-6 has-text-weight-semibold" }, "\u8868\u793A\u5F62\u5F0F"),
        React__namespace.createElement("div", { className: "field is-horizontal" },
            React__namespace.createElement("div", { className: "field-body" },
                React__namespace.createElement("div", { className: "field has-addons" },
                    React__namespace.createElement("div", { className: "control is-expanded" },
                        React__namespace.createElement("input", { className: "input", type: "text", value: displayFormat, onChange: function (e) { return setDisplayFormat(e.target.value); } })),
                    React__namespace.createElement("div", { className: "control" },
                        React__namespace.createElement("button", { className: "button is-info", disabled: !displayFormat, onClick: function () {
                                setTestingDisplayFormat(formSchema.getInitialDate(computedInitialValue.value, moment__default["default"]()));
                            } }, "\u78BA\u8A8D\u3059\u308B"))))),
        testingDisplayFormat !== "" && (React__namespace.createElement("p", { className: "is-size-6" },
            "\u8868\u793A\u4F8B: ",
            testingDisplayFormat))));
};

var baseArgs = {
    label: { text: "", shouldDisplay: true },
    description: { text: "", shouldDisplay: true },
    required: true,
};
var generateBaseArgs = function (isMarkdown) { return (tslib.__assign(tslib.__assign({}, baseArgs), (isMarkdown !== undefined && {
    description: { text: "", shouldDisplay: true, isMarkdown: isMarkdown },
}))); };
var DefaultToolbarItemList = [
    {
        key: formSchema.InputElementTypes.Text,
        icon: freeSolidSvgIcons.faFont,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.TextInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), placeholder: "", required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.TextArea,
        icon: freeSolidSvgIcons.faTextHeight,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.TextAreaElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), placeholder: "", required: true, rows: 10 })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Number,
        icon: freeSolidSvgIcons.faFont,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.NumberInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Select,
        icon: freeSolidSvgIcons.faCaretSquareDown,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.SelectElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), enum: [], required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.RadioButtons,
        icon: freeSolidSvgIcons.faDotCircle,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.RadioButtonsElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), enum: [], required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Checkboxes,
        icon: freeSolidSvgIcons.faCheckSquare,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.CheckboxesElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), enum: [], uniqueItems: true, minItems: 0, maxItems: 1, required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Email,
        icon: freeSolidSvgIcons.faEnvelope,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.EmailInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true, placeholder: "" })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Date,
        icon: freeSolidSvgIcons.faCalendarDay,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.DateInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true, dateFormat: "YYYY/MM/DD" })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.DateRange,
        icon: freeSolidSvgIcons.faCalendarDay,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.DateRangeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true, dateFormat: "YYYY/MM/DD" })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Time,
        icon: freeSolidSvgIcons.faClock,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.TimeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.TimeRange,
        icon: freeSolidSvgIcons.faClock,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.TimeRangeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.DateTime,
        icon: freeSolidSvgIcons.faCalendarDay,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.DatetimeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true, dateTimeFormat: "YYYY/MM/DD HH:mm" })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.DateTimeRange,
        icon: freeSolidSvgIcons.faCalendarDay,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.DatetimeRangeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true, dateTimeFormat: "YYYY/MM/DD HH:mm" })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.YearMonth,
        icon: freeSolidSvgIcons.faCalendar,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.YearMonthInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true })),
        ]; },
    },
    {
        key: formSchema.InputElementTypes.Tel,
        icon: freeSolidSvgIcons.faPhone,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.TelInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true })),
        ]; },
        hasDivider: true,
    },
    {
        key: formSchema.InputElementTypes.File,
        icon: freeSolidSvgIcons.faFile,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.FileInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { maxSize: 5, accept: ["application/pdf", "image/png", "image/jpeg"], id: generateUniqueId(), required: true })),
        ]; },
        hasDivider: true,
    },
    {
        key: formSchema.InputElementTypes.MyNumber,
        icon: freeSolidSvgIcons.faIdCard,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.MyNumberInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), required: true })),
        ]; },
        hasDivider: true,
    },
    {
        key: formSchema.InputElementTypes.FormulaResult,
        icon: freeSolidSvgIcons.faCalculator,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.FormulaResultElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { formulaId: undefined, id: generateUniqueId(), required: true })),
        ]; },
        hasDivider: true,
    },
    {
        key: formSchema.InputElementTypes.PostalCode,
        icon: freeSolidSvgIcons.faTenge,
        onCreate: function (generateUniqueId, isMarkdownConfig) {
            var id = generateUniqueId();
            var addressCompleteTarget = generateUniqueId();
            while (id === addressCompleteTarget) {
                addressCompleteTarget = generateUniqueId();
            }
            var postalCodeInputElement = formSchema.PostalCodeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: id, addressCompleteTarget: addressCompleteTarget, required: true }));
            var textInputElement = formSchema.TextInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: addressCompleteTarget, placeholder: "", required: true, label: tslib.__assign(tslib.__assign({}, baseArgs.label), { text: "住所" }) }));
            return [postalCodeInputElement, textInputElement];
        },
    },
    {
        key: "repeatable",
        icon: freeSolidSvgIcons.faRedo,
        onCreate: function (generateUniqueId, isMarkdownConfig) { return [
            formSchema.RepeatableElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), minLength: 1, maxLength: 2, required: true, hidden: false, baseUnit: [] })),
        ]; },
        hasDivider: true,
    },
    {
        key: formSchema.FunctionTypes.CorporateSearch,
        icon: freeSolidSvgIcons.faSearch,
        onCreate: function (generateUniqueId, isMarkdownConfig) {
            var idset = new Set();
            while (idset.size < 5) {
                idset.add(generateUniqueId());
            }
            var ids = Array.from(idset);
            var id = ids[0];
            var nameCompleteTargetId = ids[1];
            var corpNoCompleteTargetId = ids[2];
            var postalCodeCompleteTargetId = ids[3];
            var addressCompleteTargetId = ids[4];
            var searchElem = formSchema.CorporateSearchElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: id, label: {
                    text: "法人検索",
                    shouldDisplay: false,
                }, autocompleteTarget: {
                    corporateName: nameCompleteTargetId,
                    corporateNumber: corpNoCompleteTargetId,
                    corporateAddress: addressCompleteTargetId,
                    corporatePostalCode: postalCodeCompleteTargetId,
                } }));
            var nameInputElem = formSchema.TextInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: nameCompleteTargetId, placeholder: "", required: true, label: {
                    text: "法人名",
                    shouldDisplay: true,
                } }));
            var corpNoInputElem = formSchema.TextInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: corpNoCompleteTargetId, placeholder: "", required: true, label: {
                    text: "法人番号",
                    shouldDisplay: true,
                } }));
            var postalCodeInputElem = formSchema.PostalCodeInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: postalCodeCompleteTargetId, addressCompleteTarget: addressCompleteTargetId, required: true, label: {
                    text: "郵便番号",
                    shouldDisplay: true,
                } }));
            var addressInputElem = formSchema.TextInputElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: addressCompleteTargetId, placeholder: "", required: true, label: {
                    text: "住所",
                    shouldDisplay: true,
                } }));
            return [
                searchElem,
                nameInputElem,
                corpNoInputElem,
                postalCodeInputElem,
                addressInputElem,
            ];
        },
        hasDivider: true,
    },
    {
        key: formSchema.StaticTypes.Description,
        icon: freeSolidSvgIcons.faNoteSticky,
        onCreate: function (generateUniqueId, isMarkdownConfig) {
            return [
                formSchema.DescriptionElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), label: {
                        text: "説明文",
                        shouldDisplay: false,
                    }, text: "", isMarkdown: isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForStaticDescription })),
            ];
        },
        hasDivider: true,
    },
    {
        key: formSchema.StaticTypes.Image,
        icon: freeSolidSvgIcons.faImage,
        onCreate: function (generateUniqueId, isMarkdownConfig) {
            return [
                formSchema.ImageElement.create(tslib.__assign(tslib.__assign({}, generateBaseArgs(isMarkdownConfig === null || isMarkdownConfig === void 0 ? void 0 : isMarkdownConfig.initialValueForCommonProperties)), { id: generateUniqueId(), label: {
                        text: "",
                        shouldDisplay: true,
                    }, refKey: "", name: "", size: 0, altText: "", mimeType: "" })),
            ];
        },
        hasDivider: true,
    },
];

var DefaultElementConfigRegistry = new (/** @class */ (function () {
    function DefaultImpl() {
    }
    DefaultImpl.prototype.get = function (_elem, _repeatable) {
        return {
            disableSort: false,
            disableInsertion: false,
            disableEdit: false,
            disableDelete: false,
            disableCopy: false,
        };
    };
    DefaultImpl.prototype.getSectionEditConfig = function (_elem) {
        return {
            disableSort: false,
            disableEdit: false,
            disableDelete: false,
            disableAdd: false,
            disableCopy: false,
        };
    };
    return DefaultImpl;
}()))();

function isConditionalRulesEditTarget(t) {
    return (t === null || t === void 0 ? void 0 : t.type) === "conditional_rules";
}
function isSectionEditTarget(t) {
    return (t === null || t === void 0 ? void 0 : t.type) === "section";
}
function isElementEditTarget(t) {
    return (t === null || t === void 0 ? void 0 : t.type) === "element";
}
function isConditionalRuleEditTarget(t) {
    return (t === null || t === void 0 ? void 0 : t.type) === "conditional_rule";
}
function isFormulaEditTarget(t) {
    return (t === null || t === void 0 ? void 0 : t.type) === "formula";
}
var useEditState = function () {
    var _a = React.useState(undefined), editState = _a[0], setEditState = _a[1];
    return {
        editState: editState,
        setEditState: setEditState,
        finishEditState: function () { return setEditState(undefined); },
    };
};
var TabTypes$1 = {
    Form: "FORM",
    Rule: "RULE",
    Formula: "FORMULA",
};
var useFormBuilderV2 = function (initialSchema, onChange, initialSection, onChangeCurrentSection, option) {
    var _a, _b;
    var _c = React.useState((function () {
        var schema = formSchema.SchemaBuilder.fromSchema(initialSchema);
        if (initialSection !== undefined &&
            initialSection < schema.sectionCount) {
            schema.changeSection(initialSection);
        }
        return schema;
    })()), schemaBuilder = _c[0], setSchemaBuilder = _c[1];
    var _d = useEditState(), editState = _d.editState, setEditState = _d.setEditState, finishEditState = _d.finishEditState;
    var setNewBuilder = React.useCallback(function (builder) {
        setSchemaBuilder(builder.copy());
        onChange(builder.currentSchema());
    }, [setSchemaBuilder, onChange]);
    var insertElements = React.useCallback(function (elements, index, parent) {
        if (parent) {
            if (!elements.every(formSchema.isElementUsableInRepeatable)) {
                return;
            }
            var inserted = elements.reduce(function (acc, elem, elemIndex) {
                return acc
                    .repeatableOf(parent)
                    .insertAtIndex(elem, index + elemIndex);
            }, schemaBuilder);
            setNewBuilder(inserted);
            setEditState({
                type: "element",
                element: elements[0],
                index: index,
                // baseUnit が更新された、最新の repeatable を parent として設定する。
                parent: inserted.repeatableOf(parent).target,
            });
        }
        else {
            setNewBuilder(elements.reduce(function (acc, elem, elemIndex) {
                return acc.insertAtIndexes(elem, index + elemIndex);
            }, schemaBuilder));
            setEditState({
                type: "element",
                element: elements[0],
                index: index,
            });
        }
    }, [setNewBuilder, schemaBuilder, setEditState]);
    var updateSchema = React.useCallback(function (elem, index, parent) {
        // RepeatableElementの入れ子に出来ないものが含まれている場合、全て弾く
        if (!!parent && !formSchema.isElementUsableInRepeatable(elem)) {
            return;
        }
        setNewBuilder(!parent
            ? schemaBuilder.replaceByIndexes(elem, index)
            : schemaBuilder
                .repeatableOf(parent)
                .replaceByIndex(elem, index));
    }, [setNewBuilder, schemaBuilder]);
    var removeElement = React.useCallback(function (index, parent) {
        if (parent) {
            setNewBuilder(schemaBuilder.repeatableOf(parent).removeByIndex(index).copy());
        }
        else {
            setNewBuilder(schemaBuilder.removeByIndexes(index).copy());
        }
        finishEditState();
    }, [setNewBuilder, schemaBuilder, finishEditState]);
    var moveSection = React.useCallback(function (a, b) {
        setNewBuilder(schemaBuilder.moveSection(a, b));
    }, [setNewBuilder, schemaBuilder]);
    var moveElement = React.useCallback(function (a, b, parent) {
        var targetBuilder = parent
            ? schemaBuilder.repeatableOf(parent)
            : schemaBuilder;
        setNewBuilder(targetBuilder.moveByIndexes(a, b).copy());
        finishEditState();
    }, [setNewBuilder, schemaBuilder, finishEditState]);
    var changeSection = React.useCallback(function (builder, index) {
        finishEditState();
        setSchemaBuilder(builder.changeSection(index).copy());
        if (onChangeCurrentSection) {
            onChangeCurrentSection(index);
        }
    }, [finishEditState, setSchemaBuilder, onChangeCurrentSection]);
    var insertSection = React.useCallback(function (builder, sect, index) {
        finishEditState();
        var newBuilder = builder.insertSection(sect, index).copy();
        setNewBuilder(newBuilder);
        setEditState({
            type: "section",
            element: newBuilder.currentSchema().root[index],
            sectIndex: index,
        });
    }, [finishEditState, setNewBuilder, setEditState]);
    var _e = React.useState((_a = option === null || option === void 0 ? void 0 : option.initialTab) !== null && _a !== void 0 ? _a : TabTypes$1.Form), tabState = _e[0], setTabState = _e[1];
    var changeTab = React.useCallback(function (tab) {
        setTabState(tab);
        finishEditState();
        if (option === null || option === void 0 ? void 0 : option.onChangeCurrentTab) {
            option.onChangeCurrentTab(tab);
        }
    }, [setTabState, option === null || option === void 0 ? void 0 : option.onChangeCurrentTab]);
    var tabs = [{ literal: TabTypes$1.Form, label: "フォーム設定" }];
    if (!(option === null || option === void 0 ? void 0 : option.disableConditionalRules)) {
        tabs.push({ literal: TabTypes$1.Rule, label: "条件分岐設定" });
    }
    if (option === null || option === void 0 ? void 0 : option.supportFormula) {
        tabs.push({ literal: TabTypes$1.Formula, label: "自動計算数式" });
    }
    var isClickableMarkdownApplyButton = React.useCallback(function () {
        if (!(option === null || option === void 0 ? void 0 : option.markdownConfig)) {
            return false;
        }
        var markdownConfig = option.markdownConfig;
        return (
        //計算量的に hasNonMarkdownForDescriptionElement を先にチェックした方が良い
        (markdownConfig.initialValueForStaticDescription &&
            !schemaBuilder
                .currentSchema()
                .isMarkdownAppliedForAllDescriptionElement()) ||
            (markdownConfig.initialValueForCommonProperties &&
                !schemaBuilder.currentSchema().isMarkdownAppliedForAllDescription()));
    }, [schemaBuilder, option]);
    var _f = React.useState(((_b = option === null || option === void 0 ? void 0 : option.markdownConfig) === null || _b === void 0 ? void 0 : _b.showMarkdownApplyBanner) &&
        isClickableMarkdownApplyButton()), showMarkdownApplyBanner = _f[0], setShowMarkdownApplyBanner = _f[1];
    var applyDescriptionMarkdown = React.useCallback(function () {
        if (!(option === null || option === void 0 ? void 0 : option.markdownConfig)) {
            return;
        }
        var markdownConfig = option.markdownConfig;
        var schema = schemaBuilder.copy().currentSchema();
        if (markdownConfig.initialValueForCommonProperties) {
            schema.applyMarkdownForAllDescription();
        }
        if (markdownConfig.initialValueForStaticDescription) {
            schema.applyMarkdownForAllDescriptionElement();
        }
        setNewBuilder(formSchema.SchemaBuilder.fromSchema(schema));
        finishEditState();
        return;
    }, [schemaBuilder, option, setNewBuilder, finishEditState]);
    return {
        ruleSetMap: schemaBuilder.conditionalRuleConverter.conditionalRuleMap(),
        schemaBuilder: schemaBuilder,
        setNewBuilder: setNewBuilder,
        changeSection: changeSection,
        moveSection: moveSection,
        insertSection: insertSection,
        insertElements: insertElements,
        updateSchema: updateSchema,
        removeElement: removeElement,
        moveElement: moveElement,
        editState: editState,
        setEditState: setEditState,
        finishEditState: finishEditState,
        tabs: tabs,
        tabState: tabState,
        changeTab: changeTab,
        showMarkdownApplyBanner: showMarkdownApplyBanner,
        setShowMarkdownApplyBanner: setShowMarkdownApplyBanner,
        isClickableMarkdownApplyButton: isClickableMarkdownApplyButton,
        applyDescriptionMarkdown: applyDescriptionMarkdown,
    };
};
var useAddingState = function () {
    var _a = React.useState(), addingState = _a[0], setAddingState = _a[1];
    return {
        addingState: addingState,
        setAddingState: setAddingState,
        finishAddingState: function () { return setAddingState(undefined); },
    };
};

var IfConditionsEditor = function (_a) {
    var fixIfConditionElement = _a.fixIfConditionElement, ifConditions = _a.ifConditions, ifCandidates = _a.ifCandidates, onUpdate = _a.onUpdate, _b = _a.unselectedLabel, unselectedLabel = _b === void 0 ? "未選択" : _b;
    var conds = ifConditions.conditions;
    return (React__namespace.createElement(React__namespace.Fragment, null, conds.map(function (c, index) {
        var selected = ifCandidates.find(function (s) { return s.id === c.id; });
        return (React__namespace.createElement("div", { key: index, className: "columns is-multiline is-vcentered" },
            React__namespace.createElement("div", { className: "column is-narrow" },
                React__namespace.createElement("div", { className: "field" },
                    React__namespace.createElement("div", { className: "select" },
                        React__namespace.createElement("select", { value: c.id, disabled: fixIfConditionElement, onChange: function (e) {
                                onUpdate(tslib.__assign(tslib.__assign({}, ifConditions), { conditions: conds.map(function (c, i) {
                                        if (index !== i) {
                                            return c;
                                        }
                                        var targetIf = ifCandidates.find(function (s) { return s.id === e.target.value; });
                                        return tslib.__assign(tslib.__assign({}, c), { id: e.target.value, match: {
                                                const: (targetIf === null || targetIf === void 0 ? void 0 : targetIf.enum[0].value) || "",
                                            } });
                                    }) }));
                            } },
                            " ",
                            React__namespace.createElement("option", { value: "", key: "" }, unselectedLabel),
                            ifCandidates.map(function (f) {
                                return (React__namespace.createElement("option", { value: f.id, key: f.id }, f.label.text));
                            }))))),
            React__namespace.createElement("div", { className: "column is-narrow" },
                React__namespace.createElement("p", null, "\u304C")),
            React__namespace.createElement("div", { className: "column is-narrow" },
                React__namespace.createElement("div", { className: "field" },
                    React__namespace.createElement("div", { className: "select" },
                        React__namespace.createElement("select", { value: c.match.const, onChange: function (e) {
                                onUpdate(tslib.__assign(tslib.__assign({}, ifConditions), { conditions: conds.map(function (c, i) {
                                        if (index !== i) {
                                            return c;
                                        }
                                        else {
                                            return tslib.__assign(tslib.__assign({}, c), { match: tslib.__assign(tslib.__assign({}, c.match), { const: e.target.value }) });
                                        }
                                    }) }));
                            } },
                            React__namespace.createElement("option", { value: "", key: "" }, unselectedLabel),
                            !!selected &&
                                selected.enum.map(function (e) {
                                    return (React__namespace.createElement("option", { key: e.value, value: e.value }, e.text));
                                })))))));
    })));
};

var ToggleField = function (_a) {
    var label = _a.label, isOn = _a.isOn, setOn = _a.setOn, setOff = _a.setOff, children = _a.children, disabled = _a.disabled;
    return (React__namespace.createElement("div", { className: "field" },
        React__namespace.createElement("div", { className: "columns is-marginless is-paddingless is-mobile mb-1" },
            React__namespace.createElement("div", { className: "column is-marginless is-paddingless" },
                React__namespace.createElement("label", { className: "label" }, label)),
            React__namespace.createElement("div", { className: "column is-marginless is-paddingless" },
                React__namespace.createElement("div", { className: "buttons is-small is-right has-addons" },
                    React__namespace.createElement("button", { disabled: disabled, className: classNames__default["default"]("button is-small", {
                            "is-selected": isOn,
                            "is-success": isOn,
                        }), onClick: setOn }, "ON"),
                    React__namespace.createElement("button", { disabled: disabled, className: classNames__default["default"]("button is-small", {
                            "is-selected": !isOn,
                            "is-success": !isOn,
                        }), onClick: setOff }, "OFF")))),
        isOn && children));
};

function useToggleField(hasValue) {
    var _a = React.useState(false), isOn = _a[0], setIsOn = _a[1];
    return {
        isOn: isOn || !!hasValue(),
        setOn: function () { return setIsOn(true); },
        setOff: function () { return setIsOn(false); },
    };
}

var ConditionalRequiredHiddenButtons = function (_a) {
    var rule = _a.rule, onUpdate = _a.onUpdate, element = _a.element;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("div", { className: "field has-addons" },
                React__namespace.createElement("p", { className: "control" },
                    React__namespace.createElement("button", { className: classNames__default["default"]("button", {
                            "is-info": formSchema.isRequiredHiddenPattern(rule, "REQUIRED_NOT_HIDDEN"),
                        }), onClick: function () {
                            onUpdate(tslib.__assign(tslib.__assign({}, rule), { required: true, hidden: false }));
                        } },
                        React__namespace.createElement("span", null, "\u5FC5\u9808"))),
                React__namespace.createElement("p", { className: "control" },
                    React__namespace.createElement("button", { className: classNames__default["default"]("button", {
                            "is-info": formSchema.isRequiredHiddenPattern(rule, "NOT_REQUIRED_NOT_HIDDEN"),
                        }), onClick: function () {
                            onUpdate(tslib.__assign(tslib.__assign({}, rule), { required: false, hidden: false }));
                        } },
                        React__namespace.createElement("span", null, "\u4EFB\u610F"))),
                React__namespace.createElement("p", { className: "control" },
                    React__namespace.createElement("button", { className: classNames__default["default"]("button", {
                            "is-info": formSchema.isRequiredHiddenPattern(rule, "NOT_REQUIRED_HIDDEN"),
                        }), onClick: function () {
                            onUpdate(tslib.__assign(tslib.__assign({}, rule), { required: false, hidden: true }));
                        } },
                        React__namespace.createElement("span", null, "\u975E\u8868\u793A"))))),
        formSchema.isRequiredHiddenPattern(rule, "INVALID_SETTING") && (React__namespace.createElement("p", { className: "help is-danger" }, "\u8A2D\u5B9A\u9805\u76EE\u304C\u4E0D\u6B63\u306A\u5024\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u3044\u305A\u308C\u304B\u306E\u8A2D\u5B9A\u5024\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002")),
        !formSchema.isRepeatableElement(element) &&
            (element === null || element === void 0 ? void 0 : element.inputType) === "formula_result" &&
            rule.hidden && (React__namespace.createElement("p", { className: "help is-info" }, "\u975E\u8868\u793A\u306B\u8A2D\u5B9A\u3057\u305F\u5834\u5408\u3001\u8A08\u7B97\u7D50\u679C\u306F\u51FA\u529B\u3055\u308C\u307E\u305B\u3093\u3002"))));
};

var ShowHideButtons = function (_a) {
    var hidden = _a.hidden, onSelectShow = _a.onSelectShow, onSelectHide = _a.onSelectHide;
    return (React__default["default"].createElement("div", { className: "control" },
        React__default["default"].createElement("div", { className: "field has-addons" },
            React__default["default"].createElement("p", { className: "control" },
                React__default["default"].createElement("button", { className: classNames__default["default"]("button", {
                        "is-info": !hidden,
                    }), onClick: onSelectShow },
                    React__default["default"].createElement("span", null, "\u8868\u793A"))),
            React__default["default"].createElement("p", { className: "control" },
                React__default["default"].createElement("button", { className: classNames__default["default"]("button", {
                        "is-info": hidden,
                    }), onClick: onSelectHide },
                    React__default["default"].createElement("span", null, "\u975E\u8868\u793A"))))));
};

/**
 * FunctionalElement を then に持つ rule の設定ボタン。
 * hidden 値の設定のみを受け付ける。
 */
var ConditionalShowHideButtons = function (_a) {
    var rule = _a.rule, onUpdate = _a.onUpdate;
    return (React__default["default"].createElement(ShowHideButtons, { hidden: !!rule.hidden, onSelectShow: function () {
            onUpdate(tslib.__assign(tslib.__assign({}, rule), { hidden: false }));
        }, onSelectHide: function () {
            onUpdate(tslib.__assign(tslib.__assign({}, rule), { hidden: true }));
        } }));
};

var ThenRuleEditor = function (_a) {
    var r = _a.thenRule, fixApplyingTarget = _a.fixApplyingTarget, thenCandidates = _a.thenCandidates, onUpdate = _a.onUpdate, element = _a.element, _b = _a.unselectedLabel, unselectedLabel = _b === void 0 ? "未選択" : _b;
    var toggleProps = useToggleField(function () { return !formSchema.isRequiredHiddenPattern(r.rule, "NO_SETTING"); });
    var setOff = React__namespace.useCallback(function () {
        var newRule = tslib.__assign({}, r.rule);
        delete newRule["required"];
        delete newRule["hidden"];
        onUpdate(tslib.__assign(tslib.__assign({}, r), { rule: tslib.__assign({}, newRule) }));
        toggleProps.setOff();
    }, [r, onUpdate, toggleProps]);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u9069\u7528\u5BFE\u8C61"),
            React__namespace.createElement("div", { className: "select" },
                React__namespace.createElement("select", { value: r.id, disabled: fixApplyingTarget, onChange: function (e) {
                        onUpdate(tslib.__assign(tslib.__assign({}, r), { id: e.target.value }));
                    } },
                    React__namespace.createElement("option", { key: "", value: "" }, unselectedLabel),
                    thenCandidates.map(function (f) {
                        return (React__namespace.createElement("option", { key: f.id, value: f.id }, f.label.text));
                    })))),
        formSchema.isInputElement(element) && (React__namespace.createElement(InputElementThenEditor, { toggleProps: toggleProps, thenRule: r, onUpdate: onUpdate, setOff: setOff, element: element })),
        formSchema.isFunctionElement(element) && (React__namespace.createElement(FunctionElementThenEditor, { toggleProps: toggleProps, thenRule: r, onUpdate: onUpdate, setOff: setOff, element: element })),
        formSchema.isStaticElement(element) && (React__namespace.createElement(StaticElementThenEditor, { toggleProps: toggleProps, thenRule: r, onUpdate: onUpdate, setOff: setOff, element: element })),
        formSchema.isRepeatableElement(element) && (React__namespace.createElement(RepeatableElementThenEditor, { toggleProps: toggleProps, thenRule: r, onUpdate: onUpdate, setOff: setOff, element: element }))));
};
var InputElementThenEditor = function (_a) {
    var toggleProps = _a.toggleProps, r = _a.thenRule, onUpdate = _a.onUpdate, setOff = _a.setOff, element = _a.element;
    return (React__namespace.createElement(ToggleField, tslib.__assign({ label: "\u5FC5\u9808\u30FB\u8868\u793A\u8A2D\u5B9A" }, toggleProps, { setOff: setOff }),
        React__namespace.createElement(ConditionalRequiredHiddenButtons, { rule: r.rule, onUpdate: function (newRule) {
                return onUpdate(tslib.__assign(tslib.__assign({}, r), { rule: tslib.__assign({}, newRule) }));
            }, element: element })));
};
var RepeatableElementThenEditor = function (_a) {
    var toggleProps = _a.toggleProps, onUpdate = _a.onUpdate, setOff = _a.setOff, thenRule = _a.thenRule, element = _a.element;
    return (React__namespace.createElement(ToggleField, tslib.__assign({ label: "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A" }, toggleProps, { setOff: setOff }),
        React__namespace.createElement(ConditionalRequiredHiddenButtons, { rule: thenRule.rule, onUpdate: function (newRule) {
                return onUpdate(tslib.__assign(tslib.__assign({}, thenRule), { rule: tslib.__assign({}, newRule) }));
            }, element: element })));
};
var FunctionElementThenEditor = function (_a) {
    var toggleProps = _a.toggleProps, onUpdate = _a.onUpdate, setOff = _a.setOff, thenRule = _a.thenRule;
    return (React__namespace.createElement(ToggleField, tslib.__assign({ label: "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A" }, toggleProps, { setOff: setOff }),
        React__namespace.createElement(ConditionalShowHideButtons, { rule: thenRule.rule, onUpdate: function (newRule) {
                return onUpdate(tslib.__assign(tslib.__assign({}, thenRule), { rule: tslib.__assign({}, newRule) }));
            } })));
};
var StaticElementThenEditor = function (_a) {
    var toggleProps = _a.toggleProps, onUpdate = _a.onUpdate, setOff = _a.setOff, thenRule = _a.thenRule;
    return (React__namespace.createElement(ToggleField, tslib.__assign({ label: "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A" }, toggleProps, { setOff: setOff }),
        React__namespace.createElement(ConditionalShowHideButtons, { rule: thenRule.rule, onUpdate: function (newRule) {
                onUpdate(tslib.__assign(tslib.__assign({}, thenRule), { rule: tslib.__assign({}, newRule) }));
            } })));
};

var ThenRulesEditor = function (_a) {
    var thenRules = _a.thenRules, editingElement = _a.editingElement, thenCandidates = _a.thenCandidates, _b = _a.thenDisplayFilter, thenDisplayFilter = _b === void 0 ? function () { return true; } : _b, onUpdate = _a.onUpdate;
    var totalRules = thenRules.length;
    var thenFiltered = thenRules.filter(thenDisplayFilter).length;
    var _c = React.useState(totalRules !== thenFiltered), filterToggle = _c[0], setFilterToggle = _c[1];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns is-vcentered" },
            React__namespace.createElement("div", { className: "column" }, thenRules.map(function (r, index) {
                if (!thenDisplayFilter(r) && filterToggle) {
                    return null;
                }
                var targetElement = thenCandidates.find(function (e) { return e.id === r.id; });
                return (React__namespace.createElement(React__namespace.Fragment, null, targetElement && (React__namespace.createElement(ThenRuleEditor, { fixApplyingTarget: editingElement && editingElement.id === r.id, thenRule: r, thenCandidates: thenCandidates, element: targetElement, onUpdate: function (newRule) {
                        onUpdate(thenRules.map(function (rule, i) {
                            if (index === i) {
                                return newRule;
                            }
                            else {
                                return rule;
                            }
                        }));
                    } }))));
            }))),
        filterToggle && totalRules - thenFiltered > 0 && (React__namespace.createElement("div", null,
            React__namespace.createElement("button", { className: "button is-fullwidth", onClick: function () { return setFilterToggle(false); } },
                "\u4ED6\u306E\u8A2D\u5B9A\u3082\u8868\u793A\uFF08\u6B8B\u308A",
                totalRules - thenFiltered,
                "\u4EF6\uFF09")))));
};

/**
 * ValueObjectの基本型
 */
var BaseValue = /** @class */ (function () {
    function BaseValue(value) {
        this.value = value;
    }
    BaseValue.prototype.getValue = function () {
        return this.value;
    };
    return BaseValue;
}());
/**
 * StringLiteralsをベースにした選択可能なValueObjectの基本型
 */
/** @class */ ((function (_super) {
    tslib.__extends(BaseType, _super);
    function BaseType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseType.prototype.equals = function (type) {
        return this.value === type;
    };
    BaseType.prototype.typeEquals = function (target) {
        return this.value === target.value;
    };
    BaseType.prototype.matchType = function (matcher) {
        return matcher[this.value];
    };
    return BaseType;
})(BaseValue));
function matchType(value, matcher) {
    return matcher[value];
}

var ConditionalRuleEditorView = function (_a) {
    var formSchema$1 = _a.formSchema, rule = _a.rule, editingElement = _a.editingElement, onUpdate = _a.onUpdate, thenDisplayFilter = _a.thenDisplayFilter, _b = _a.viewMode, viewMode = _b === void 0 ? "EDITABLE" : _b;
    var converter = new formSchema.FormSchemaConverter(formSchema$1);
    var thenInputFilter = useFormEditorContext().thenInputFilter;
    var ifCandidates = converter.ifCandidates(rule.then);
    var thenCandidates = converter.thenCandidates(rule.if, thenInputFilter);
    var conditionalRuleValidator = React__namespace.useMemo(function () { return new formSchema.ConditionalRuleValidator(formSchema$1); }, [formSchema$1]);
    return (React__namespace.createElement(React__namespace.Fragment, null, matchType(viewMode, {
        EDITABLE: (React__namespace.createElement(ConditionalRuleEditorViewEditable, { rule: rule, editingElement: editingElement, onUpdate: onUpdate, ifCandidates: ifCandidates, thenCandidates: thenCandidates, thenDisplayFilter: thenDisplayFilter, conditionalRuleValidator: conditionalRuleValidator })),
        READONLY: (React__namespace.createElement(ConditionalRuleEditorViewReadonly, { ifConditions: rule.if, ifCandidates: ifCandidates, thenCandidates: thenCandidates, thenRules: rule.then.rules })),
    })));
};
var ConditionalRuleEditorViewEditable = function (_a) {
    var rule = _a.rule, editingElement = _a.editingElement, onUpdate = _a.onUpdate, ifCandidates = _a.ifCandidates, thenCandidates = _a.thenCandidates, thenDisplayFilter = _a.thenDisplayFilter, conditionalRuleValidator = _a.conditionalRuleValidator;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { style: {
                marginBottom: "24px",
            } },
            React__namespace.createElement("p", { className: "title is-size-5", style: {
                    borderLeft: "3px solid #40bfb0",
                    paddingLeft: "6px",
                } }, "\u6761\u4EF6"),
            React__namespace.createElement("div", { style: {
                    paddingLeft: "6px",
                } },
                React__namespace.createElement(IfConditionsEditor, { ifConditions: rule.if, ifCandidates: ifCandidates, fixIfConditionElement: editingElement &&
                        rule.if.conditions.length === 1 &&
                        rule.if.conditions[0].id === editingElement.id, onUpdate: function (ifCond) {
                        onUpdate(tslib.__assign(tslib.__assign({}, rule), { if: ifCond }));
                    } }),
                React__namespace.createElement(ErrorMessage$1, { msg: conditionalRuleValidator.checkInvalidIf(rule)
                        ? "条件に設定されている内容を修正してください"
                        : undefined }))),
        React__namespace.createElement("div", { style: {
                marginBottom: "24px",
            } },
            React__namespace.createElement("p", { className: "title is-size-5", style: {
                    borderLeft: "3px solid #40bfb0",
                    paddingLeft: "12px",
                } }, "\u9069\u7528\u3055\u308C\u308B\u8A2D\u5B9A"),
            React__namespace.createElement("div", { style: {
                    paddingLeft: "6px",
                } },
                React__namespace.createElement(ThenRulesEditor, { editingElement: editingElement, thenRules: rule.then.rules, thenCandidates: thenCandidates, thenDisplayFilter: thenDisplayFilter, onUpdate: function (then) {
                        onUpdate(tslib.__assign(tslib.__assign({}, rule), { then: { rules: then } }));
                    } }),
                React__namespace.createElement(ErrorMessage$1, { msg: conditionalRuleValidator.checkInvalidThen(rule)
                        ? "適用される設定を修正してください"
                        : undefined })))));
};
var ConditionalRuleEditorViewReadonly = function (_a) {
    var ifConditions = _a.ifConditions, ifCandidates = _a.ifCandidates, thenRules = _a.thenRules, thenCandidates = _a.thenCandidates;
    // css style basically copied from ConditionalRuleEditorViewEditable,
    // but change it whenever necessary; no need to keep them completely the same.
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { style: {
                marginBottom: "24px",
            } },
            React__namespace.createElement("p", { className: "title is-size-5", style: {
                    borderLeft: "3px solid #40bfb0",
                    paddingLeft: "6px",
                } }, "\u6761\u4EF6"),
            React__namespace.createElement("div", { style: {
                    paddingLeft: "6px",
                } }, ifConditions.conditions.map(function (c, index) {
                var _a;
                var selected = ifCandidates.find(function (s) { return s.id === c.id; });
                return (React__namespace.createElement("div", { key: index, className: "columns is-multiline is-vcentered" },
                    React__namespace.createElement("div", { className: "column is-narrow" },
                        React__namespace.createElement("div", { className: "field" },
                            React__namespace.createElement("p", { className: "has-text-weight-bold" }, selected === null || selected === void 0 ? void 0 : selected.label.text))),
                    React__namespace.createElement("div", { className: "column is-narrow" },
                        React__namespace.createElement("p", null, "\u304C")),
                    React__namespace.createElement("div", { className: "column is-narrow" },
                        React__namespace.createElement("div", { className: "field" },
                            React__namespace.createElement("p", { className: "has-text-weight-bold" }, (_a = selected === null || selected === void 0 ? void 0 : selected.enum.find(function (e) { return c.match.const === e.value; })) === null || _a === void 0 ? void 0 : _a.text)))));
            }))),
        React__namespace.createElement("div", { style: {
                marginBottom: "24px",
            } },
            React__namespace.createElement("p", { className: "title is-size-5", style: {
                    borderLeft: "3px solid #40bfb0",
                    paddingLeft: "12px",
                } }, "\u9069\u7528\u3055\u308C\u308B\u8A2D\u5B9A"),
            React__namespace.createElement("div", { style: {
                    paddingLeft: "6px",
                } },
                React__namespace.createElement("div", { className: "columns is-vcentered" },
                    React__namespace.createElement("div", { className: "column" }, thenRules.map(function (r) {
                        var targetElement = thenCandidates.find(function (e) { return e.id === r.id; });
                        return (React__namespace.createElement(React__namespace.Fragment, null, targetElement && (React__namespace.createElement(React__namespace.Fragment, null,
                            React__namespace.createElement("div", { className: "field" },
                                React__namespace.createElement("label", { className: "label" }, "\u9069\u7528\u5BFE\u8C61"),
                                React__namespace.createElement("p", null, targetElement.label.text)),
                            formSchema.isInputElement(targetElement) && (React__namespace.createElement("div", { className: "field" },
                                React__namespace.createElement("label", { className: "label" }, "\u5FC5\u9808\u30FB\u8868\u793A\u8A2D\u5B9A"),
                                React__namespace.createElement("div", { className: "control" },
                                    React__namespace.createElement("p", null, formSchema.resolveRequiredHiddenLabel(r.rule))))),
                            formSchema.isFunctionElement(targetElement) && (React__namespace.createElement("div", { className: "field" },
                                React__namespace.createElement("label", { className: "label" }, "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A"),
                                React__namespace.createElement("div", { className: "control" },
                                    React__namespace.createElement("p", null, r.rule.hidden ? "非表示" : "表示")))),
                            formSchema.isStaticElement(targetElement) && (React__namespace.createElement("div", { className: "field" },
                                React__namespace.createElement("label", { className: "label" }, "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A"),
                                React__namespace.createElement("div", { className: "control" },
                                    React__namespace.createElement("p", null, r.rule.hidden ? "非表示" : "表示")))),
                            formSchema.isRepeatableElement(targetElement) && (React__namespace.createElement("div", { className: "field" },
                                React__namespace.createElement("label", { className: "label" }, "\u5FC5\u9808\u30FB\u8868\u793A\u8A2D\u5B9A"),
                                React__namespace.createElement("div", { className: "control" },
                                    React__namespace.createElement("p", null, formSchema.resolveRequiredHiddenLabel(r.rule)))))))));
                    })))))));
};

var ConditionalRuleEditor = function (_a) {
    var attachingElement = _a.attachingElement, formSchema = _a.formSchema, rule = _a.rule, ruleIndex = _a.ruleIndex, onSave = _a.onSave, onClose = _a.onClose, _b = _a.viewMode, viewMode = _b === void 0 ? "EDITABLE" : _b;
    var validatorRegistry = useValidatoRegistry();
    var _c = React.useState(JSON.parse(JSON.stringify(rule))), currentRule = _c[0], setCurrentRule = _c[1];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "level", style: { marginBottom: 0 } },
            React__namespace.createElement("div", { className: "level-left" }),
            React__namespace.createElement("div", { className: "level-right" },
                React__namespace.createElement("div", { className: "level-item buttons" },
                    React__namespace.createElement("button", { className: "button is-outlined", onClick: onClose }, "\u9589\u3058\u308B"),
                    viewMode === "EDITABLE" && (React__namespace.createElement("button", { className: "button is-outlined", onClick: function () {
                            onSave(currentRule);
                        }, disabled: !validatorRegistry
                            .getConditionalRuleValidator(formSchema)
                            .checkRule(currentRule) }, "\u4FDD\u5B58"))))),
        React__namespace.createElement(ConditionalRuleEditorView, { editingElement: attachingElement, formSchema: formSchema, rule: currentRule, ruleIndex: ruleIndex, onUpdate: setCurrentRule, viewMode: viewMode })));
};

var ConditionalRuleEditors = function (_a) {
    var formSchema = _a.formSchema, editingElement = _a.editingElement, currentRule = _a.currentRule, ruleIndex = _a.ruleIndex, onRemove = _a.onRemove, onUpdate = _a.onUpdate, disableRemove = _a.disableRemove, thenDisplayFilter = _a.thenDisplayFilter;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "level mb-1", style: { marginBottom: 0 } },
            React__namespace.createElement("div", { className: "level-left" },
                React__namespace.createElement("p", { className: "title is-size-5" },
                    "\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A # ",
                    ruleIndex !== undefined ? ruleIndex + 1 : "")),
            React__namespace.createElement("div", { className: "level-right" },
                React__namespace.createElement("div", { className: "level-item buttons" }, currentRule.then.rules.length === 1 && (React__namespace.createElement("button", { className: "button is-outlined", onClick: onRemove, disabled: disableRemove }, "\u8A2D\u5B9A\u3092\u89E3\u9664\u3059\u308B"))))),
        React__namespace.createElement(ConditionalRuleEditorView, { editingElement: editingElement, formSchema: formSchema, rule: currentRule, onUpdate: onUpdate, thenDisplayFilter: thenDisplayFilter })));
};

function replaceElem(target, index, elem) {
    return target.map(function (v, idx) { return (idx === index ? elem : v); });
}

var TargetsCopyableEditor = function (_a) {
    var element = _a.element, schemaValidator = _a.schemaValidator, onElementUpdate = _a.onElementUpdate;
    var supportCopyValues = useFormEditorContext().supportCopyValues;
    var _b = React.useState(Array.isArray(element === null || element === void 0 ? void 0 : element.targetsCopyable)), isTargetsCopyable = _b[0], setIsTargetsCopyable = _b[1];
    var childElement = React.useMemo(function () {
        var result = element.baseUnit.map(function (v) {
            var _a;
            return ({
                id: v.id,
                labelText: v.label.text,
                isCopyValue: !!((_a = element.targetsCopyable) === null || _a === void 0 ? void 0 : _a.includes(v.id)),
                disabled: !formSchema.isCopyableChildElement(v),
            });
        });
        return result;
    }, [element]);
    var targetsCopyableElementId = React.useMemo(function () { return "targets-copyable-".concat(element.id); }, [element.id]);
    if (!supportCopyValues) {
        return null;
    }
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label", htmlFor: targetsCopyableElementId },
                "\u5165\u529B\u5185\u5BB9\u3092\u30B3\u30D4\u30FC\u3057\u305F\u7E70\u308A\u8FD4\u3057",
                React__namespace.createElement("span", { className: "help has-text-weight-normal" }, "\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u7533\u8ACB\u8005\u306F\u7E70\u308A\u8FD4\u3057\u5165\u529B\u3092\u884C\u3046\u969B\u3001\u76F4\u524D\u306E\u5165\u529B\u5185\u5BB9\u3092\u30B3\u30D4\u30FC\u3057\u3066\u5165\u529B\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002")),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("label", { className: "checkbox" },
                    React__namespace.createElement("input", { id: targetsCopyableElementId, type: "checkbox", checked: isTargetsCopyable, onChange: function (e) {
                            setIsTargetsCopyable(e.target.checked);
                            onElementUpdate(tslib.__assign(tslib.__assign({}, element), { targetsCopyable: e.target.checked ? [] : undefined }));
                        } }),
                    "\u5165\u529B\u5185\u5BB9\u3092\u30B3\u30D4\u30FC\u3057\u305F\u7E70\u308A\u8FD4\u3057\u3092\u6709\u52B9\u306B\u3059\u308B"))),
        isTargetsCopyable && (React__namespace.createElement("div", { className: "field ml-4" },
            React__namespace.createElement("label", { className: "label" }, "\u30B3\u30D4\u30FC\u306E\u5BFE\u8C61\u3068\u3059\u308B\u9805\u76EE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u30021\u3064\u4EE5\u4E0A\u9078\u629E\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"),
            React__namespace.createElement("div", { className: "control" }, childElement.length ? (childElement.map(function (v) {
                return (React__namespace.createElement("label", { key: v.id, className: "mb-1 is-inline-block pr-4", style: {
                        cursor: v.disabled ? "auto" : "pointer",
                    } },
                    React__namespace.createElement("input", { style: { marginRight: "0.25rem" }, type: "checkbox", value: v.id, checked: v.isCopyValue, disabled: v.disabled, onChange: function (event) {
                            var _a;
                            onElementUpdate(tslib.__assign(tslib.__assign({}, element), { targetsCopyable: tslib.__spreadArray(tslib.__spreadArray([], ((_a = element.targetsCopyable) !== null && _a !== void 0 ? _a : []), true), [
                                    v.id,
                                ], false).filter(function (id) { return event.target.checked || id !== v.id; }) }));
                        } }),
                    v.labelText));
            })) : (React__namespace.createElement("p", null, "\u30B3\u30D4\u30FC\u306E\u5BFE\u8C61\u3068\u3059\u308B\u9805\u76EE\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"))),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.targetsCopyable() })))));
};

var RepeatableEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = React.useState(new formSchema.RepeatableSchemaValidator(element)), schemaValidator = _b[0], setValidator = _b[1];
    React.useEffect(function () {
        setValidator(new formSchema.RepeatableSchemaValidator(element, "warn"));
    }, [element]);
    var labelId = "".concat(element.id, "-label");
    var descriptionId = "".concat(element.id, "-description");
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label", htmlFor: labelId }, "\u9805\u76EE\u540D"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { id: labelId, className: "input", type: "text", placeholder: "\u672A\u8A2D\u5B9A", value: element.label.text, onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { label: tslib.__assign(tslib.__assign({}, element.label), { text: e.target.value }) }));
                    } })),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.label() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("div", { className: "label is-flex is-justify-content-space-between is-align-items-baseline mb-0" },
                React__namespace.createElement("label", { className: "mb-2", htmlFor: descriptionId }, "\u8AAC\u660E\u6587"),
                element.description.isMarkdown && (React__namespace.createElement(HelpLink, { href: markdownHelpLink, label: "\u5165\u529B\u65B9\u6CD5\u3084\u30B5\u30F3\u30D7\u30EB\u306F\u3053\u3061\u3089" }))),
            React__namespace.createElement("div", { className: "control" }, element.description.isMarkdown ? (React__namespace.createElement(consoleDesignKit.MarkdownEditor, { value: element.description.text, layout: "standalone", allowedTagNames: formGenerator.grafferSchemasSuportTagNames, editAreaOptions: {
                    attributes: {
                        id: descriptionId,
                        placeholder: "未設定",
                        rows: 5,
                    },
                }, onChange: function (text) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { description: tslib.__assign(tslib.__assign({}, element.description), { text: text }) }));
                } })) : (React__namespace.createElement("textarea", { id: descriptionId, className: "textarea", rows: 2, placeholder: "\u672A\u8A2D\u5B9A", value: element.description.text, onChange: function (e) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { description: tslib.__assign(tslib.__assign({}, element.label), { text: e.target.value }) }));
                } }))),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.description() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5FC5\u9808\u30FB\u8868\u793A\u8A2D\u5B9A"),
            React__namespace.createElement(RequiredHiddenButtons, { element: element, onUpdate: function (e) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { required: e.required, hidden: e.hidden }));
                } })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u6700\u5C0F\u7E70\u308A\u8FD4\u3057\u56DE\u6570"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "number", value: element.minLength, onChange: function (e) {
                        var value = parseInt(e.target.value);
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { minLength: value }));
                    } })),
            React__namespace.createElement("p", { className: "help is-danger" },
                (!element.minLength || element.minLength < 1) &&
                    "1以上の値を設定してください",
                element.maxLength < element.minLength &&
                    "最大文字数以下の値を設定してください")),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u6700\u5927\u7E70\u308A\u8FD4\u3057\u56DE\u6570"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "number", value: element.maxLength, onChange: function (e) {
                        var value = parseInt(e.target.value);
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { maxLength: value }));
                    } })),
            React__namespace.createElement("p", { className: "help is-danger" },
                (!element.maxLength || element.maxLength < 1) &&
                    "1以上の値を設定してください",
                element.maxLength < element.minLength &&
                    "最小必要文字数以上の値を設定してください",
                schemaValidator.maxLength35())),
        React__namespace.createElement(TargetsCopyableEditor, { element: element, schemaValidator: schemaValidator, onElementUpdate: onElementUpdate })));
};

var FunctionElementCommonPropertiesEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u9805\u76EE\u540D"),
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("input", { className: "input", type: "text", value: element.label.text, onChange: function (_a) {
                        var value = _a.target.value;
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { label: {
                                text: value,
                                shouldDisplay: false,
                            } }));
                    } })),
            React__default["default"].createElement("p", { className: "help" }, "\u9805\u76EE\u540D\u306F\u5165\u529B\u753B\u9762\u3067\u306F\u8868\u793A\u3055\u308C\u307E\u305B\u3093")),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A"),
            React__default["default"].createElement(ShowHideButtons, { hidden: !!element.hidden, onSelectShow: function () {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { hidden: false }));
                }, onSelectHide: function () {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { hidden: true }));
                } }))));
};

var CorporateSearchElementEditor = function (_a) {
    var _b;
    var element = _a.element, onElementUpdate = _a.onElementUpdate, sections = _a.sections;
    var schemaValidator = useFunctionSchemaValidator(element, function (elem) { return new formSchema.CorporateSearchSchemaValidator(elem); });
    var sectionOptions = React.useMemo(function () {
        var currentSection = sections.find(function (section) {
            return section.children.some(function (child) { return child.id === element.id; });
        });
        if (!currentSection) {
            return [];
        }
        var elementIndex = currentSection.children.findIndex(function (child) { return child.id === element.id; });
        return currentSection.children.reduce(function (acc, elem, index) { return (index > elementIndex ? tslib.__spreadArray(tslib.__spreadArray([], acc, true), [elem], false) : acc); }, []);
    }, [sections, element]);
    var textInputOptions = React.useMemo(function () {
        return sectionOptions.reduce(function (acc, elem) {
            return formSchema.isInputElement(elem) && formSchema.isTextInputElement(elem) ? tslib.__spreadArray(tslib.__spreadArray([], acc, true), [elem], false) : acc;
        }, []);
    }, [sectionOptions]);
    var postalCodeOptions = React.useMemo(function () {
        return sectionOptions.reduce(function (acc, elem) {
            return formSchema.isInputElement(elem) && formSchema.isPostalCodeInputElement(elem)
                ? tslib.__spreadArray(tslib.__spreadArray([], acc, true), [elem], false) : acc;
        }, []);
    }, [sectionOptions]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(FunctionElementCommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement(consoleDesignKit.Select, { id: "".concat(element.id, "-corporateName"), label: "「法人名」を適用する項目", description: "", value: element.autocompleteTarget.corporateName, options: [{ name: "", value: "" }].concat(textInputOptions.map(function (opt) {
                    return {
                        name: opt.label.text,
                        value: opt.id,
                    };
                })), onChange: function (value) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { autocompleteTarget: tslib.__assign(tslib.__assign({}, element.autocompleteTarget), { corporateName: value || undefined }) }));
                } })),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement(consoleDesignKit.Select, { id: "".concat(element.id, "-corporateNumber"), label: "「法人番号」を適用する項目", description: "", value: element.autocompleteTarget.corporateNumber, options: [{ name: "", value: "" }].concat(textInputOptions.map(function (opt) {
                    return {
                        name: opt.label.text,
                        value: opt.id,
                    };
                })), onChange: function (value) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { autocompleteTarget: tslib.__assign(tslib.__assign({}, element.autocompleteTarget), { corporateNumber: value || undefined }) }));
                } })),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement(consoleDesignKit.Select, { id: "".concat(element.id, "-corporatePostalCode"), label: "「郵便番号」を適用する項目", description: "", value: element.autocompleteTarget.corporatePostalCode, options: [{ name: "", value: "" }].concat(postalCodeOptions.map(function (opt) {
                    return {
                        name: opt.label.text,
                        value: opt.id,
                    };
                })), onChange: function (value) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { autocompleteTarget: tslib.__assign(tslib.__assign({}, element.autocompleteTarget), { corporatePostalCode: value || undefined }) }));
                } })),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement(consoleDesignKit.Select, { id: "".concat(element.id, "-corporateAddress"), label: "「住所」を適用する項目", description: "", value: element.autocompleteTarget.corporateAddress, options: [{ name: "", value: "" }].concat(textInputOptions.map(function (opt) {
                    return {
                        name: opt.label.text,
                        value: opt.id,
                    };
                })), onChange: function (value) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { autocompleteTarget: tslib.__assign(tslib.__assign({}, element.autocompleteTarget), { corporateAddress: value || undefined }) }));
                } })), (_b = schemaValidator
        .validate()) === null || _b === void 0 ? void 0 :
        _b.map(function (msg, idx) { return (React__default["default"].createElement(ErrorMessage$1, { key: "corporateSearch-errorMsg-".concat(idx), msg: msg })); })));
};

var FunctionElementEditor = function (_a) {
    var _b;
    var element = _a.element, onElementUpdate = _a.onElementUpdate, isDuplicateId = _a.isDuplicateId, allowCustomElemId = _a.allowCustomElemId, sections = _a.sections;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        allowCustomElemId && (React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "ElementID"),
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("input", { className: "input", type: "text", placeholder: "", value: element.id, onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { id: e.target.value }));
                    } })),
            isDuplicateId && (React__default["default"].createElement("p", { className: "help is-danger" }, "ID\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059")))),
        new formSchema.FunctionElementState(element.functionType).matchType((_b = {},
            _b[formSchema.FunctionTypes.CorporateSearch] = (React__default["default"].createElement(CorporateSearchElementEditor, { element: element, onElementUpdate: onElementUpdate, sections: sections })),
            _b))));
};

var ErrorMessage = function (_a) {
    var msg = _a.msg;
    return msg ? React__namespace.createElement("p", { className: "help is-danger" }, msg) : null;
};

var StaticElementCommonPropertiesEditor = function (_a) {
    var _b;
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var schemaValidator = useStaticSchemaValidator(element, function (elem) {
        return formSchema.getStaticElementSchemaValidator(elem, "warn");
    });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u9805\u76EE\u540D"),
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("input", { className: "input", type: "text", value: element.label.text, onChange: function (_a) {
                        var value = _a.target.value;
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { label: tslib.__assign(tslib.__assign({}, element.label), { text: value }) }));
                    } })),
            React__default["default"].createElement(React__default["default"].Fragment, null, new formSchema.StaticElementState(element.staticType).matchType((_b = {},
                _b[formSchema.StaticTypes.Description] = (React__default["default"].createElement("p", { className: "help" }, "\u9805\u76EE\u540D\u306F\u5165\u529B\u753B\u9762\u3067\u306F\u8868\u793A\u3055\u308C\u307E\u305B\u3093")),
                _b[formSchema.StaticTypes.Image] = null,
                _b))),
            React__default["default"].createElement(ErrorMessage, { msg: schemaValidator.label() })),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u8868\u793A\u30FB\u975E\u8868\u793A\u8A2D\u5B9A"),
            React__default["default"].createElement(ShowHideButtons, { hidden: !!element.hidden, onSelectShow: function () {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { hidden: false }));
                }, onSelectHide: function () {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { hidden: true }));
                } }))));
};

var DescriptionElementEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var descriptionId = "".concat(element.id, "-description");
    var schemaValidator = useStaticSchemaValidator(element, function (elem) { return new formSchema.DescriptionSchemaValidator(elem, "warn"); });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StaticElementCommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("div", { className: "label is-flex is-justify-content-space-between is-align-items-baseline mb-0" },
                React__default["default"].createElement("label", { className: "mb-2", htmlFor: descriptionId }, "\u8AAC\u660E\u6587"),
                element.isMarkdown && (React__default["default"].createElement(HelpLink, { href: markdownHelpLink, label: "\u5165\u529B\u65B9\u6CD5\u3084\u30B5\u30F3\u30D7\u30EB\u306F\u3053\u3061\u3089" }))),
            React__default["default"].createElement("div", { className: "control" }, element.isMarkdown ? (React__default["default"].createElement(consoleDesignKit.MarkdownEditor, { value: element.text, layout: "standalone", allowedTagNames: formGenerator.grafferSchemasSuportTagNames, editAreaOptions: {
                    attributes: {
                        id: descriptionId,
                        placeholder: "未設定",
                        rows: 5,
                    },
                }, onChange: function (text) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { text: text }));
                } })) : (React__default["default"].createElement("textarea", { id: descriptionId, className: "textarea", rows: 2, placeholder: "\u672A\u8A2D\u5B9A", value: element.text, onChange: function (e) {
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { text: e.target.value }));
                } }))),
            React__default["default"].createElement(ErrorMessage, { msg: schemaValidator.text() }))));
};

var useImageElementEditorHooks = function (element, onElementUpdate) {
    var _a = React.useState(), file = _a[0], setFile = _a[1];
    var _b = React.useState(undefined), fieldError = _b[0], setFieldError = _b[1];
    var imageRefkeyExchanger = useImageRefkeyExchanger();
    React.useEffect(function () {
        if (element.refKey) {
            imageRefkeyExchanger.refkeyToValue(element.refKey).then(function (v) {
                var blob = new Blob([v.uri], { type: v.mimeType });
                setFile(new File([blob], v.name, { type: v.mimeType }));
            });
        }
        else {
            setFile(undefined);
        }
    }, [element, imageRefkeyExchanger]);
    var onSetFile = React__default["default"].useCallback(function (file) { return tslib.__awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, imageRefkeyExchanger
                            .valueToRefkey(file, element.refKey)
                            .then(function (refKey) {
                            onElementUpdate(tslib.__assign(tslib.__assign({}, element), { refKey: refKey, name: file.name, size: file.size, mimeType: file.type }));
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setFieldError(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [element, imageRefkeyExchanger, onElementUpdate]);
    var onDeleteFile = React.useCallback(function () {
        imageRefkeyExchanger.clearRefKey(element.refKey);
        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { refKey: "", name: "", size: 0, altText: "", mimeType: "" }));
    }, [element, onElementUpdate, imageRefkeyExchanger]);
    return {
        file: file,
        fieldError: fieldError,
        onSetFile: onSetFile,
        onDeleteFile: onDeleteFile,
    };
};

var ImageElementEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var imageId = "".concat(element.id, "-image");
    var _b = useImageElementEditorHooks(element, onElementUpdate), file = _b.file, fieldError = _b.fieldError, onSetFile = _b.onSetFile, onDeleteFile = _b.onDeleteFile;
    var schemaValidator = useStaticSchemaValidator(element, function (elem) { return new formSchema.ImageSchemaValidator(elem, "warn"); });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StaticElementCommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement(consoleDesignKit.SingleFileUploader, { value: file, acceptFileType: tslib.__spreadArray([], formSchema.ImageMimeTypeList, true), setFile: onSetFile, deleteFile: onDeleteFile, id: imageId, description: "", label: "\u753B\u50CF\u30D5\u30A1\u30A4\u30EB", errorMessages: fieldError })),
            React__default["default"].createElement(ErrorMessage, { msg: schemaValidator.imageSrc() })),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label", htmlFor: "".concat(element.id, "-image-alt") }, "\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8"),
            React__default["default"].createElement("p", { className: "mb-2" }, "\u753B\u50CF\u304C\u8AAD\u307F\u8FBC\u3081\u306A\u3044\u5834\u5408\u3084\u753B\u50CF\u3092\u8868\u793A\u3067\u304D\u306A\u3044\u5834\u5408\u306B\u63D0\u4F9B\u3055\u308C\u308B\u30C6\u30AD\u30B9\u30C8\u3067\u3059\u3002\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8\u306F\u8996\u899A\u969C\u5BB3\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306B\u3068\u3063\u3066\u91CD\u8981\u3067\u3042\u308A\u3001\u753B\u50CF\u306E\u5185\u5BB9\u3084\u610F\u5473\u3092\u4F1D\u3048\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"),
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("input", { id: "".concat(element.id, "-image-alt"), className: "input", type: "text", placeholder: "", value: element.altText, onChange: function (e) {
                        return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { altText: e.target.value }));
                    } })),
            React__default["default"].createElement(ErrorMessage, { msg: schemaValidator.altText() }))));
};

var StaticElementEditor = function (_a) {
    var _b;
    var element = _a.element, onElementUpdate = _a.onElementUpdate, isDuplicateId = _a.isDuplicateId, allowCustomElemId = _a.allowCustomElemId;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        allowCustomElemId && (React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "ElementID"),
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("input", { className: "input", type: "text", placeholder: "", value: element.id, onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { id: e.target.value }));
                    } })),
            isDuplicateId && (React__default["default"].createElement("p", { className: "help is-danger" }, "ID\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059")))),
        new formSchema.StaticElementState(element.staticType).matchType((_b = {},
            _b[formSchema.StaticTypes.Description] = (React__default["default"].createElement(DescriptionElementEditor, { element: element, onElementUpdate: onElementUpdate })),
            _b[formSchema.StaticTypes.Image] = (React__default["default"].createElement(ImageElementEditor, { element: element, onElementUpdate: onElementUpdate })),
            _b))));
};

/**
 * 選択式要素の場合は管理コード（optionのvalue）の更新に合わせて条件分岐ルールを更新するメソッド
 * @param conditionalRules 条件分岐ルール
 * @param newElement 更新後の要素
 * @param prevElement 更新前の要素
 * @returns 更新後の条件分岐ルール
 */
var getReplacedConditionalRules = function (conditionalRules, newElement, prevElement) {
    // 参照元のオブジェクトに変更が生じると意図せぬバリデーションエラーを引き起こすため、
    // 置換用のオブジェクトをディープコピーで作成する
    var copiedConditionalRules = JSON.parse(JSON.stringify(conditionalRules));
    return copiedConditionalRules.map(function (cr) {
        var newConditionalRule = tslib.__assign({}, cr);
        newConditionalRule.rule.if.conditions = cr.rule.if.conditions.map(function (cond) {
            return getReplacedCondition(cond, newElement, prevElement);
        });
        return newConditionalRule;
    });
};
var getReplacedCondition = function (condition, newElement, prevElement) {
    if (prevElement.id !== newElement.id) {
        throw new Error("element ids are not match between prevElement and newElement");
    }
    if (condition.id !== prevElement.id) {
        return condition;
    }
    // 更新前の条件をキーに更新前のoptionを取得
    var prevOption = prevElement.enum.find(function (e) { return e.value === condition.match.const; });
    if (!prevOption) {
        return condition;
    }
    // 更新前のoptionのtextと同じtextのoptionを更新後の要素から取得
    var newOption = newElement.enum.find(function (e) { return e.text === prevOption.text; });
    if (!newOption) {
        return condition;
    }
    // 更新後のoptionのvalueで置換
    return tslib.__assign(tslib.__assign({}, condition), { match: tslib.__assign(tslib.__assign({}, condition.match), { const: newOption.value }) });
};

var ElementRulesEditorView = function (_a) {
    var schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, editState = _a.editState, onStateUpdate = _a.onStateUpdate, isElementDirty = _a.isElementDirty, insertRuleIndex = _a.insertRuleIndex;
    var _b = useFormEditorContext(), allowCustomElemId = _b.allowCustomElemId, disableConditionalRules = _b.disableConditionalRules;
    var allIdExcludeTarget = schemaBuilder.formSchemaConverter
        .allIds()
        .filter(function (id) { return id !== editState.element.id; });
    var isDuplicateId = tslib.__spreadArray(tslib.__spreadArray([], allIdExcludeTarget, true), [editState.element.id], false).filter(function (id, index) {
        return tslib.__spreadArray(tslib.__spreadArray([], allIdExcludeTarget, true), [editState.element.id], false).indexOf(id) !== index;
    }).length !== 0;
    var _c = useAddingState(), addingState = _c.addingState, setAddingState = _c.setAddingState, finishAddingState = _c.finishAddingState;
    var onElementUpdate = React__namespace.useCallback(function (e) {
        if (!formSchema.isSelectableElement(e)) {
            onStateUpdate(tslib.__assign(tslib.__assign({}, editState), { element: e }));
            return;
        }
        if (!(formSchema.isInputElement(editState.element) &&
            formSchema.isSelectableElement(editState.element))) {
            throw new Error("element types are not match between editState and e");
        }
        onStateUpdate(tslib.__assign(tslib.__assign({}, editState), { element: e, conditionalRules: getReplacedConditionalRules(editState.conditionalRules, e, editState.element) }));
    }, [editState, onStateUpdate]);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "px-3 py-3" },
            formSchema.isInputElement(editState.element) && (React__namespace.createElement(ElementEditorView, { isDuplicateId: isDuplicateId, currentRawSchema: schemaBuilder.currentRawSchema, allowCustomElemId: allowCustomElemId, element: editState.element, onElementUpdate: onElementUpdate, attachedFormulas: 
                // MEMO kaneda : 現時点の用途は選択式要素の注釈バナー表示のためだけ。計算量削減のためその他要素ではundefinedを渡す。
                formSchema.isSelectableElement(editState.element)
                    ? schemaBuilder.formulaSetConverter.getAttachedFormula(editState.element.id)
                    : undefined })),
            formSchema.isRepeatableElement(editState.element) && (React__namespace.createElement(RepeatableEditor, { element: editState.element, onElementUpdate: function (e) {
                    onStateUpdate(tslib.__assign(tslib.__assign({}, editState), { element: e }));
                } })),
            formSchema.isFunctionElement(editState.element) && (React__namespace.createElement(FunctionElementEditor, { element: editState.element, onElementUpdate: function (e) {
                    onStateUpdate(tslib.__assign(tslib.__assign({}, editState), { element: e }));
                }, isDuplicateId: isDuplicateId, allowCustomElemId: allowCustomElemId, sections: schemaBuilder.currentRawSchema.root })),
            formSchema.isStaticElement(editState.element) && (React__namespace.createElement(StaticElementEditor, { element: editState.element, onElementUpdate: function (e) {
                    onStateUpdate(tslib.__assign(tslib.__assign({}, editState), { element: e }));
                }, isDuplicateId: isDuplicateId, allowCustomElemId: allowCustomElemId }))),
        !disableConditionalRules && (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement("hr", null),
            editState.conditionalRules.length > 0 &&
                editState.conditionalRules.map(function (target, idx) { return (React__namespace.createElement("div", { key: JSON.stringify(target) + idx.toString() },
                    React__namespace.createElement(ConditionalRuleEditors, { editingElement: editState.element, formSchema: schemaBuilder.currentRawSchema, currentRule: target.rule, ruleIndex: target.index, disableRemove: isElementDirty(editState.element), onUpdate: function (newRule) {
                            onStateUpdate(tslib.__assign(tslib.__assign({}, editState), { conditionalRules: replaceElem(editState.conditionalRules, idx, tslib.__assign(tslib.__assign({}, target), { rule: newRule })) }));
                        }, onRemove: function () {
                            setNewBuilder(schemaBuilder.removeRuleByIndex(target.index));
                        } }))); }),
            editState.conditionalRules.length > 0 && (React__namespace.createElement("div", { className: "mt-2" },
                React__namespace.createElement("button", { className: "button is-fullwidth", disabled: isElementDirty(editState.element) ||
                        schemaBuilder.conditionalRuleConverter
                            .conditionalRuleMap()
                            .hasIfRule(editState.element.id), onClick: function () {
                        setAddingState({
                            state: formSchema.ConditionalFactory.creatRuleFor(editState.element),
                        });
                    } }, "\u8FFD\u52A0\u3059\u308B"))),
            React__namespace.createElement("hr", null),
            editState.conditionalRules.length === 0 && (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement("div", { style: {
                        border: "1px solid lightgrey",
                    } },
                    React__namespace.createElement("div", { className: "columns is-centered is-vcentered has-text-centered pt-6 pb-6" },
                        React__namespace.createElement("div", { className: "column pt-6 pb-4" },
                            React__namespace.createElement("p", { className: "has-text-centered has-text-weight-bold mb-2" },
                                editState.element.label.text,
                                "\u306B\u306F\u3001\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A\u306F\u3042\u308A\u307E\u305B\u3093"),
                            React__namespace.createElement("button", { className: "button", disabled: isElementDirty(editState.element), onClick: function () {
                                    setAddingState({
                                        state: formSchema.ConditionalFactory.creatRuleFor(editState.element),
                                    });
                                } }, "\u8FFD\u52A0\u3059\u308B")))))),
            addingState && (React__namespace.createElement("div", { className: "modal is-active" },
                React__namespace.createElement("div", { className: "modal-background" }),
                React__namespace.createElement("section", { className: "modal-content box" },
                    React__namespace.createElement(ConditionalRuleEditor, { formSchema: schemaBuilder.currentRawSchema, attachingElement: editState.element, rule: addingState.state, onSave: function (r) {
                            if (insertRuleIndex !== undefined) {
                                setNewBuilder(schemaBuilder.insertRule(r, insertRuleIndex));
                            }
                            else {
                                setNewBuilder(schemaBuilder.addRule(r));
                            }
                            finishAddingState();
                        }, onClose: finishAddingState }))))))));
};

var DefaultEditorRegistry = new (/** @class */ (function () {
    function class_1() {
    }
    class_1.prototype.getBuilderFieldTemplate = function (_elem, _parent) {
        return undefined;
    };
    class_1.prototype.getElementEditor = function (_elem, _parent) {
        return ElementRulesEditorView;
    };
    class_1.prototype.getDropdownMenuContent = function () {
        return undefined;
    };
    return class_1;
}()))();

var DefaultValidatorRegistry = new (/** @class */ (function () {
    function class_1() {
    }
    class_1.prototype.getConditionalRuleValidator = function (formSchema$1) {
        return new formSchema.ConditionalRuleValidator(formSchema$1);
    };
    return class_1;
}()))();

var defaultFormEditorMarkdownConfig = {
    initialValueForCommonProperties: false,
    initialValueForStaticDescription: false,
    showMarkdownApplyBanner: false,
    markdownProcessor: function () {
        console.log("default markdown processor does not process markdown");
        return null;
    },
};
var FormEditorContext = React__namespace.createContext({
    toolbarItemList: DefaultToolbarItemList,
    editConfigRegistry: DefaultElementConfigRegistry,
    editorRegistry: DefaultEditorRegistry,
    validatorRegistry: DefaultValidatorRegistry,
    thenInputFilter: function () { return true; },
});
var FormEditorInnerWrapper = function (props) { return (React__namespace.createElement(reactDnd.DndProvider, { backend: reactDndHtml5Backend.HTML5Backend },
    React__namespace.createElement(FormEditorContext.Provider, { value: {
            allowCustomElemId: props.allowCustomElemId,
            supportMyNumberInput: props.supportMyNumberInput,
            supportFileInput: props.supportFileInput,
            supportInitialDateInput: props.supportInitialDateInput,
            supportFormula: props.supportFormula,
            formulaViewMode: props.formulaViewMode,
            supportFormulaResult: props.supportFormulaResult,
            supportYearMonthInput: props.supportYearMonthInput,
            supportAllowedTermValidationForDateInput: props.supportAllowedTermValidationForDateInput,
            supportSwitchEditorModeForSelectableInput: props.supportSwitchEditorModeForSelectableInput,
            disableConditionalRules: props.disableConditionalRules,
            conditionalRuleViewMode: props.conditionalRuleViewMode,
            toolbarItemList: props.toolbarItemList,
            editConfigRegistry: props.editConfigRegistry,
            editorRegistry: props.editorRegistry,
            validatorRegistry: props.validatorRegistry,
            thenInputFilter: props.thenInputFilter,
            shouldHide: props.shouldHide,
            insertRuleIndex: props.insertRuleIndex,
            supportCopyValues: props.supportCopyValues,
            supportPostalCode: props.supportPostalCode,
            supportCorporateSearch: props.supportCorporateSearch,
            supportDescription: props.supportDescription,
            supportImage: props.supportImage,
            imageRefkeyExchanger: props.imageRefkeyExchanger,
            supportSuffix: props.supportSuffix,
            markdownConfig: props.markdownConfig,
        } },
        React__namespace.createElement(formGenerator.FormContext.Provider, { value: {
                refKeyContext: {
                    fileRefKeyExchanger: new formSchema.OnMemoryArrayFileRefKeyExchanger(),
                    myNumberRefKeyExchanger: new formSchema.OnMemoryMyNumberRefkeyExchanger(),
                    imageRefkeyExchanger: props.imageRefkeyExchanger,
                },
                confirmContext: {},
                modificationContext: {},
                submissionContext: {
                    // フォームをGUIで edit するという観点に立つと、
                    // 「現時点」が基準になっていることがいったん自然と考えられる。
                    // リッチなプレビュー機能などがサポートされた暁には、
                    // こういった値を画面からも設定してプレビューできる
                    // ようになることが望ましい。
                    submissionDate: new Date(),
                },
                markdownConfig: props.markdownConfig,
            } }, props.children)))); };
function useFormEditorContext() {
    return React.useContext(FormEditorContext);
}
function useEditConfig(elem, parent) {
    var editConfigRegistry = useEditConfigRegistry();
    return editConfigRegistry.get(elem, parent);
}
function useEditConfigRegistry() {
    var editConfigRegistry = useFormEditorContext().editConfigRegistry;
    return editConfigRegistry;
}
function useEditorRegistry() {
    var editorRegistry = useFormEditorContext().editorRegistry;
    return editorRegistry;
}
function useValidatoRegistry() {
    var validatorRegistry = useFormEditorContext().validatorRegistry;
    return validatorRegistry;
}
function useImageRefkeyExchanger() {
    var imageRefkeyExchanger = useFormEditorContext().imageRefkeyExchanger;
    if (!imageRefkeyExchanger) {
        throw new Error("imageRefKeyExchanger must be provided for image element.");
    }
    return imageRefkeyExchanger;
}
function useMarkdownConfig() {
    var markdownConfig = useFormEditorContext().markdownConfig;
    return markdownConfig !== null && markdownConfig !== void 0 ? markdownConfig : defaultFormEditorMarkdownConfig;
}

function useValidationSettingField(validation) {
    var _a = React.useState(false), isOn = _a[0], setIsOn = _a[1];
    return {
        isOn: isOn || !!validation,
        setOn: function () { return setIsOn(true); },
        setOff: function () { return setIsOn(false); },
    };
}

var MaxCharacters = function (_a) {
    var _b;
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessage = _a.errMessage, cellSize = _a.cellSize;
    var _c = useValidationSettingField(schema), isOn = _c.isOn, setOn = _c.setOn, setOff = _c.setOff;
    return (React__namespace.createElement(ToggleField, { label: "\u6700\u5927\u6587\u5B57\u6570", isOn: isOn, setOn: setOn, setOff: function () {
            remove("maxLength");
            setOff();
        }, disabled: !!cellSize },
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("input", { className: "input", type: "number", placeholder: "1...", value: (_b = schema === null || schema === void 0 ? void 0 : schema.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                    if (e.target.value) {
                        upsert({
                            keyword: "maxLength",
                            value: parseInt(e.target.value, 10),
                        });
                    }
                    else {
                        // TextCellの場合は、maxLength validationは必須なためremoveさせない
                        if (!cellSize) {
                            remove("maxLength");
                        }
                    }
                }, max: (cellSize && cellSize.horizontal * cellSize.vertical) || undefined })),
        cellSize && (React__namespace.createElement("p", { className: "help is-info" }, "\u30C6\u30AD\u30B9\u30C8\u30BB\u30EB\u30B5\u30A4\u30BA\u4EE5\u4E0B\u306E\u6700\u5927\u6587\u5B57\u6570\u30D0\u30EA\u30C7\u30FC\u30B7\u30E7\u30F3\u304C\u5FC5\u9808\u3067\u3059")),
        React__namespace.createElement(ErrorMessage$1, { msg: errMessage })));
};

var validationHelperV2 = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var removeValidation = function (keyword) {
        var vs = element.validations;
        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { validations: vs.filter(function (v) { return v.keyword !== keyword; }) }));
    };
    var upsertValidation = function (newValue) {
        var vs = element.validations;
        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { validations: tslib.__spreadArray(tslib.__spreadArray([], vs.filter(function (v) { return v.keyword !== newValue.keyword; }), true), [
                newValue,
            ], false) }));
    };
    return {
        removeValidation: removeValidation,
        upsertValidation: upsertValidation,
    };
};

var MinCharacters = function (_a) {
    var _b;
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessage = _a.errMessage;
    var _c = useValidationSettingField(schema), isOn = _c.isOn, setOn = _c.setOn, setOff = _c.setOff;
    return (React__namespace.createElement(ToggleField, { label: "\u6700\u5C0F\u6587\u5B57\u6570", isOn: isOn, setOn: setOn, setOff: function () {
            remove("minLength");
            setOff();
        } },
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("input", { className: "input", type: "number", placeholder: "1...", value: (_b = schema === null || schema === void 0 ? void 0 : schema.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                    if (e.target.value) {
                        upsert({
                            keyword: "minLength",
                            value: parseInt(e.target.value, 10),
                        });
                    }
                    else {
                        remove("minLength");
                    }
                } })),
        React__namespace.createElement(ErrorMessage$1, { msg: errMessage })));
};

var AllowedCharacters = function (_a) {
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessage = _a.errMessage;
    var _b = useValidationSettingField(schema), isOn = _b.isOn, setOn = _b.setOn, setOff = _b.setOff;
    return (React__namespace.createElement(ToggleField, { label: "\u8A31\u5BB9\u6587\u5B57\u7A2E", isOn: isOn, setOn: setOn, setOff: function () {
            remove("allowedCharacters");
            setOff();
        } },
        React__namespace.createElement("div", { className: "control" }, new Array("alphabet", "numeric", "hiragana", "katakana", "half_width_space", "full_width_space").map(function (s) {
            return (React__namespace.createElement("label", { key: s, className: "checkbox" },
                React__namespace.createElement("input", { type: "checkbox", checked: !!schema &&
                        formSchema.isAllowedCharactersValidation(schema) &&
                        schema.value.indexOf(s) !== -1, onChange: function () {
                        if (schema) {
                            upsert({
                                keyword: "allowedCharacters",
                                value: schema.value.indexOf(s) !== -1
                                    ? schema.value.filter(function (k) { return k !== s; })
                                    : tslib.__spreadArray(tslib.__spreadArray([], schema.value, true), [s], false),
                            });
                        }
                        else {
                            upsert({
                                keyword: "allowedCharacters",
                                value: [s],
                            });
                        }
                    } }),
                new formSchema.CharTypesMatcherState(s).matchType({
                    alphabet: "アルファベット",
                    hiragana: "ひらがな",
                    katakana: "カタカナ",
                    numeric: "数字",
                    half_width_space: "半角スペース",
                    full_width_space: "全角スペース",
                })));
        })),
        React__namespace.createElement(ErrorMessage$1, { msg: errMessage })));
};

var Regexp = function (_a) {
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessage = _a.errMessage;
    var _b = useValidationSettingField(schema), isOn = _b.isOn, setOn = _b.setOn, setOff = _b.setOff;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(ToggleField, { label: "\u6B63\u898F\u8868\u73FE", isOn: isOn, setOn: setOn, setOff: function () {
                remove("regexp");
                setOff();
            } },
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "text", placeholder: "/(?:)/", value: (schema === null || schema === void 0 ? void 0 : schema.value) || "", onChange: function (e) {
                        upsert({
                            keyword: "regexp",
                            value: e.target.value,
                        });
                    } })),
            React__namespace.createElement(ErrorMessage$1, { msg: errMessage })),
        React__namespace.createElement("div", { className: "is-flex is-align-items-center" },
            "\u6B63\u898F\u8868\u73FE\u306B\u3064\u3044\u3066\u306F\u3001",
            React__namespace.createElement(consoleDesignKit.ExternalLink, { anchor: function (_a) {
                    var children = _a.children, props = tslib.__rest(_a, ["children"]);
                    return (React__namespace.createElement("a", tslib.__assign({}, props, { href: "/help/contents/regularexpression" }), children));
                }, icon: "OpenInNewIcon" }, "\u6B63\u898F\u8868\u73FE\u4E00\u89A7"),
            "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002")));
};

var TextInputValidationEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = validationHelperV2({
        element: element,
        onElementUpdate: onElementUpdate,
    }), upsertValidation = _b.upsertValidation, removeValidation = _b.removeValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.TextInputSchemaValidator(elem); });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("hr", null),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5165\u529B\u898F\u5247\u8A2D\u5B9A"),
            React__namespace.createElement(MaxCharacters, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "maxLength"; }), errMessage: schemaValidator.maxValidation() ||
                    schemaValidator.minMax() ||
                    schemaValidator.cellSize(), cellSize: (element.pdfAdapterRule &&
                    formSchema.isTextCellAdapterRule(element.pdfAdapterRule) &&
                    element.pdfAdapterRule.cellSize) ||
                    undefined }),
            React__namespace.createElement(MinCharacters, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "minLength"; }), errMessage: schemaValidator.minValidation() || schemaValidator.minMax() }),
            React__namespace.createElement(AllowedCharacters, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "allowedCharacters"; }) }),
            React__namespace.createElement(Regexp, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "regexp"; }), errMessage: schemaValidator.regexpValidation() }))));
};

var TextInputEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate, hideValidation = _a.hideValidation;
    var supportInitialDateInput = React.useContext(FormEditorContext).supportInitialDateInput;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.TextInputSchemaValidator(elem); });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u30D7\u30EC\u30FC\u30B9\u30DB\u30EB\u30C0\u30FC"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "text", placeholder: element.placeholder, value: element.placeholder, onChange: function (e) {
                        return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { placeholder: e.target.value }));
                    } }),
                React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.placeholder() }))),
        React__namespace.createElement(InitialValueComponent, { element: element, onElementUpdate: function (e) {
                onElementUpdate(tslib.__assign({}, e));
            }, computedInitialValuesName: supportInitialDateInput ? ["date"] : [] }),
        React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.initialValue() }),
        !hideValidation && (React__namespace.createElement(TextInputValidationEditor, { element: element, onElementUpdate: onElementUpdate }))));
};

var TextAreaValidationEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = validationHelperV2({
        element: element,
        onElementUpdate: onElementUpdate,
    }), upsertValidation = _b.upsertValidation, removeValidation = _b.removeValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.TextAreaSchemaValidator(elem); });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5165\u529B\u898F\u5247\u8A2D\u5B9A"),
            React__namespace.createElement(MaxCharacters, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "maxLength"; }), errMessage: schemaValidator.maxValidation() || schemaValidator.minMax() }),
            React__namespace.createElement(MinCharacters, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "minLength"; }), errMessage: schemaValidator.minValidation() || schemaValidator.minMax() }))));
};

var TextAreaEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate, hideValidation = _a.hideValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.TextAreaSchemaValidator(elem); });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u30D7\u30EC\u30FC\u30B9\u30DB\u30EB\u30C0\u30FC"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "text", placeholder: element.placeholder, value: element.placeholder, onChange: function (e) {
                        return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { placeholder: e.target.value }));
                    } })),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.placeholder() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5165\u529B\u6B04\u306E\u884C\u6570"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "number", value: element.rows, onChange: function (e) {
                        var value = parseInt(e.target.value);
                        if (value < 1) {
                            alert("1以上の値を設定してください");
                        }
                        else {
                            onElementUpdate(tslib.__assign(tslib.__assign({}, element), { rows: value }));
                        }
                    } })),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.rows() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement(InitialValueComponent, { onElementUpdate: onElementUpdate, element: element })),
        React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.initialValue() }),
        !hideValidation && (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(TextAreaValidationEditor, { onElementUpdate: onElementUpdate, element: element })))));
};

var OptionsSeparator = "\n";
var LabelValueSeparator = "\t";
/*
 * selectable elementの選択肢をテキストエリアの入力フォームで設定する際に使用するhook
 * @param element 編集しようとしているelement
 * @param onElementUpdate elementのstateを更新するための関数
 * */
var useOptionsTextareaEditor = function (element, onElementUpdate) {
    var _a = React.useState(element.enum
        .map(function (_a) {
        var text = _a.text, value = _a.value;
        if (text === value) {
            return text;
        }
        return text + LabelValueSeparator + value;
    })
        .join("\n")), editorInput = _a[0], setEditorInput = _a[1];
    var handleOnChangeTextarea = function (formInput) {
        setEditorInput(formInput);
        var newEnum = newEnumsForTextareaEditor(formInput);
        var newElement = newSelectableElement(element, newEnum);
        onElementUpdate(newElement);
    };
    return {
        editorInput: editorInput,
        handleOnChangeTextarea: handleOnChangeTextarea,
    };
};

var newSelectableElement = function (element, newEnumValue) {
    return formSchema.isCheckboxesElement(element)
        ? tslib.__assign(tslib.__assign({}, element), { enum: newEnumValue, maxItems: newEnumValue.length }) : tslib.__assign(tslib.__assign({}, element), { enum: newEnumValue });
};
var newEnumsForTextareaEditor = function (formInput) {
    var lines = formInput.split(OptionsSeparator);
    return lines
        .filter(function (line) { return line.trim() !== ""; })
        .map(function (line) {
        var words = line.split(LabelValueSeparator);
        // タブ区切りでの入力がされていない場合はtext、valueともに同じ値を設定する
        if (words.length === 1) {
            return {
                text: words[0],
                value: words[0],
            };
        }
        return {
            text: words[0],
            value: words.slice(1).join(""), // 複数タブ区切りされている場合は、最初のタブ以降の文字列を一つの文字列としてvalueに設定する
        };
    });
};
var newOnlineEditorInput = function () {
    return {
        text: "",
        value: "",
        displayValue: "",
        displayOnly: true,
    };
};
var newEnumsForOnelineEditor = function (editorInputs) {
    return editorInputs
        .filter(function (_a) {
        var displayOnly = _a.displayOnly;
        return !displayOnly;
    })
        .map(function (_a) {
        var text = _a.text, value = _a.value;
        return ({ text: text, value: value });
    });
};
var newInputsChangeForOnelineEditor = function (target) {
    switch (target) {
        case "text":
            return newInputsByTextChangeForOnelineEditor;
        case "value":
            return newInputsByValueChangeForOnelineEditor;
        default:
            throw new Error("invalid target");
    }
};
var newInputsByTextChangeForOnelineEditor = function (editorInputs, textInput, formTargetIndex) {
    return editorInputs.map(function (input, i) {
        if (i !== formTargetIndex) {
            return input;
        }
        if (textInput === "") {
            return newOnlineEditorInput();
        }
        if (input.value === "") {
            return tslib.__assign(tslib.__assign({}, input), { text: textInput, value: textInput, displayOnly: false });
        }
        return tslib.__assign(tslib.__assign({}, input), { text: textInput, displayOnly: false });
    });
};
var newInputsByValueChangeForOnelineEditor = function (editorInputs, valueInput, formTargetIndex) {
    return editorInputs.map(function (input, i) {
        if (i !== formTargetIndex) {
            return input;
        }
        if (valueInput === "") {
            return tslib.__assign(tslib.__assign({}, input), { value: input.text, displayValue: "" });
        }
        return tslib.__assign(tslib.__assign({}, input), { value: valueInput, displayValue: valueInput });
    });
};

/*
 * selectable elementの選択肢を一行入力フォームで設定する際に使用するhooks
 * @param element 編集しようとしているelement
 * @param onElementUpdate elementのstateを更新するための関数
 * */
var useOptionsOnelineEditor = function (element, onElementUpdate) {
    var _a = React.useState(tslib.__spreadArray(tslib.__spreadArray([], element.enum.map(function (option) { return (tslib.__assign(tslib.__assign({}, option), { displayValue: option.text === option.value ? "" : option.value, displayOnly: false })); }), true), [
        newOnlineEditorInput(),
    ], false)), editorInputs = _a[0], setEditorInputs = _a[1];
    var handleOnAddOneline = function () {
        setEditorInputs(tslib.__spreadArray(tslib.__spreadArray([], editorInputs, true), [newOnlineEditorInput()], false));
    };
    var handleOnDeleteOneline = function (formTargetIndex) {
        var targetInput = editorInputs[formTargetIndex];
        var newOnelineEditorInputs = editorInputs.filter(function (_, i) { return i !== formTargetIndex; });
        if (!targetInput.displayOnly) {
            var newEnums = newEnumsForOnelineEditor(newOnelineEditorInputs);
            var newElement = newSelectableElement(element, newEnums);
            onElementUpdate(newElement);
        }
        setEditorInputs(newOnelineEditorInputs);
    };
    var handleOnChangeOneline = function (type, formInput, formTargetIndex) {
        var newOnelineEditorInputs = newInputsChangeForOnelineEditor(type)(editorInputs, formInput, formTargetIndex);
        var newEnums = newEnumsForOnelineEditor(newOnelineEditorInputs);
        var newElement = newSelectableElement(element, newEnums);
        setEditorInputs(newOnelineEditorInputs);
        onElementUpdate(newElement);
    };
    return {
        editorInputs: editorInputs,
        handleOnAddOneline: handleOnAddOneline,
        handleOnDeleteOneline: handleOnDeleteOneline,
        handleOnChangeOneline: handleOnChangeOneline,
    };
};

var SelectableOptionsOnelineEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = useOptionsOnelineEditor(element, onElementUpdate), editorInputs = _b.editorInputs, handleOnAddOneline = _b.handleOnAddOneline, handleOnDeleteOneline = _b.handleOnDeleteOneline, handleOnChangeOneline = _b.handleOnChangeOneline;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("span", { className: "help has-text-weight-normal" }, "\u7BA1\u7406\u7528\u30B3\u30FC\u30C9\u306B\u306F\u3001\u8868\u793A\u540D\u3068\u306F\u5225\u306B\u30B7\u30B9\u30C6\u30E0\u9023\u643A\u306A\u3069\u306B\u4F7F\u7528\u3059\u308B\u305F\u3081\u306E\u3001\u4EFB\u610F\u306E\u6587\u5B57\u5217\u304C\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002\u30D5\u30A9\u30FC\u30E0\u306B\u5165\u529B\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u308B\u306E\u306F\u3001\u8868\u793A\u540D\u306E\u307F\u3067\u3059\u3002\u7BA1\u7406\u7528\u30B3\u30FC\u30C9\u3092\u8A2D\u5B9A\u3057\u306A\u3044\u5834\u5408\u306B\u306F\u3001\u8868\u793A\u540D\u3068\u7BA1\u7406\u7528\u30B3\u30FC\u30C9\u306F\u540C\u3058\u3082\u306E\u306B\u8A2D\u5B9A\u3055\u308C\u307E\u3059\u3002\u30C7\u30FC\u30BF\u306E\u51FA\u529B\u6642\u306B\u306F\u3001\u7BA1\u7406\u7528\u30B3\u30FC\u30C9\u3082\u3042\u308F\u305B\u3066\u51FA\u529B\u3067\u304D\u307E\u3059\u3002"),
        React__namespace.createElement("table", { className: "table is-fullwidth" },
            React__namespace.createElement("thead", null,
                React__namespace.createElement("tr", null,
                    React__namespace.createElement("th", null, "\u8868\u793A\u540D"),
                    React__namespace.createElement("th", null, "\u7BA1\u7406\u7528\u30B3\u30FC\u30C9"),
                    React__namespace.createElement("th", { style: {
                            width: "50px",
                        } }))),
            React__namespace.createElement("tbody", null, editorInputs.map(function (_a, i) {
                var text = _a.text, displayValue = _a.displayValue;
                return (React__namespace.createElement("tr", { key: "selectable-options-oneline-table-tr-".concat(i) },
                    React__namespace.createElement("td", { style: {
                            verticalAlign: "middle",
                        } },
                        React__namespace.createElement("input", { className: "input", type: "text", value: text, onChange: function (e) {
                                return handleOnChangeOneline("text", e.target.value, i);
                            } })),
                    React__namespace.createElement("td", null,
                        React__namespace.createElement("input", { className: "input", type: "text", value: displayValue, disabled: !text, onChange: function (e) {
                                return handleOnChangeOneline("value", e.target.value, i);
                            } })),
                    React__namespace.createElement("td", null,
                        React__namespace.createElement("button", { className: "button", style: { border: "none" }, onClick: function () { return handleOnDeleteOneline(i); } },
                            React__namespace.createElement("span", { className: "icon" },
                                React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTrash }))))));
            }))),
        React__namespace.createElement("button", { className: "button is-fullwidth has-text-centered mb-4", disabled: editorInputs.some(function (input) { return input.displayOnly; }), onClick: handleOnAddOneline }, "\u8FFD\u52A0\u3059\u308B")));
};

var placeholder = "A\nB\nC\n=> \u9078\u629E\u80A2 [A,B,C]";
var SelectableOptionsTextareaEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = useOptionsTextareaEditor(element, onElementUpdate), editorInput = _b.editorInput, handleOnChangeTextarea = _b.handleOnChangeTextarea;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "mb-2" },
            React__namespace.createElement("textarea", { id: "".concat(element.id, "-options"), className: "textarea", value: editorInput, placeholder: placeholder, onChange: function (e) { return handleOnChangeTextarea(e.target.value); }, rows: 8 })),
        !!element.enum.length && (React__namespace.createElement("div", { className: "tags" }, element.enum.map(function (_a, i) {
            var label = _a.text, value = _a.value;
            return (React__namespace.createElement("span", { className: "tag pt-2 pb-2", style: {
                    whiteSpace: "normal",
                    height: "auto",
                    wordBreak: "break-word",
                }, key: "selectable-options-tag-".concat(i) }, label === value ? label : label + ":" + value));
        })))));
};

var SelectableOptionsEditor = function (_a) {
    var element = _a.element, schemaValidator = _a.schemaValidator, onElementUpdate = _a.onElementUpdate, attachedFormulas = _a.attachedFormulas;
    var supportSwitchEditorModeForSelectableInput = useFormEditorContext().supportSwitchEditorModeForSelectableInput;
    var _b = React.useState("textarea"), editor = _b[0], setEditor = _b[1];
    var handleOnToggleEditor = function () {
        if (!supportSwitchEditorModeForSelectableInput)
            return;
        if (editor === "textarea") {
            setEditor("oneline");
        }
        else {
            setEditor("textarea");
        }
    };
    return (React__default["default"].createElement("div", { className: "field", "data-testid": TEST_ID.OptionsTextAreaEdit },
        React__default["default"].createElement("div", { className: "is-flex is-justify-content-space-between is-align-items-center mb-4" },
            React__default["default"].createElement("label", { className: "label", htmlFor: "".concat(element.id, "-options"), style: {
                    marginBottom: 0,
                } }, "\u9078\u629E\u80A2\u4E00\u89A7"),
            supportSwitchEditorModeForSelectableInput && (React__default["default"].createElement(consoleDesignKit.SecondaryButton, { isSmall: true, text: editor === "textarea"
                    ? "管理用コードを表示"
                    : "管理用コードを非表示", onClick: handleOnToggleEditor }))),
        editor === "textarea" ? (React__default["default"].createElement(SelectableOptionsTextareaEditor, { element: element, onElementUpdate: onElementUpdate })) : (React__default["default"].createElement(SelectableOptionsOnelineEditor, { element: element, onElementUpdate: onElementUpdate })),
        React__default["default"].createElement(ErrorMessage$1, { msg: schemaValidator.enumValues() }),
        React__default["default"].createElement(ErrorMessage$1, { msg: schemaValidator.enumLength() }),
        React__default["default"].createElement(ErrorMessage$1, { msg: formSchema.SelectSchemaValidator.noDuplicateEnumsIncludingEmptyString(element) }),
        React__default["default"].createElement(ErrorMessage$1, { msg: formSchema.SelectSchemaValidator.noEmptyEnum(element) }),
        attachedFormulas && attachedFormulas.length > 0 && (React__default["default"].createElement("div", { className: "mt-4" },
            React__default["default"].createElement(InfoBanner, { message: "\u3053\u306E\u9805\u76EE\u3092\u53C2\u7167\u3057\u305F\u81EA\u52D5\u8A08\u7B97\u6570\u5F0F\u304C\u3042\u308A\u307E\u3059\u3002", description: "\u9078\u629E\u80A2\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001\u5909\u66F4\u5F8C\u306E\u9078\u629E\u80A2\u3067\u671F\u5F85\u901A\u308A\u306E\u8A08\u7B97\u7D50\u679C\u304C\u5F97\u3089\u308C\u308B\u3088\u3046\u3001\u81EA\u52D5\u8A08\u7B97\u6570\u5F0F\u3092\u4FEE\u6B63\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u6570\u5F0FID: ".concat(attachedFormulas
                    .map(function (f) { return f.formula.id; })
                    .join(", ")) })))));
};

var LABEL = {
    minItems: "最小チェック数",
    maxItems: "最大チェック数",
};
var OptionsCheckItems = function (_a) {
    var _b;
    var type = _a.type, element = _a.element, schemaValidator = _a.schemaValidator, onElementUpdate = _a.onElementUpdate;
    var handleOnChange = function (e) {
        var _a;
        var value = e.target.value;
        onElementUpdate(tslib.__assign(tslib.__assign({}, element), (_a = {}, _a[type] = value, _a)));
    };
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, LABEL[type]),
            React__namespace.createElement("div", { className: "mb-2" },
                React__namespace.createElement("input", { className: "input", type: "number", placeholder: "1...", value: (_b = element[type]) !== null && _b !== void 0 ? _b : "", onChange: handleOnChange })),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.validateCheckboxItems(type) }))));
};

var SelectableEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate, attachedFormulas = _a.attachedFormulas;
    var schemaValidator = useSchemaValidator(element, function (elem) {
        switch (elem.inputType) {
            case "checkboxes":
                return new formSchema.CheckboxesSchemaValidator(elem, "warn");
            case "radio_buttons":
                return new formSchema.RadioSchemaValidator(elem);
            case "select":
                return new formSchema.SelectSchemaValidator(elem);
        }
    });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement(SelectableOptionsEditor, { element: element, onElementUpdate: onElementUpdate, schemaValidator: schemaValidator, attachedFormulas: attachedFormulas }),
        element.inputType === "checkboxes" && (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(OptionsCheckItems, { type: "minItems", element: element, onElementUpdate: onElementUpdate, schemaValidator: schemaValidator }),
            React__namespace.createElement(OptionsCheckItems, { type: "maxItems", element: element, onElementUpdate: onElementUpdate, schemaValidator: schemaValidator })))));
};

var Max = function (_a) {
    var _b;
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessage = _a.errMessage;
    var _c = useValidationSettingField(schema), isOn = _c.isOn, setOn = _c.setOn, setOff = _c.setOff;
    return (React__namespace.createElement(ToggleField, { label: "\u6700\u5927\u5024", isOn: isOn, setOn: setOn, setOff: function () {
            remove("maximum");
            setOff();
        } },
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("input", { className: "input", type: "number", placeholder: "1...", value: (_b = schema === null || schema === void 0 ? void 0 : schema.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                    if (e.target.value) {
                        upsert({
                            keyword: "maximum",
                            value: parseInt(e.target.value, 10),
                        });
                    }
                    else {
                        remove("maximum");
                    }
                } })),
        React__namespace.createElement(ErrorMessage$1, { msg: errMessage })));
};

var Min = function (_a) {
    var _b;
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessage = _a.errMessage;
    var _c = useValidationSettingField(schema), isOn = _c.isOn, setOn = _c.setOn, setOff = _c.setOff;
    return (React__namespace.createElement(ToggleField, { label: "\u6700\u5C0F\u5024", isOn: isOn, setOn: setOn, setOff: function () {
            remove("minimum");
            setOff();
        } },
        React__namespace.createElement("div", { className: "control" },
            React__namespace.createElement("input", { className: "input", type: "number", placeholder: "1...", value: (_b = schema === null || schema === void 0 ? void 0 : schema.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                    if (e.target.value) {
                        upsert({
                            keyword: "minimum",
                            value: parseInt(e.target.value, 10),
                        });
                    }
                    else {
                        remove("minimum");
                    }
                } })),
        React__namespace.createElement(ErrorMessage$1, { msg: errMessage })));
};

var NumberValidationEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = validationHelperV2({
        element: element,
        onElementUpdate: onElementUpdate,
    }), upsertValidation = _b.upsertValidation, removeValidation = _b.removeValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) {
        return formSchema.getNumberValidator(elem);
    });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5165\u529B\u898F\u5247\u8A2D\u5B9A")),
        React__namespace.createElement(Max, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "maximum"; }), errMessage: schemaValidator.maxValidation() || schemaValidator.minMax() }),
        React__namespace.createElement(Min, { remove: removeValidation, upsert: upsertValidation, schema: element.validations.find(function (elem) { return elem.keyword === "minimum"; }), errMessage: schemaValidator.minValidation() || schemaValidator.minMax() })));
};

var NumberInputEditor = function (_a) {
    var _b, _c, _d;
    var element = _a.element, onElementUpdate = _a.onElementUpdate, hideValidation = _a.hideValidation;
    var supportSuffix = React.useContext(FormEditorContext).supportSuffix;
    var labelId = "".concat(element.id, "-label");
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.NumberInputSchemaValidator(elem); });
    var _e = React.useState(((_b = element.suffixDescription) === null || _b === void 0 ? void 0 : _b.shouldDisplay) &&
        !!element.suffixDescription.text), isSuffixEnabled = _e[0], setIsSuffixEnabled = _e[1];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement(React__namespace.Fragment, null, supportSuffix && (React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u5358\u4F4D\u8A2D\u5B9A"),
            React__namespace.createElement("input", { type: "checkbox", className: "switch", id: "switch", checked: isSuffixEnabled, onChange: function (e) {
                    setIsSuffixEnabled(e.target.checked);
                    onElementUpdate(tslib.__assign(tslib.__assign({}, element), { suffixDescription: e.target.checked
                            ? {
                                text: "",
                                shouldDisplay: e.target.checked,
                            }
                            : undefined }));
                } }),
            React__namespace.createElement("label", { htmlFor: "switch" }, "\u5358\u4F4D\u3092\u8A2D\u5B9A\u3059\u308B"),
            isSuffixEnabled && (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement("input", { id: labelId, className: "input", type: "text", value: (_d = (_c = element.suffixDescription) === null || _c === void 0 ? void 0 : _c.text) !== null && _d !== void 0 ? _d : "", onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { suffixDescription: {
                                text: e.target.value,
                                shouldDisplay: true,
                            } }));
                    } }),
                React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.suffixDescriptionValidation() })))))),
        !hideValidation && (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement("hr", null),
            React__namespace.createElement(NumberValidationEditor, { element: element, onElementUpdate: onElementUpdate })))));
};

var AllowedTermInput = function (_a) {
    var identifier = _a.identifier, index = _a.index, value = _a.value, onChange = _a.onChange, onRemove = _a.onRemove, showRemove = _a.showRemove;
    return (React__default["default"].createElement("div", { className: "columns px-4 py-4" },
        React__default["default"].createElement("div", { className: "column is-full mb-4 is-paddingless", style: {
                border: "1px solid #CFCFCF",
                borderRadius: 3,
            } },
            React__default["default"].createElement("div", { className: "columns is-marginless has-background-light px-4" },
                React__default["default"].createElement("div", { className: "column is-paddingless my-4", style: {
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    } },
                    React__default["default"].createElement("label", { className: "label" }, "# ".concat(index + 1))),
                showRemove && (React__default["default"].createElement("div", { className: "column is-paddingless has-text-right is-narrow my-4", style: {
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    } },
                    React__default["default"].createElement("button", { className: "icon", onClick: onRemove, "aria-label": "\u30AF\u30EA\u30A2" },
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTimesCircle }))))),
            React__default["default"].createElement("div", { className: "columns px-4 py-4" },
                React__default["default"].createElement("div", { className: "column" },
                    React__default["default"].createElement("div", { className: "field" },
                        React__default["default"].createElement("label", { className: "label" }, "\u5B9A\u7FA9\u5185\u5BB9"),
                        React__default["default"].createElement("div", { className: "control" },
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_definedAs"), checked: value.definedAs === "min", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { definedAs: checked ? "min" : value.definedAs }));
                                    } }),
                                textMapForDefinedAs["min"]),
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_definedAs"), checked: value.definedAs === "max", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { definedAs: checked ? "max" : value.definedAs }));
                                    } }),
                                textMapForDefinedAs["max"]))),
                    React__default["default"].createElement("div", { className: "field ".concat(value.basedOn.kind === "FormSubmissionDate" ? "mb-4" : "") },
                        React__default["default"].createElement("label", { className: "label" }, "\u8A08\u7B97\u57FA\u6E96\u65E5"),
                        React__default["default"].createElement("div", { className: "control" },
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_basedOn_kind"), checked: value.basedOn.kind === "FormSubmissionDate", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { basedOn: checked
                                                ? { kind: "FormSubmissionDate" }
                                                : value.basedOn }));
                                    } }),
                                "\u30D5\u30A9\u30FC\u30E0\u304C\u9001\u4FE1\u3055\u308C\u305F\u65E5\u4ED8"),
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_basedOn_kind"), checked: value.basedOn.kind === "FixedDate", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { basedOn: checked
                                                ? {
                                                    kind: "FixedDate",
                                                    value: "".concat(new Date().getFullYear(), "-01-01"),
                                                }
                                                : value.basedOn }));
                                    } }),
                                "\u56FA\u5B9A\u306E\u65E5\u4ED8"))),
                    value.basedOn.kind === "FixedDate" && (React__default["default"].createElement(FixedDateValueInput, { value: value.basedOn.value, onChange: function (newValue) {
                            onChange(tslib.__assign(tslib.__assign({}, value), { basedOn: {
                                    kind: "FixedDate",
                                    value: newValue,
                                } }));
                        } })),
                    React__default["default"].createElement("div", { className: "field mb-4" },
                        React__default["default"].createElement("label", { className: "label" },
                            textMapForDefinedAs[value.definedAs],
                            "\u306E\u5236\u9650\u3092\u3069\u3053\u3078\u8A2D\u3051\u308B\u304B"),
                        React__default["default"].createElement("div", { className: "control" },
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_arithmeticOperation"), checked: value.arithmeticOperation === "minus", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { arithmeticOperation: checked
                                                ? "minus"
                                                : value.arithmeticOperation }));
                                    } }),
                                "\u57FA\u6E96\u65E5\u4EE5\u524D"),
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_arithmeticOperation"), checked: value.arithmeticOperation === "plus", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { arithmeticOperation: checked
                                                ? "plus"
                                                : value.arithmeticOperation }));
                                    } }),
                                "\u57FA\u6E96\u65E5\u4EE5\u5F8C"))),
                    React__default["default"].createElement("div", { className: "field mb-4" },
                        React__default["default"].createElement("label", { className: "label" }, "\u8A08\u7B97\u306B\u7528\u3044\u308B\u5E74\u306E\u5024\uFF08\u6570\u5B57\uFF09"),
                        React__default["default"].createElement("div", { className: "control" },
                            React__default["default"].createElement("input", { className: "input", type: "text", pattern: "[0-9]{1,3}", value: value.year.value, onChange: function (_a) {
                                    var target = _a.target;
                                    onChange(tslib.__assign(tslib.__assign({}, value), { year: tslib.__assign(tslib.__assign({}, value.year), { value: toHalfWidthNum(target.value) }) }));
                                } }))),
                    React__default["default"].createElement("div", { className: "field" },
                        React__default["default"].createElement("label", { className: "label" }, "\u8A08\u7B97\u306B\u7528\u3044\u308B\u6708\u306E\u5024\uFF08\u6570\u5B57\uFF09"),
                        React__default["default"].createElement("div", { className: "control" },
                            React__default["default"].createElement("input", { className: "input", type: "text", pattern: "[0-9]{1}|1[0-2]", value: value.month.value, onChange: function (_a) {
                                    var target = _a.target;
                                    onChange(tslib.__assign(tslib.__assign({}, value), { month: tslib.__assign(tslib.__assign({}, value.month), { value: toHalfWidthNum(target.value) }) }));
                                } }))),
                    React__default["default"].createElement("div", { className: "field mb-4" },
                        React__default["default"].createElement("div", { className: "control" },
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_month_usedAs"), checked: value.month.usedAs === "relative", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { month: tslib.__assign(tslib.__assign({}, value.month), { usedAs: checked ? "relative" : value.month.usedAs }) }));
                                    } }),
                                "\u57FA\u6E96\u65E5\u304B\u3089\u306E\u5DEE\u3068\u3057\u3066\u6271\u3046"),
                            React__default["default"].createElement("label", { className: "radio" },
                                React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_month_usedAs"), checked: value.month.usedAs === "absolute", onChange: function (_a) {
                                        var checked = _a.target.checked;
                                        onChange(tslib.__assign(tslib.__assign({}, value), { month: tslib.__assign(tslib.__assign({}, value.month), { usedAs: checked ? "absolute" : value.month.usedAs }) }));
                                    } }),
                                "\u7D76\u5BFE\u7684\u306A\u5024\u3068\u3057\u3066\u6271\u3046"))),
                    value.day && (React__default["default"].createElement(CalcDayValueEditor, { identifier: identifier, onChange: onChange, value: value, day: value.day })))))));
};
var CalcDayValueEditor = function (_a) {
    var identifier = _a.identifier, value = _a.value, onChange = _a.onChange, day = _a.day;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u8A08\u7B97\u306B\u7528\u3044\u308B\u65E5\u306E\u5024\uFF08\u6570\u5B57\uFF09"),
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("input", { className: "input", type: "text", pattern: "[0-9]{1,3}", value: day.value, onChange: function (_a) {
                        var target = _a.target;
                        onChange(tslib.__assign(tslib.__assign({}, value), { day: tslib.__assign(tslib.__assign({}, day), { value: toHalfWidthNum(target.value) }) }));
                    } }))),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("div", { className: "control" },
                React__default["default"].createElement("label", { className: "radio" },
                    React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_day_usedAs"), checked: day.usedAs === "relative", onChange: function (_a) {
                            var checked = _a.target.checked;
                            onChange(tslib.__assign(tslib.__assign({}, value), { day: tslib.__assign(tslib.__assign({}, day), { usedAs: checked ? "relative" : day.usedAs }) }));
                        } }),
                    "\u57FA\u6E96\u65E5\u304B\u3089\u306E\u5DEE\u3068\u3057\u3066\u6271\u3046"),
                React__default["default"].createElement("label", { className: "radio" },
                    React__default["default"].createElement("input", { type: "radio", name: "".concat(identifier, "_dateComparison_day_usedAs"), checked: day.usedAs === "absolute", onChange: function (_a) {
                            var checked = _a.target.checked;
                            onChange(tslib.__assign(tslib.__assign({}, value), { day: tslib.__assign(tslib.__assign({}, day), { usedAs: checked ? "absolute" : day.usedAs }) }));
                        } }),
                    "\u7D76\u5BFE\u7684\u306A\u5024\u3068\u3057\u3066\u6271\u3046")),
            React__default["default"].createElement(HelpTextForDayValue, { day: day, definedAs: value.definedAs }))));
};
var textMapForDefinedAs = {
    min: "最小値",
    max: "最大値",
};
var FixedDateValueInput = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (React__default["default"].createElement("div", { className: "field has-addons mb-4" },
        React__default["default"].createElement("div", { className: "control" },
            React__default["default"].createElement("input", { className: "input", type: "text", pattern: "[0-9]{4}", value: value.split("-")[0], onChange: function (_a) {
                    var target = _a.target;
                    onChange("".concat(toHalfWidthNum(target.value), "-01-01"));
                } })),
        React__default["default"].createElement("div", { className: "control" },
            React__default["default"].createElement("div", { className: "button is-static" }, "\u5E741\u67081\u65E5"))));
};
var toHalfWidthNum = function (strValue) {
    var replaced = strValue.replace(/[０-９]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
    });
    var num = Number(replaced);
    return Number.isNaN(num) ? 0 : num;
};
var HelpTextForDayValue = function (_a) {
    var day = _a.day, definedAs = _a.definedAs;
    var value = day.value, usedAs = day.usedAs;
    if (usedAs !== "absolute") {
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    }
    if (value <= 28) {
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    }
    return (React__default["default"].createElement("p", { className: "help mt-2" }, "".concat(value, "\u65E5\u3088\u308A\u3082\u77ED\u3044\u6708\u306E\u5834\u5408\u306F\u3001\u6708\u672B\u65E5\u304C").concat(textMapForDefinedAs[definedAs], "\u3068\u3057\u3066\u8A2D\u5B9A\u3055\u308C\u307E\u3059\u3002")));
};

var AllowedTermValidationEditor = function (_a) {
    var schema = _a.schema, remove = _a.remove, upsert = _a.upsert, errMessages = _a.errMessages, defaultValueBuilder = _a.defaultValueBuilder;
    var handleInitialize = React__default["default"].useCallback(function () {
        upsert({
            keyword: formSchema.ValidationKeywords.AllowedTerm,
            value: [defaultValueBuilder()],
        });
    }, [upsert, defaultValueBuilder]);
    var keyedSchemaValues = useKeyedArray(schema === null || schema === void 0 ? void 0 : schema.value);
    var handleUpdateOne = React__default["default"].useCallback(function (updateKey, newValue) {
        upsert({
            keyword: formSchema.ValidationKeywords.AllowedTerm,
            value: keyedSchemaValues.map(function (_a) {
                var key = _a[0], value = _a[1];
                return key === updateKey ? newValue : value;
            }),
        });
    }, [keyedSchemaValues, upsert]);
    var handleRemoveOne = React__default["default"].useCallback(function (removeKey) {
        upsert({
            keyword: formSchema.ValidationKeywords.AllowedTerm,
            value: keyedSchemaValues
                .filter(function (_a) {
                var key = _a[0];
                return key !== removeKey;
            })
                .map(function (_a) {
                _a[0]; var v = _a[1];
                return v;
            }),
        });
    }, [keyedSchemaValues, upsert]);
    var keyedErrorMessages = useKeyedArray(errMessages);
    return (React__default["default"].createElement(ToggleField, { label: "".concat(getValidatorName(formSchema.ValidationKeywords.AllowedTerm), " \uFF08\u6700\u5927").concat(formSchema.ValidationErrorVariables.allowedTerm.maxConfigLength, "\u500B\uFF09"), isOn: !!schema, setOn: handleInitialize, setOff: function () {
            remove(formSchema.ValidationKeywords.AllowedTerm);
        } },
        !!schema && (React__default["default"].createElement("div", { className: "columns" },
            React__default["default"].createElement("div", { className: "column ml-4" },
                keyedSchemaValues.map(function (_a, index) {
                    var key = _a[0], value = _a[1];
                    return (React__default["default"].createElement(AllowedTermInput, { key: key, identifier: key, index: index, value: value, onChange: function (newValue) {
                            handleUpdateOne(key, newValue);
                        }, onRemove: function () {
                            handleRemoveOne(key);
                        }, showRemove: keyedSchemaValues.length > 1 }));
                }),
                React__default["default"].createElement("div", { className: "columns ".concat(schema.value.length >=
                        formSchema.ValidationErrorVariables.allowedTerm.maxConfigLength
                        ? "is-hidden"
                        : "") },
                    React__default["default"].createElement("div", { className: "column is-full" },
                        React__default["default"].createElement("button", { className: "button is-fullwidth has-text-centered", onClick: function () {
                                upsert(tslib.__assign(tslib.__assign({}, schema), { value: tslib.__spreadArray(tslib.__spreadArray([], schema.value, true), [defaultValueBuilder()], false) }));
                            }, disabled: (Array.isArray(errMessages) && errMessages.length > 0) ||
                                schema.value.length >=
                                    formSchema.ValidationErrorVariables.allowedTerm.maxConfigLength }, "\u8FFD\u52A0\u3059\u308B")))))),
        // TODO: より視認性の良いフィードバックを行う。
        keyedErrorMessages.map(function (_a) {
            var key = _a[0], message = _a[1];
            return React__default["default"].createElement(ErrorMessage$1, { key: key, msg: message });
        })));
};
// Array#map でコンポーネントを描画するに際して、
// React の文脈で unique な key を付与できるようにしている。
var useKeyedArray = function (arr) {
    var base = arr !== null && arr !== void 0 ? arr : [];
    var keys = React__default["default"].useMemo(function () {
        return formSchema.StringGenerator.generateUniqueIDs(base.length);
    }, [
        // 要素の入れ替えはサポートしていないので、
        // length が変わったときのみ再計算する、でよい
        base.length,
    ]);
    return keys.map(function (id, index) { return [id, base[index]]; });
};

var YearMonthInputValidationEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = validationHelperV2({
        element: element,
        onElementUpdate: onElementUpdate,
    }), upsertValidation = _b.upsertValidation, removeValidation = _b.removeValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.YearMonthInputSchemaValidator(elem); });
    return (React__default["default"].createElement("div", null,
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u5165\u529B\u898F\u5247\u8A2D\u5B9A")),
        React__default["default"].createElement(AllowedTermValidationEditor, { schema: element.validations.find(formSchema.isDateComparisonSchema), upsert: upsertValidation, remove: removeValidation, errMessages: schemaValidator.allowedTermFlat(), defaultValueBuilder: defaultAllowedTermValueForYearMonth })));
};
var defaultAllowedTermValueForYearMonth = function () {
    return {
        definedAs: "min",
        basedOn: {
            kind: "FormSubmissionDate",
        },
        arithmeticOperation: "minus",
        year: {
            value: 0,
        },
        month: {
            value: 0,
            usedAs: "relative",
        },
    };
};

var YearMonthInputEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate, hideValidation = _a.hideValidation;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        !hideValidation && (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("hr", null),
            React__default["default"].createElement(YearMonthInputValidationEditor, { element: element, onElementUpdate: onElementUpdate })))));
};

var FileInputEditor = function (_a) {
    var _b;
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.FileInputSchemaValidator(elem); });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label", htmlFor: "fileInputEditor-maxSize-".concat(element.id) }, "\u6700\u5927\u30B5\u30A4\u30BA\uFF08\u30E1\u30AC\u30D0\u30A4\u30C8\uFF09"),
            React__namespace.createElement("div", { className: "field" },
                React__namespace.createElement("div", { className: "control has-icons-right" },
                    React__namespace.createElement("input", { id: "fileInputEditor-maxSize-".concat(element.id), className: "input", type: "number", placeholder: "\u30C1\u30A7\u30C3\u30AF\u306E\u5024", value: element.maxSize, onChange: function (e) {
                            onElementUpdate(tslib.__assign(tslib.__assign({}, element), { maxSize: parseInt(e.target.value, 10) }));
                        } }))),
            React__namespace.createElement(ErrorMessage$1, { msg: (_b = schemaValidator.maxFileSizeIsNaturalNumber()) !== null && _b !== void 0 ? _b : schemaValidator.maxFileSize() })),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u8A31\u5BB9\u30D5\u30A1\u30A4\u30EB"),
            React__namespace.createElement("ul", { className: "columns is-gapless is-flex-wrap-wrap" }, formSchema.mimeTypeList.map(function (mimeType) {
                return (React__namespace.createElement("li", { key: "fileInputEditor-AcceptAttributeValue-".concat(mimeType), className: "column is-narrow mr-1" },
                    React__namespace.createElement("label", { className: "checkbox" },
                        React__namespace.createElement("input", { type: "checkbox", className: "mr-1", checked: element.accept.includes(mimeType), onChange: function () {
                                onElementUpdate(tslib.__assign(tslib.__assign({}, element), { accept: element.accept.includes(mimeType)
                                        ? element.accept.filter(function (v) { return v !== mimeType; })
                                        : tslib.__spreadArray(tslib.__spreadArray([], element.accept, true), [mimeType], false) }));
                            } }),
                        formSchema.MimeTypeToExtension[mimeType].join(","))));
            })))));
};

var DateInputValidationEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate;
    var _b = validationHelperV2({
        element: element,
        onElementUpdate: onElementUpdate,
    }), upsertValidation = _b.upsertValidation, removeValidation = _b.removeValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.DateInputValidator(elem); });
    return (React__default["default"].createElement("div", null,
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label" }, "\u5165\u529B\u898F\u5247\u8A2D\u5B9A")),
        React__default["default"].createElement(AllowedTermValidationEditor, { schema: element.validations.find(formSchema.isDateComparisonSchema), upsert: upsertValidation, remove: removeValidation, errMessages: schemaValidator.allowedTermFlat(), defaultValueBuilder: defaultAllowedTermValueForDate })));
};
var defaultAllowedTermValueForDate = function () {
    return {
        definedAs: "min",
        basedOn: {
            kind: "FormSubmissionDate",
        },
        arithmeticOperation: "minus",
        year: {
            value: 0,
        },
        month: {
            value: 0,
            usedAs: "relative",
        },
        day: {
            value: 0,
            usedAs: "relative",
        },
    };
};

var DateInputEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate, hideValidation = _a.hideValidation;
    var supportAllowedTermValidationForDateInput = useFormEditorContext().supportAllowedTermValidationForDateInput;
    var handleOnChange = React__namespace.useCallback(function (event) {
        var value = event.target.value;
        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { formType: value }));
    }, [element, onElementUpdate]);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement(consoleDesignKit.RadioButton, { label: "入力フォームタイプ", description: "日付の入力方式を選んでください。", options: [
                    {
                        name: "カレンダー入力",
                        value: "DatePicker",
                        description: "月間カレンダーの中から日付を選択できる入力形式です。 \n転出日など直近の日付を入力させたい場合に向いていますが、生年月日など現在から離れた日付を入力したい場合には向いていません。",
                    },
                    {
                        name: "数値直接入力",
                        value: "MultiInput",
                        description: "日付の数値をキーボードで直接入力できる形式です。パソコンでの操作が多い場合に向いています。",
                    },
                    {
                        name: "選択入力",
                        value: "SelectInput",
                        tags: (React__namespace.createElement(consoleDesignKit.SecondaryStatusTag, { type: "LIGHT" }, "\u548C\u66A6\u30FB\u897F\u66A6\u4F75\u8A18")),
                        description: "セレクトボックス形式の候補の中から日付を選択入力できる形式です。 \n日付の範囲としては、開始は1907年から、終了は現在の10年先まで表示されます。\n年の表記には、西暦・和暦が併記されます。\nセレクトボックスに最初に表示される候補の日付を初期表示開始年設定で指定することができます。初期表示開始年は1907年から現在の10年前まで指定することができます",
                    },
                ], value: new formSchema.DateInputFormType(element.formType).getValue(), onChange: handleOnChange })),
        element.formType === "SelectInput" && (React__namespace.createElement(ToggleField, { label: "\u521D\u671F\u8868\u793A\u958B\u59CB\u5E74", isOn: element.baseYear !== undefined, setOn: function () {
                return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { baseYear: 2000 }));
            }, setOff: function () {
                return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { baseYear: undefined }));
            } },
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "number", value: element.baseYear, onChange: function (e) {
                        return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { baseYear: parseInt(e.target.value, 10) }));
                    }, placeholder: "\u958B\u59CB\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" })),
            React__namespace.createElement(ErrorMessage$1, { msg: element.baseYear !== undefined &&
                    (element.baseYear < 1907 ||
                        element.baseYear > new Date().getFullYear() - 10)
                    ? "初期表示開始年は1907年から現在年の10年前までの間で指定してください"
                    : undefined }))),
        !hideValidation && supportAllowedTermValidationForDateInput && (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement("hr", null),
            React__namespace.createElement(DateInputValidationEditor, { element: element, onElementUpdate: onElementUpdate })))));
};

var FormulaResultEditor = function (_a) {
    var _b;
    var element = _a.element, onElementUpdate = _a.onElementUpdate, formulaSet = _a.formulaSet, hideValidation = _a.hideValidation;
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.FormulaResultSchemaValidator(elem); });
    var formulaIds = (_b = formulaSet === null || formulaSet === void 0 ? void 0 : formulaSet.formulas.map(function (f) { return f.id; })) !== null && _b !== void 0 ? _b : [];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u6570\u5F0F\u8A2D\u5B9A"),
            React__namespace.createElement("div", { className: "select" },
                React__namespace.createElement("select", { value: element.formulaId, onChange: function (e) {
                        return onElementUpdate(tslib.__assign(tslib.__assign({}, element), { formulaId: e.target.value }));
                    } },
                    React__namespace.createElement("option", { key: "", value: "" }, "\u672A\u9078\u629E"),
                    element.formulaId && !formulaIds.includes(element.formulaId) && (React__namespace.createElement("option", { key: element.formulaId, value: element.formulaId }, element.formulaId)),
                    formulaIds.map(function (id) { return (React__namespace.createElement("option", { key: id, value: id }, id)); }))),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.formulaIdValidation(formulaIds) })),
        !hideValidation && (React__namespace.createElement(NumberValidationEditor, { element: element, onElementUpdate: onElementUpdate }))));
};

var PostalCodeInputEditor = function (_a) {
    var element = _a.element, onElementUpdate = _a.onElementUpdate, sections = _a.sections;
    var postalCode = "".concat(element.id, "-postalCode");
    var schemaValidator = useSchemaValidator(element, function (elem) { return new formSchema.PostalCodeInputSchemaValidator(elem); });
    var sectionOptions = React.useMemo(function () {
        var currentSection = sections.find(function (section) {
            return section.children.some(function (child) { return child.id === element.id; });
        });
        if (!currentSection) {
            return [];
        }
        var elementIndex = currentSection.children.findIndex(function (child) { return child.id === element.id; });
        return currentSection.children.reduce(function (acc, elem, index) {
            return formSchema.isInputElement(elem) &&
                formSchema.isTextInputElement(elem) &&
                (element.addressCompleteTarget === elem.id || elementIndex < index)
                ? tslib.__spreadArray(tslib.__spreadArray([], acc, true), [elem], false) : acc;
        }, []);
    }, [sections, element]);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(CommonPropertiesEditor, { element: element, onElementUpdate: onElementUpdate }),
        React__namespace.createElement("hr", null),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label", htmlFor: postalCode }, "\u9069\u7528\u3059\u308B\u9805\u76EE"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("div", { className: "select" },
                    React__namespace.createElement("select", { value: element.addressCompleteTarget, onChange: function (e) {
                            onElementUpdate(tslib.__assign(tslib.__assign({}, element), { addressCompleteTarget: e.target.value }));
                        } },
                        React__namespace.createElement("option", { key: "", value: "" }),
                        sectionOptions.map(function (section) {
                            return (React__namespace.createElement("option", { key: section.id, value: section.id }, section.label.text));
                        })))),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.hasAddressCompleteTarget() }))));
};

var ElementEditorView = function (_a) {
    var element = _a.element, isDuplicateId = _a.isDuplicateId, currentRawSchema = _a.currentRawSchema, allowCustomElemId = _a.allowCustomElemId, onElementUpdate = _a.onElementUpdate, hideValidation = _a.hideValidation, attachedFormulas = _a.attachedFormulas;
    var elem = element;
    var extraFormDescriptionWithTel = "この項目では全角・半角、ハイフン有り・無しのいずれの値も受け付けられます。入力値を制御したい場合には、入力できる文字の種類を「説明文」に記載することで利用者の行動を促します。もしくは「1行テキスト」の正規表現の設定で、入力できる文字を制御します。";
    return (React__namespace.createElement(React__namespace.Fragment, null,
        element.inputType === "tel" && (React__namespace.createElement("div", { className: "is-size-7 has-text-grey mb-4" }, extraFormDescriptionWithTel)),
        allowCustomElemId && (React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "ElementID"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "text", placeholder: "", value: element.id, onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { id: e.target.value }));
                    } })),
            isDuplicateId && (React__namespace.createElement("p", { className: "help is-danger" }, "ID\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059")))),
        new formSchema.InputElementState(elem.inputType).matchType({
            text: (React__namespace.createElement(TextInputEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation })),
            text_area: (React__namespace.createElement(TextAreaEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation })),
            number: (React__namespace.createElement(NumberInputEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation })),
            tel: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, subDescription: "\u4F8B\uFF09\u65E5\u4E2D\u306B\u9023\u7D61\u304C\u53D6\u308C\u308B\u96FB\u8A71\u756A\u53F7\u3092\u3001\u30CF\u30A4\u30D5\u30F3\uFF08-\uFF09\u306A\u3057\u306E\u534A\u89D2\u6570\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", onElementUpdate: onElementUpdate })),
            date: (React__namespace.createElement(DateInputEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation })),
            date_range: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            time: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            datetime: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            time_range: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            datetime_range: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            year_month: (React__namespace.createElement(YearMonthInputEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation })),
            email: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            checkboxes: (React__namespace.createElement(SelectableEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation, attachedFormulas: attachedFormulas })),
            radio_buttons: (React__namespace.createElement(SelectableEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation, attachedFormulas: attachedFormulas })),
            select: (React__namespace.createElement(SelectableEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation, attachedFormulas: attachedFormulas })),
            file: (React__namespace.createElement(FileInputEditor, { element: elem, onElementUpdate: onElementUpdate, hideValidation: hideValidation })),
            my_number: (React__namespace.createElement(CommonPropertiesEditor, { element: elem, onElementUpdate: onElementUpdate })),
            formula_result: (React__namespace.createElement(FormulaResultEditor, { element: elem, onElementUpdate: onElementUpdate, formulaSet: currentRawSchema.formulaSet, hideValidation: hideValidation })),
            postal_code: (React__namespace.createElement(PostalCodeInputEditor, { element: elem, onElementUpdate: onElementUpdate, sections: currentRawSchema.root, hideValidation: hideValidation })),
        })));
};

var SectionEditor = function (_a) {
    var initialElement = _a.element, onElementUpdateComplete = _a.onElementUpdate, onClose = _a.onClose;
    var _b = React.useState(initialElement), element = _b[0], onElementUpdate = _b[1];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns is-vcentered is-mobile is-paddingless is-marginless" },
            React__namespace.createElement("div", { className: "column is-marginless is-paddingless" },
                React__namespace.createElement("div", null,
                    React__namespace.createElement("p", { className: "title is-size-4" }, element.title))),
            React__namespace.createElement("div", { className: "column is-narrow buttons is-marginless is-paddingless" },
                React__namespace.createElement("button", { className: "button is-outlined", onClick: onClose }, "\u9589\u3058\u308B"),
                React__namespace.createElement("button", { className: "button is-outlined", onClick: function () {
                        onElementUpdateComplete(element);
                        onClose();
                    }, disabled: element.title.length === 0 }, "\u4FDD\u5B58"))),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label" }, "\u30BF\u30A4\u30C8\u30EB"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "text", placeholder: "\u672A\u8A2D\u5B9A", value: element.title, onChange: function (e) {
                        onElementUpdate(tslib.__assign(tslib.__assign({}, element), { title: e.target.value }));
                    } })))));
};

var AddButton = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "default" : _b, hideLabel = _a.hideLabel, onClick = _a.onClick;
    return (React__namespace.createElement("div", { className: "is-flex is-align-items-center is-paddingless is-marginless", style: {
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            outline: "none",
            padding: 0,
            appearance: "none",
        }, onClick: onClick, "data-testid": TEST_ID.AddButton },
        React__namespace.createElement(React__namespace.Fragment, null, matchType(size, {
            default: (React__namespace.createElement("span", { className: "icon is-large", style: {
                    paddingTop: "1px",
                } },
                React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faPlusCircle, size: "2x" }))),
            small: (React__namespace.createElement("span", { className: "icon has-text-grey-light", style: {
                    paddingTop: "1px",
                } },
                React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faPlusCircle }))),
        })),
        !hideLabel && React__namespace.createElement("span", null, "\u9805\u76EE\u3092\u8FFD\u52A0\u3059\u308B")));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".add-dropdown-module_isFullWidth__hIW8C {\n  width: 100% !important;\n}\n\n.add-dropdown-module_bar__nI-2K {\n  display: block;\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 1;\n  padding: 0.75rem;\n}\n\n.add-dropdown-module_bar__nI-2K hr {\n  background-color: #dbdbdb;\n  height: 1px;\n}\n\n.add-dropdown-module_dropdownContent__tzHQv {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  grid-column-gap: 16px;\n  grid-row-gap: 8px;\n  width: 100%;\n  padding: 16px;\n}\n\n.add-dropdown-module_dropdownContent__tzHQv.add-dropdown-module_maxHeight__EkkFB {\n  max-height: 30em;\n  overflow: auto;\n}\n\n.add-dropdown-module_dropdownContent__tzHQv.add-dropdown-module_isScrollContainer__FEdB3 {\n  max-height: 13em;\n  overflow: auto;\n}\n\n@media screen and (max-width: 768px) {\n  .add-dropdown-module_dropdownContent__tzHQv.add-dropdown-module_maxHeight__EkkFB {\n    max-height: 13em;\n  }\n}\n";
var styles$1 = {"isFullWidth":"add-dropdown-module_isFullWidth__hIW8C","bar":"add-dropdown-module_bar__nI-2K","dropdownContent":"add-dropdown-module_dropdownContent__tzHQv","maxHeight":"add-dropdown-module_maxHeight__EkkFB","isScrollContainer":"add-dropdown-module_isScrollContainer__FEdB3"};
styleInject(css_248z$1);

var ToolbarItemList = function (_a) {
    var hideRepeatable = _a.hideRepeatable, hidePostalCode = _a.hidePostalCode, hideCorporateSearch = _a.hideCorporateSearch, hideDescription = _a.hideDescription, hideImage = _a.hideImage, onClick = _a.onClick, generateUniqueId = _a.generateUniqueId, setIsActive = _a.setIsActive, markdownConfig = _a.markdownConfig;
    var _b = useFormEditorContext(), toolbarItemList = _b.toolbarItemList, supportFileInput = _b.supportFileInput, supportMyNumberInput = _b.supportMyNumberInput, supportFormula = _b.supportFormula, supportFormulaResult = _b.supportFormulaResult, supportYearMonthInput = _b.supportYearMonthInput, supportPostalCode = _b.supportPostalCode, supportCorporateSearch = _b.supportCorporateSearch, supportDescription = _b.supportDescription, supportImage = _b.supportImage;
    var isSupportedItem = React__namespace.useCallback(function (item) {
        switch (item.key) {
            case "file":
                return supportFileInput;
            case "my_number":
                return supportMyNumberInput;
            case "year_month":
                return supportYearMonthInput;
            case "formula_result":
                return supportFormula && supportFormulaResult && !hideRepeatable;
            case "postal_code":
                return supportPostalCode && !hidePostalCode;
            case "repeatable":
                return !hideRepeatable;
            case formSchema.FunctionTypes.CorporateSearch:
                return supportCorporateSearch && !hideCorporateSearch;
            case formSchema.StaticTypes.Description:
                return supportDescription && !hideDescription;
            case formSchema.StaticTypes.Image:
                return supportImage && !hideImage;
            default:
                return true;
        }
    }, [
        supportFileInput,
        supportMyNumberInput,
        supportYearMonthInput,
        supportFormula,
        supportFormulaResult,
        hideRepeatable,
        supportPostalCode,
        hidePostalCode,
        supportCorporateSearch,
        hideCorporateSearch,
        supportDescription,
        hideDescription,
        supportImage,
        hideImage,
    ]);
    return (React__namespace.createElement(React__namespace.Fragment, null, toolbarItemList.map(function (item) {
        if (!isSupportedItem(item)) {
            return null;
        }
        var onClickItem = function () {
            onClick(item.onCreate(generateUniqueId, markdownConfig));
            setIsActive(false);
        };
        return (React__namespace.createElement("div", { key: item.key, "data-testid": TEST_ID.ToolbarItemList, "data-testkey": item.key },
            React__namespace.createElement("button", { onClick: onClickItem, style: {
                    cursor: "pointer",
                } },
                item.key === "number" ? (React__namespace.createElement("span", null,
                    React__namespace.createElement("strong", { className: "mr-2" }, "123"))) : (React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { className: "mr-2", icon: item.icon })),
                formSchema.typeLabel(item.key))));
    })));
};

var AddDropdownMenuBetweenElem = function (_a) {
    var _b;
    var hideRepeatable = _a.hideRepeatable, hidePostalCode = _a.hidePostalCode, hideCorporateSearch = _a.hideCorporateSearch, hideDescription = _a.hideDescription, hideImage = _a.hideImage, onClick = _a.onClick, buttonContext = _a.buttonContext, generateUniqueId = _a.generateUniqueId, isUp = _a.isUp, props = tslib.__rest(_a, ["hideRepeatable", "hidePostalCode", "hideCorporateSearch", "hideDescription", "hideImage", "onClick", "buttonContext", "generateUniqueId", "isUp"]);
    var editRegistry = useEditorRegistry();
    var _c = React.useState(false), isActive = _c[0], setIsActive = _c[1];
    var DropdownContent = editRegistry.getDropdownMenuContent(buttonContext);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(OutsideClickHandler__default["default"], { onOutsideClick: function () {
                setIsActive(false);
            } },
            React__namespace.createElement("div", { className: "columns is-paddingless is-marginless is-vcentered", "data-testid": TEST_ID.AddDropdownMenuBetweenElem, "data-testkey": (_b = buttonContext.elem) === null || _b === void 0 ? void 0 : _b.id },
                React__namespace.createElement("div", { className: classNames__default["default"]("column is-narrow is-paddingless is-marginless", styles$1.isFullWidth) },
                    React__namespace.createElement("div", { className: classNames__default["default"]("dropdown", {
                            "is-active": isActive,
                            "is-up": isUp,
                        }, "is-flex", "align-items-center", styles$1.isFullWidth) },
                        React__namespace.createElement(AddButton, { size: "small", hideLabel: true, onClick: function () {
                                setIsActive(!isActive);
                            } }),
                        React__namespace.createElement("div", { className: classNames__default["default"]("dropdown-menu", styles$1.isFullWidth), role: "menu" },
                            React__namespace.createElement("div", { className: classNames__default["default"]("dropdown-content", styles$1.dropdownContent, styles$1.isScrollContainer) }, DropdownContent ? (React__namespace.createElement(DropdownContent, { schemaBuilder: props.schemaBuilder, setNewBuilder: props.setNewBuilder })) : (React__namespace.createElement(ToolbarItemList, { hideRepeatable: hideRepeatable, hidePostalCode: hidePostalCode, hideCorporateSearch: hideCorporateSearch, hideDescription: hideDescription, hideImage: hideImage, onClick: onClick, generateUniqueId: generateUniqueId, setIsActive: setIsActive, markdownConfig: props.markdownConfig })))),
                        React__namespace.createElement("div", { className: styles$1.bar },
                            React__namespace.createElement("hr", null))))))));
};

var AddDropdownMenu = function (_a) {
    var onClick = _a.onClick, buttonContext = _a.buttonContext, size = _a.size, isUp = _a.isUp, generateUniqueId = _a.generateUniqueId, hideRepeatable = _a.hideRepeatable, hidePostalCode = _a.hidePostalCode, hideCorporateSearch = _a.hideCorporateSearch, hideDescription = _a.hideDescription, hideImage = _a.hideImage, isScrollContainer = _a.isScrollContainer, markdownConfig = _a.markdownConfig, props = tslib.__rest(_a, ["onClick", "buttonContext", "size", "isUp", "generateUniqueId", "hideRepeatable", "hidePostalCode", "hideCorporateSearch", "hideDescription", "hideImage", "isScrollContainer", "markdownConfig"]);
    var _b = React.useState(false), isActive = _b[0], setIsActive = _b[1];
    var editRegistry = useEditorRegistry();
    var DropdownContent = editRegistry.getDropdownMenuContent(buttonContext);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(OutsideClickHandler__default["default"], { onOutsideClick: function () {
                setIsActive(false);
            } },
            React__namespace.createElement("div", { className: classNames__default["default"]("dropdown", {
                    "is-active": isActive,
                    "is-up": isUp,
                }, styles$1.isFullWidth), "data-testid": TEST_ID.AddDropdownMenu },
                React__namespace.createElement("div", { className: classNames__default["default"]("dropdown-trigger", styles$1.isFullWidth) },
                    React__namespace.createElement(AddButton, { size: size, onClick: function () {
                            setIsActive(!isActive);
                        } })),
                React__namespace.createElement("div", { className: classNames__default["default"]("dropdown-menu", styles$1.isFullWidth), role: "menu" },
                    React__namespace.createElement("div", { className: classNames__default["default"]("dropdown-content", styles$1.dropdownContent, styles$1.maxHeight, isScrollContainer && styles$1.isScrollContainer) }, DropdownContent ? (React__namespace.createElement(DropdownContent, { schemaBuilder: props.schemaBuilder, setNewBuilder: props.setNewBuilder })) : (React__namespace.createElement(ToolbarItemList, { hideRepeatable: hideRepeatable, hidePostalCode: hidePostalCode, hideCorporateSearch: hideCorporateSearch, hideDescription: hideDescription, hideImage: hideImage, onClick: onClick, generateUniqueId: generateUniqueId, setIsActive: setIsActive, markdownConfig: markdownConfig }))))))));
};

var HiddenTag = function () { return (React__default["default"].createElement("span", { className: "tag is-rounded" }, "\u975E\u8868\u793A")); };

var ConditionalRuleTag = function () { return (React__namespace.createElement("span", { className: "tag is-rounded" }, "\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A")); };

var BuilderRepeatableFieldTemplateV2 = function (_a) {
    var config = _a.config, onEdit = _a.onEdit, onRemove = _a.onRemove, onCopy = _a.onCopy, children = _a.children, ruleMap = _a.ruleMap, isInsertable = _a.isInsertable;
    var FieldTemplate = formGenerator.DefaultRepeatableTemplateRegistry.get(config);
    var editConfig = useEditConfig(config);
    return (React__namespace.createElement("div", { className: "field", style: {
            cursor: "pointer",
        }, "data-testid": TEST_ID.BuilderRepeatableFieldTemplateV2 },
        React__namespace.createElement("div", { className: "level mb-4" },
            React__namespace.createElement("div", { className: "level-left" },
                React__namespace.createElement("div", { className: "level-item tags" },
                    React__namespace.createElement("span", { className: "tag" }, formSchema.typeLabel("repeatable")),
                    config.hidden && React__namespace.createElement(HiddenTag, null),
                    ruleMap.hasThenRule(config.id) && React__namespace.createElement(ConditionalRuleTag, null))),
            React__namespace.createElement("div", { className: "level-right" },
                React__namespace.createElement("div", { className: "level-item" },
                    React__namespace.createElement(consoleDesignKit.TextButton, { onClick: onEdit, text: "編集", icon: "EditIcon" }),
                    !editConfig.disableCopy && (React__namespace.createElement("p", { className: "ml-4" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { onClick: onCopy, text: "コピー", icon: "CopyIcon", disabled: !isInsertable }))),
                    !editConfig.disableDelete && (React__namespace.createElement("p", { className: "ml-4" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { color: "danger", onClick: onRemove, text: "削除", icon: "TrashIcon" })))))),
        React__namespace.createElement("div", { style: {
                paddingLeft: "3px",
            } },
            React__namespace.createElement("div", { className: "field box", style: {
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    border: "none",
                    borderRadius: 0,
                    borderLeft: "2px solid lightgrey",
                } },
                React__namespace.createElement(FieldTemplate, { config: config, onAdd: console.log, isAddDisabled: true, values: [] }, children)))));
};

var Title = function (_a) {
    var title = _a.title;
    return title ? (React__namespace.createElement("span", { style: {
            overflowWrap: "break-word",
        } }, title)) : (React__namespace.createElement("span", { className: "has-text-grey-lighter" }, "\u672A\u8A2D\u5B9A"));
};

var OptionalTag = function () { return (React__default["default"].createElement("span", { className: "tag is-rounded" }, "\u4EFB\u610F")); };

var BuilderInputFieldTemplateV2 = function (_a) {
    var config = _a.config, onEdit = _a.onEdit, onRemove = _a.onRemove, onCopy = _a.onCopy, children = _a.children, ruleMap = _a.ruleMap, isInsertable = _a.isInsertable;
    var editConfig = useEditConfig(config);
    var markdownProcessor = useMarkdownConfig().markdownProcessor;
    return (React__namespace.createElement("div", { className: "field", style: {
            cursor: "pointer",
        } },
        React__namespace.createElement("div", { className: "level mb-4" },
            React__namespace.createElement("div", { className: "level-left" },
                React__namespace.createElement("div", { className: "level-item tags" },
                    React__namespace.createElement("span", { className: "tag has-text-weight-bold" }, formSchema.typeLabel(config.inputType)),
                    !config.required && !config.hidden && React__namespace.createElement(OptionalTag, null),
                    !config.required && config.hidden && React__namespace.createElement(HiddenTag, null),
                    (ruleMap === null || ruleMap === void 0 ? void 0 : ruleMap.hasThenRule(config.id)) && React__namespace.createElement(ConditionalRuleTag, null))),
            React__namespace.createElement("div", { className: "level-right" },
                React__namespace.createElement("div", { className: "level-item" },
                    !editConfig.disableEdit && (React__namespace.createElement(consoleDesignKit.TextButton, { onClick: onEdit, text: "編集", icon: "EditIcon" })),
                    !editConfig.disableCopy && (React__namespace.createElement("p", { className: "ml-4" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { onClick: onCopy, text: "コピー", icon: "CopyIcon", disabled: !isInsertable }))),
                    !editConfig.disableDelete && (React__namespace.createElement("p", { className: "ml-4" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { color: "danger", onClick: onRemove, text: "削除", icon: "TrashIcon" })))))),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("label", { className: "label", htmlFor: config.id },
                config.label.shouldDisplay && React__namespace.createElement(Title, { title: config.label.text }),
                config.description.shouldDisplay &&
                    (config.description.isMarkdown ? (React__namespace.createElement("div", { className: "help has-text-weight-normal" },
                        React__namespace.createElement(formGenerator.MarkdownStyleWrapper, { value: config.description.text, markdownProcessor: markdownProcessor }))) : (React__namespace.createElement("div", { className: "help has-text-weight-normal", style: {
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                        } }, config.description.text)))),
            React__namespace.createElement("div", { className: "control" }, children))));
};

var COPY_LABEL_SUFFIX = "のコピー";

var MultiFieldCopyDialog = function (_a) {
    var isOpen = _a.isOpen, elementType = _a.elementType, onCancel = _a.onCancel, onProceed = _a.onProceed;
    if (!isOpen) {
        return null;
    }
    return (React__namespace.createElement(consoleDesignKit.DefaultDialog, { title: elementType === "repeatable"
            ? "繰り返し項目のコピー"
            : "セクションのコピー", contents: "\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A\u3084\u81EA\u52D5\u8A08\u7B97\u6570\u5F0F\u306F\u30B3\u30D4\u30FC\u3055\u308C\u307E\u305B\u3093\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u518D\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002", cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB", proceedText: "\u30B3\u30D4\u30FC\u3059\u308B", onCancel: onCancel, onProceed: onProceed }));
};

var Repeatable = function (_a) {
    var ruleMap = _a.ruleMap, schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, moveElement = _a.moveElement, insertElements = _a.insertElements, updateElement = _a.updateElement, removeElement = _a.removeElement, setEditState = _a.setEditState, index = _a.index, e = _a.elem, isFirstChild = _a.isFirstChild, isLastSecondChildIndex = _a.isLastSecondChildIndex, isLastChildIndex = _a.isLastChildIndex, markdownConfig = _a.markdownConfig, props = tslib.__rest(_a, ["ruleMap", "schemaBuilder", "setNewBuilder", "moveElement", "insertElements", "updateElement", "removeElement", "setEditState", "index", "elem", "isFirstChild", "isLastSecondChildIndex", "isLastChildIndex", "markdownConfig"]);
    var editConfigRegistry = useFormEditorContext().editConfigRegistry;
    var editorRegistry = useEditorRegistry();
    var elem = formSchema.RepeatableElement.create(e);
    var editConfig = editConfigRegistry.get(elem);
    var isInsertableInBaseUnit = props.isInsertable && !editConfig.disableInsertion;
    var isInsertableUnderElem = isInsertableInBaseUnit && !isLastChildIndex(index);
    var _b = React__namespace.useState(false), isOpenCopyDialog = _b[0], setIsOpenCopyDialog = _b[1];
    return (React__namespace.createElement(FieldSortableWrapper, { id: elem.id, key: elem.id, index: index, moveCard: moveElement, insertCard: updateElement },
        React__namespace.createElement(BuilderRepeatableFieldTemplateV2, { config: elem, isInsertable: props.isInsertable, onRemove: function () { return removeElement(index); }, onCopy: function () { return setIsOpenCopyDialog(true); }, onEdit: function () {
                return setEditState({
                    type: "element",
                    element: elem,
                    index: index,
                    parent: undefined,
                });
            }, ruleMap: ruleMap },
            elem.baseUnit.map(function (baseUnitElem, baseUnitIndex) {
                var Input = formGenerator.DefaultInputTemplateRegistry.get(baseUnitElem, elem);
                var editConfig = editConfigRegistry.get(baseUnitElem, elem);
                var Wrapper = !editConfig.disableSort
                    ? FieldSortableWrapper
                    : FieldWrapper;
                // 繰り返し要素の子要素の場合にエラーになるため、通常要素に変換してからわたしている
                var baseUnitTmpElem = formSchema.createInputElement(tslib.__assign({}, baseUnitElem));
                var FieldTemplate = editorRegistry.getBuilderFieldTemplate(baseUnitElem, elem) ||
                    BuilderInputFieldTemplateV2;
                return (React__namespace.createElement(Wrapper, { kind: elem.id, id: baseUnitTmpElem.id, key: baseUnitTmpElem.id, index: baseUnitIndex, moveCard: function (a, b) {
                        moveElement(a, b, elem);
                    }, insertCard: function (e, index) {
                        updateElement(e, index, elem);
                    }, repeatable: elem },
                    React__namespace.createElement(FieldTemplate, { ruleMap: ruleMap, config: baseUnitTmpElem, isInsertable: props.isInsertable, onRemove: function () {
                            removeElement(baseUnitIndex, elem);
                        }, onCopy: function () {
                            var copied = baseUnitTmpElem.copy(schemaBuilder.generateId(), COPY_LABEL_SUFFIX);
                            insertElements([copied], baseUnitIndex + 1, elem);
                        }, onEdit: function () {
                            return setEditState({
                                type: "element",
                                element: baseUnitTmpElem,
                                index: baseUnitIndex,
                                parent: elem,
                            });
                        } },
                        React__namespace.createElement(Input, tslib.__assign({ config: baseUnitTmpElem }, NoOpsProps)),
                        isInsertableInBaseUnit && (React__namespace.createElement(AddDropdownMenuBetweenElem, { hideRepeatable: true, hidePostalCode: true, hideCorporateSearch: true, hideDescription: true, hideImage: true, buttonContext: {
                                elem: baseUnitTmpElem,
                                parent: elem,
                                section: schemaBuilder.currentSection,
                            }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                                insertElements(items, baseUnitIndex + 1, elem);
                            }, isUp: isLastChildIndex(index) &&
                                elem.baseUnit.length === baseUnitIndex + 1, markdownConfig: markdownConfig })),
                        !isInsertableInBaseUnit && React__namespace.createElement("hr", null))));
            }),
            isInsertableInBaseUnit && elem.baseUnit.length === 0 && (React__namespace.createElement(AddDropdownMenu, { size: "small", buttonContext: {
                    parent: elem,
                    section: schemaBuilder.currentSection,
                }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, hideRepeatable: true, hidePostalCode: true, hideCorporateSearch: true, hideDescription: true, hideImage: true, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                    insertElements(items, elem.baseUnit.length, elem);
                }, isScrollContainer: true, isUp: isLastChildIndex(index) && !isFirstChild(index), markdownConfig: markdownConfig }))),
        isInsertableUnderElem && (React__namespace.createElement(AddDropdownMenuBetweenElem, { buttonContext: {
                elem: elem,
                section: schemaBuilder.currentSection,
            }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                insertElements(items, index + 1);
            }, isUp: isLastSecondChildIndex(index) && !isFirstChild(index), markdownConfig: markdownConfig })),
        !isInsertableUnderElem && React__namespace.createElement("hr", null),
        isOpenCopyDialog && (React__namespace.createElement(MultiFieldCopyDialog, { isOpen: isOpenCopyDialog, elementType: elem.elementType, onCancel: function () { return setIsOpenCopyDialog(false); }, onProceed: function () {
                var newIds = schemaBuilder.generateUniqueIds(elem.baseUnit.length + 1);
                var copied = elem.copy(newIds, COPY_LABEL_SUFFIX);
                insertElements([copied], index + 1);
                setIsOpenCopyDialog(false);
            } }))));
};

var Input = function (props) {
    var editConfigRegistry = useFormEditorContext().editConfigRegistry;
    var editorRegistry = useEditorRegistry();
    var ruleMap = props.ruleMap, schemaBuilder = props.schemaBuilder, setNewBuilder = props.setNewBuilder, moveElement = props.moveElement, insertElements = props.insertElements, updateElement = props.updateElement, removeElement = props.removeElement, setEditState = props.setEditState, index = props.index, e = props.elem, isFirstChild = props.isFirstChild, isLastSecondChildIndex = props.isLastSecondChildIndex, isLastChildIndex = props.isLastChildIndex, markdownConfig = props.markdownConfig;
    var elem = formSchema.createInputElement(e);
    var editConfig = editConfigRegistry.get(elem);
    var Input = formGenerator.DefaultInputTemplateRegistry.get(elem);
    var Wrapper = !editConfig.disableSort ? FieldSortableWrapper : FieldWrapper;
    var FieldTemplate = editorRegistry.getBuilderFieldTemplate(e) || BuilderInputFieldTemplateV2;
    var isInsertable = props.isInsertable &&
        !editConfig.disableInsertion &&
        !isLastChildIndex(index);
    return (React__namespace.createElement(Wrapper, { id: elem.id, key: elem.id, index: index, moveCard: moveElement, insertCard: updateElement },
        React__namespace.createElement(FieldTemplate, { ruleMap: ruleMap, config: elem, isInsertable: props.isInsertable, onRemove: function () { return removeElement(index); }, onCopy: function () {
                var copied = elem.copy(schemaBuilder.generateId(), COPY_LABEL_SUFFIX);
                insertElements([copied], index + 1);
            }, onEdit: function () {
                return setEditState({
                    type: "element",
                    element: elem,
                    index: index,
                });
            } },
            React__namespace.createElement(Input, tslib.__assign({ config: elem }, NoOpsProps)),
            isInsertable && (React__namespace.createElement(AddDropdownMenuBetweenElem, { buttonContext: {
                    elem: elem,
                    section: schemaBuilder.currentSection,
                }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                    insertElements(items, index + 1);
                }, isUp: isLastSecondChildIndex(index) && !isFirstChild(index), markdownConfig: markdownConfig })),
            !isInsertable && React__namespace.createElement("hr", null))));
};

var BuilderFunctionFieldTemplate = function (_a) {
    var config = _a.config, onEdit = _a.onEdit, onRemove = _a.onRemove, onCopy = _a.onCopy, ruleMap = _a.ruleMap, isInsertable = _a.isInsertable, children = _a.children;
    var editConfig = useEditConfig(config);
    return (React__default["default"].createElement("div", { className: "field", style: {
            cursor: "pointer",
        } },
        React__default["default"].createElement("div", { className: "level mb-4" },
            React__default["default"].createElement("div", { className: "level-left" },
                React__default["default"].createElement("div", { className: "level-item tags" },
                    React__default["default"].createElement("span", { className: "tag has-text-weight-bold" }, formSchema.typeLabel(config.functionType)),
                    config.hidden && React__default["default"].createElement(HiddenTag, null),
                    (ruleMap === null || ruleMap === void 0 ? void 0 : ruleMap.hasThenRule(config.id)) && React__default["default"].createElement(ConditionalRuleTag, null))),
            React__default["default"].createElement("div", { className: "level-right" },
                React__default["default"].createElement("div", { className: "level-item" },
                    !editConfig.disableEdit && (React__default["default"].createElement(consoleDesignKit.TextButton, { onClick: onEdit, text: "編集", icon: "EditIcon" })),
                    !editConfig.disableCopy && (React__default["default"].createElement("p", { className: "ml-4" },
                        React__default["default"].createElement(consoleDesignKit.TextButton, { onClick: onCopy, text: "コピー", icon: "CopyIcon", disabled: !isInsertable }))),
                    !editConfig.disableDelete && (React__default["default"].createElement("p", { className: "ml-4" },
                        React__default["default"].createElement(consoleDesignKit.TextButton, { color: "danger", onClick: onRemove, text: "削除", icon: "TrashIcon" })))))),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label", htmlFor: config.id },
                React__default["default"].createElement(Title, { title: config.label.text })),
            React__default["default"].createElement("div", { className: "control" }, children))));
};

var Function = function (props) {
    var _a;
    var editConfigRegistry = useFormEditorContext().editConfigRegistry;
    var editorRegistry = useEditorRegistry();
    var ruleMap = props.ruleMap, schemaBuilder = props.schemaBuilder, setNewBuilder = props.setNewBuilder, moveElement = props.moveElement, insertElements = props.insertElements, updateElement = props.updateElement, removeElement = props.removeElement, setEditState = props.setEditState, index = props.index, e = props.elem, isFirstChild = props.isFirstChild, isLastSecondChildIndex = props.isLastSecondChildIndex, isLastChildIndex = props.isLastChildIndex, markdownConfig = props.markdownConfig;
    var elem = formSchema.createFunctionElement(e);
    var editConfig = editConfigRegistry.get(elem);
    var Wrapper = !editConfig.disableSort ? FieldSortableWrapper : FieldWrapper;
    var FieldTemplate = (_a = editorRegistry.getBuilderFieldTemplate(elem)) !== null && _a !== void 0 ? _a : BuilderFunctionFieldTemplate;
    var FunctionTemplate = formGenerator.DefaultFunctionTemplateRegistry.get(elem);
    var isInsertable = props.isInsertable &&
        !editConfig.disableInsertion &&
        !isLastChildIndex(index);
    return (React__namespace.createElement(Wrapper, { id: elem.id, key: elem.id, index: index, moveCard: moveElement, insertCard: updateElement },
        React__namespace.createElement(FieldTemplate, { ruleMap: ruleMap, config: elem, isInsertable: props.isInsertable, onRemove: function () { return removeElement(index); }, onCopy: function () {
                var copied = elem.copy(schemaBuilder.generateId(), COPY_LABEL_SUFFIX);
                insertElements([copied], index + 1);
            }, onEdit: function () {
                return setEditState({
                    type: "element",
                    element: elem,
                    index: index,
                });
            } },
            React__namespace.createElement(FunctionTemplate, { config: elem, viewMode: true }),
            isInsertable && (React__namespace.createElement(AddDropdownMenuBetweenElem, { buttonContext: {
                    elem: elem,
                    section: schemaBuilder.currentSection,
                }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                    insertElements(items, index + 1);
                }, isUp: isLastSecondChildIndex(index) && !isFirstChild(index), markdownConfig: markdownConfig })),
            !isInsertable && React__namespace.createElement("hr", null))));
};

var BuilderStaticFieldTemplate = function (_a) {
    var config = _a.config, onEdit = _a.onEdit, onRemove = _a.onRemove, onCopy = _a.onCopy, ruleMap = _a.ruleMap, isInsertable = _a.isInsertable, children = _a.children;
    var editConfig = useEditConfig(config);
    return (React__default["default"].createElement("div", { className: "field", style: {
            cursor: "pointer",
        } },
        React__default["default"].createElement("div", { className: "level mb-4" },
            React__default["default"].createElement("div", { className: "level-left" },
                React__default["default"].createElement("div", { className: "level-item tags" },
                    React__default["default"].createElement("span", { className: "tag has-text-weight-bold" }, formSchema.typeLabel(config.staticType)),
                    config.hidden && React__default["default"].createElement(HiddenTag, null),
                    (ruleMap === null || ruleMap === void 0 ? void 0 : ruleMap.hasThenRule(config.id)) && React__default["default"].createElement(ConditionalRuleTag, null))),
            React__default["default"].createElement("div", { className: "level-right" },
                React__default["default"].createElement("div", { className: "level-item" },
                    !editConfig.disableEdit && (React__default["default"].createElement(consoleDesignKit.TextButton, { onClick: onEdit, text: "編集", icon: "EditIcon" })),
                    !editConfig.disableCopy && (React__default["default"].createElement("p", { className: "ml-4" },
                        React__default["default"].createElement(consoleDesignKit.TextButton, { onClick: onCopy, text: "コピー", icon: "CopyIcon", disabled: !isInsertable }))),
                    !editConfig.disableDelete && (React__default["default"].createElement("p", { className: "ml-4" },
                        React__default["default"].createElement(consoleDesignKit.TextButton, { color: "danger", onClick: onRemove, text: "削除", icon: "TrashIcon" })))))),
        React__default["default"].createElement("div", { className: "field" },
            React__default["default"].createElement("label", { className: "label", htmlFor: config.id },
                React__default["default"].createElement(Title, { title: config.label.text })),
            React__default["default"].createElement("div", { className: "control" }, children))));
};

var Static = function (props) {
    var _a;
    // Functionからコピーした。まとめたい気はする
    var editConfigRegistry = useFormEditorContext().editConfigRegistry;
    var editorRegistry = useEditorRegistry();
    var ruleMap = props.ruleMap, schemaBuilder = props.schemaBuilder, setNewBuilder = props.setNewBuilder, moveElement = props.moveElement, insertElements = props.insertElements, updateElement = props.updateElement, removeElement = props.removeElement, setEditState = props.setEditState, index = props.index, e = props.elem, isFirstChild = props.isFirstChild, isLastSecondChildIndex = props.isLastSecondChildIndex, isLastChildIndex = props.isLastChildIndex, markdownConfig = props.markdownConfig;
    var elem = formSchema.createStaticElement(e);
    var editConfig = editConfigRegistry.get(elem);
    var Wrapper = !editConfig.disableSort ? FieldSortableWrapper : FieldWrapper;
    var FieldTemplate = (_a = editorRegistry.getBuilderFieldTemplate(elem)) !== null && _a !== void 0 ? _a : BuilderStaticFieldTemplate;
    var StaticTemplate = formGenerator.DefaultStaticTemplateRegistry.get(elem);
    var isInsertable = props.isInsertable &&
        !editConfig.disableInsertion &&
        !isLastChildIndex(index);
    return (React__namespace.createElement(Wrapper, { id: elem.id, key: elem.id, index: index, moveCard: moveElement, insertCard: updateElement },
        React__namespace.createElement(FieldTemplate, { ruleMap: ruleMap, config: elem, isInsertable: props.isInsertable, onRemove: function () { return removeElement(index); }, onCopy: function () {
                var copied = elem.copy(schemaBuilder.generateId(), COPY_LABEL_SUFFIX);
                insertElements([copied], index + 1);
            }, onEdit: function () {
                return setEditState({
                    type: "element",
                    element: elem,
                    index: index,
                });
            } },
            React__namespace.createElement(StaticTemplate, { config: elem }),
            isInsertable && (React__namespace.createElement(AddDropdownMenuBetweenElem, { buttonContext: {
                    elem: elem,
                    section: schemaBuilder.currentSection,
                }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                    insertElements(items, index + 1);
                }, isUp: isLastSecondChildIndex(index) && !isFirstChild(index), markdownConfig: markdownConfig })),
            !isInsertable && React__namespace.createElement("hr", null))));
};

var NoOpsProps = {
    value: undefined,
    touched: false,
    error: undefined,
    onChange: console.log,
    onBlur: console.log,
    onFocus: console.log,
    setValue: console.log,
};
var SectionTabContentV2 = function (props) {
    var schemaBuilder = props.schemaBuilder, currentSection = props.currentSection, fieldLimitPerSection = props.fieldLimitPerSection;
    var isFirstChild = function (index) { return index === 0; };
    var isLastChildIndex = function (index) {
        return schemaBuilder.currentSection.children.length - 1 === index;
    };
    var isLastSecondChildIndex = function (index) {
        return schemaBuilder.currentSection.children.length - 2 === index;
    };
    var isInsertable = typeof fieldLimitPerSection === "undefined" ||
        fieldLimitPerSection > currentSection.children.length;
    return (React__namespace.createElement(React__namespace.Fragment, null, currentSection.children.map(function (e, index) {
        return matchType(e.elementType, {
            repeatable: (React__namespace.createElement(Repeatable, tslib.__assign({ key: e.id }, props, { elem: e, index: index, isFirstChild: isFirstChild, isLastChildIndex: isLastChildIndex, isLastSecondChildIndex: isLastSecondChildIndex, isInsertable: isInsertable }))),
            input: (React__namespace.createElement(Input, tslib.__assign({ key: e.id }, props, { elem: e, index: index, isFirstChild: isFirstChild, isLastChildIndex: isLastChildIndex, isLastSecondChildIndex: isLastSecondChildIndex, isInsertable: isInsertable }))),
            function: (React__namespace.createElement(Function, tslib.__assign({ key: e.id }, props, { elem: e, index: index, isFirstChild: isFirstChild, isLastChildIndex: isLastChildIndex, isLastSecondChildIndex: isLastSecondChildIndex, isInsertable: isInsertable }))),
            static: (React__namespace.createElement(Static, tslib.__assign({ key: e.id }, props, { elem: e, index: index, isFirstChild: isFirstChild, isLastChildIndex: isLastChildIndex, isLastSecondChildIndex: isLastSecondChildIndex, isInsertable: isInsertable }))),
        });
    })));
};

function SectionTabSortableWrapper(itemTypes) {
    var SectionTabSortableComponent = function (_a) {
        var index = _a.index, moveCard = _a.moveCard, props = tslib.__rest(_a, ["index", "moveCard"]);
        var ref = React.useRef(null);
        var _b = reactDnd.useDrop({
            accept: itemTypes,
            hover: function (item, monitor) {
                if (!ref.current) {
                    return;
                }
                var dragIndex = item.index;
                var hoverIndex = index;
                if (dragIndex === hoverIndex) {
                    return;
                }
                var hoverBoundingRect = ref.current.getBoundingClientRect();
                var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                var clientOffset = monitor.getClientOffset();
                var hoverClientY = clientOffset.y - hoverBoundingRect.top;
                if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                    return;
                }
                if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                    return;
                }
                moveCard(dragIndex, hoverIndex);
                item.index = hoverIndex;
            },
        }), drop = _b[1];
        var _c = reactDnd.useDrag({
            type: itemTypes,
            item: { index: index },
            collect: function (monitor) { return ({
                isDragging: monitor.isDragging(),
            }); },
        }), isDragging = _c[0].isDragging, drag = _c[1];
        var opacity = isDragging ? 0 : 1;
        drag(drop(ref));
        return (React__namespace.createElement("div", { ref: ref, style: { opacity: opacity } }, props.children));
    };
    return SectionTabSortableComponent;
}
var SectionTabSortable = SectionTabSortableWrapper("section_tab");
var SortableListItem = function (_a) {
    var className = _a.className, onClick = _a.onClick, children = _a.children, props = tslib.__rest(_a, ["className", "onClick", "children"]);
    return (React__namespace.createElement(SectionTabSortable, tslib.__assign({}, props),
        React__namespace.createElement("li", { className: className, onClick: onClick }, children)));
};
var DisableSortListItem = function (_a) {
    var className = _a.className, onClick = _a.onClick, children = _a.children;
    return (React__namespace.createElement("div", null,
        React__namespace.createElement("li", { className: className, onClick: onClick }, children)));
};
var SectionTabs = function (_a) {
    var sections = _a.sections, currentSection = _a.currentSection, isSectionAddable = _a.isSectionAddable, onClick = _a.onClick, onAdd = _a.onAdd, moveSection = _a.moveSection;
    var editConfigRegistry = useEditConfigRegistry();
    return (React__namespace.createElement("div", { className: "tabs" },
        React__namespace.createElement("ul", null,
            sections.map(function (sect, index) {
                var sectionEditConfig = editConfigRegistry.getSectionEditConfig(sect);
                var ListItemComponent = sectionEditConfig.disableSort
                    ? DisableSortListItem
                    : SortableListItem;
                return (React__namespace.createElement(ListItemComponent, { index: index, key: sect.id, moveCard: moveSection, className: "".concat(sect.id === currentSection.id ? "is-active" : ""), onClick: function () { return onClick(index); } },
                    React__namespace.createElement("a", null, index + 1)));
            }),
            isSectionAddable && (React__namespace.createElement("li", { onClick: onAdd },
                React__namespace.createElement("a", { className: "is-paddingless is-marginless", style: {
                        border: "none",
                    } },
                    React__namespace.createElement("span", { className: "icon" },
                        React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faPlus }))))))));
};

var FormListPaneV2 = function (_a) {
    var schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, setEditState = _a.setEditState, CustomComponent = _a.CustomComponent, changeSection = _a.changeSection, moveSection = _a.moveSection, insertSection = _a.insertSection, sectionLimit = _a.sectionLimit, markdownConfig = _a.markdownConfig, props = tslib.__rest(_a, ["schemaBuilder", "setNewBuilder", "setEditState", "CustomComponent", "changeSection", "moveSection", "insertSection", "sectionLimit", "markdownConfig"]);
    var isSectionEditable = !CustomComponent;
    var editConfigRegistry = useEditConfigRegistry();
    var currentSection = schemaBuilder.currentSection;
    var sectionEditConfig = editConfigRegistry.getSectionEditConfig(currentSection);
    var isElemAddable = !sectionEditConfig.disableAdd &&
        (typeof props.fieldLimitPerSection === "undefined" ||
            props.fieldLimitPerSection > currentSection.children.length);
    var isSectionAddable = typeof sectionLimit === "undefined" ||
        sectionLimit > schemaBuilder.currentSchema().root.length;
    var _b = React__namespace.useState(false), isOpenCopyDialog = _b[0], setIsOpenCopyDialog = _b[1];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "box", style: { borderRadius: 0 } },
            sectionLimit !== 1 && (React__namespace.createElement(SectionTabs, { sections: schemaBuilder.currentSchema().root, currentSection: currentSection, isSectionAddable: isSectionAddable, onClick: function (index) { return changeSection(schemaBuilder, index); }, moveSection: moveSection, onAdd: function () {
                    var added = schemaBuilder.addSection();
                    changeSection(added, added.sectionCount - 1);
                    setEditState({
                        type: "section",
                        element: added.currentSchema().root[added.sectionCount - 1],
                        sectIndex: added.sectionCount - 1,
                    });
                } })),
            React__namespace.createElement("div", { className: "field mb-5" }, isSectionEditable && (React__namespace.createElement("div", { className: "columns is-vcentered is-mobile is-paddingless is-marginless" },
                React__namespace.createElement("div", { className: "column is-marginless is-paddingless" },
                    React__namespace.createElement("div", { className: "title is-size-5" },
                        React__namespace.createElement(Title, { title: currentSection.title }))),
                React__namespace.createElement("div", { className: "column is-narrow is-flex is-align-items-center is-flex-wrap-wrap is-right is-marginless is-paddingless" },
                    !sectionEditConfig.disableEdit && (React__namespace.createElement(consoleDesignKit.TextButton, { onClick: function () {
                            setEditState({
                                type: "section",
                                element: currentSection,
                                sectIndex: schemaBuilder.currentSectIndex,
                            });
                        }, text: "編集", icon: "EditIcon" })),
                    !sectionEditConfig.disableCopy && (React__namespace.createElement("p", { className: "ml-4" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { onClick: function () { return setIsOpenCopyDialog(true); }, text: "コピー", icon: "CopyIcon", disabled: !isSectionAddable }))),
                    !sectionEditConfig.disableDelete &&
                        schemaBuilder.isSectionRemovable() && (React__namespace.createElement("p", { className: "ml-4" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { color: "danger", onClick: function () {
                                setNewBuilder(schemaBuilder.removeCurrentSection());
                                setEditState(undefined);
                            }, text: "セクションを削除", icon: "TrashIcon" }))))))),
            React__namespace.createElement("div", null,
                React__namespace.createElement("div", { style: {
                        overflow: "auto",
                        maxHeight: "900px",
                        minHeight: schemaBuilder.currentSection.children.length === 1
                            ? "20em"
                            : undefined,
                    } }, matchType(CustomComponent ? "custom" : "default", {
                    default: (React__namespace.createElement(SectionTabContentV2, tslib.__assign({ schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, setEditState: setEditState, markdownConfig: markdownConfig }, props))),
                    custom: CustomComponent && (React__namespace.createElement(CustomComponent, { formSchema: schemaBuilder.currentSchema(), section: schemaBuilder.currentSection, onChange: function (fs) {
                            setNewBuilder(formSchema.SchemaBuilder.fromSchema(fs));
                        } })),
                })))),
        isElemAddable && (React__namespace.createElement(AddDropdownMenu, { buttonContext: {
                section: schemaBuilder.currentSection,
            }, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, generateUniqueId: function () { return schemaBuilder.generateId(); }, onClick: function (items) {
                if (CustomComponent) {
                    alert("選択中のセクションには要素を追加できません");
                    return;
                }
                props.insertElements(items, schemaBuilder.currentSection.children.length);
            }, isUp: schemaBuilder.currentSection.children.length > 0, markdownConfig: markdownConfig })),
        isOpenCopyDialog && (React__namespace.createElement(MultiFieldCopyDialog, { isOpen: isOpenCopyDialog, elementType: currentSection.elementType, onCancel: function () { return setIsOpenCopyDialog(false); }, onProceed: function () {
                var current = new formSchema.SectionElement(currentSection);
                var copiedSection = current.copy(function (count) { return schemaBuilder.generateUniqueIds(count); }, COPY_LABEL_SUFFIX);
                insertSection(schemaBuilder, copiedSection, schemaBuilder.currentSectIndex + 1);
                setIsOpenCopyDialog(false);
            } }))));
};

var FormulasList = function (_a) {
    var formSchema = _a.formSchema, onAdd = _a.onAdd, isAddable = _a.isAddable, onDelete = _a.onDelete, onEdit = _a.onEdit;
    var formulas = formSchema.getFormulas();
    return (React__namespace.createElement("div", null,
        formulas.map(function (f, index) {
            return (React__namespace.createElement("div", { key: index, className: "columns is-vcentered is-marginless mb-4", style: {
                    borderBottom: "1px solid lightgrey",
                } },
                React__namespace.createElement("div", { className: "column" },
                    React__namespace.createElement("p", { style: {
                            wordBreak: "break-all",
                        } }, f.formula)),
                React__namespace.createElement("div", { className: "column is-narrow has-text-right is-flex is-align-items-center is-flex-wrap-wrap" },
                    React__namespace.createElement(consoleDesignKit.TextButton, { onClick: function () { return onEdit(index); }, text: "編集", icon: "EditIcon" }),
                    React__namespace.createElement("p", { className: "ml-5" },
                        React__namespace.createElement(consoleDesignKit.TextButton, { color: "danger", onClick: function () { return onDelete(index); }, text: "削除", icon: "TrashIcon" })))));
        }),
        formulas.length === 0 ? (React__namespace.createElement(NoResource, { title: "\u6570\u5F0F\u306F\u307E\u3060\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093", subtitle: React__namespace.createElement(React__namespace.Fragment, null,
                "\u8FFD\u52A0\u30DC\u30BF\u30F3\u3088\u308A\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
                React__namespace.createElement("br", null),
                React__namespace.createElement("br", null),
                React__namespace.createElement("button", { className: "button is-info is-outlined is-rounded", onClick: onAdd }, "\u8FFD\u52A0\u3059\u308B")) })) : (isAddable && (React__namespace.createElement("button", { className: "button is-fullwidth", onClick: onAdd }, "\u8FFD\u52A0\u3059\u308B")))));
};

var FormulasReadonlyList = function (_a) {
    var formSchema = _a.formSchema, onEdit = _a.onEdit;
    var formulas = formSchema.getFormulas();
    return (React__namespace.createElement(React__namespace.Fragment, null,
        formulas.map(function (f, index) {
            return (React__namespace.createElement("div", { key: "FormulasReadonlyList-".concat(index), className: "columns is-vcentered is-marginless mb-4", style: {
                    borderBottom: "1px solid lightgrey",
                } },
                React__namespace.createElement("div", { className: "column" },
                    React__namespace.createElement("p", { style: {
                            wordBreak: "break-all",
                        } }, f.formula)),
                React__namespace.createElement("div", { className: "column is-narrow has-text-right is-flex is-align-items-center is-flex-wrap-wrap" },
                    React__namespace.createElement(consoleDesignKit.TextButton, { onClick: function () { return onEdit(index); }, text: "詳細", icon: "EditIcon" }))));
        }),
        formulas.length === 0 && (React__namespace.createElement(NoResource, { title: "", subtitle: React__namespace.createElement("p", null, "\u6570\u5F0F\u306F\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093") }))));
};

var Tab = function (_a) {
    var tabs = _a.tabs, tabState = _a.tabState, setTabState = _a.setTabState;
    return (React__namespace.createElement("div", { className: "tabs" },
        React__namespace.createElement("ul", null, tabs.map(function (tab) { return (React__namespace.createElement(TabItem, { key: String(tab.literal), tabLiteral: tab.literal, tabLabel: tab.label, tabState: tabState, setTabState: setTabState })); }))));
};
var TabItem = function (_a) {
    var tabLiteral = _a.tabLiteral, tabLabel = _a.tabLabel, tabState = _a.tabState, setTabState = _a.setTabState;
    return (React__namespace.createElement("li", { className: classNames__default["default"]("", {
            "is-active": tabState === tabLiteral,
        }), onClick: function () {
            setTabState(tabLiteral);
        } },
        React__namespace.createElement("a", null, tabLabel)));
};

var ElementList = function (_a) {
    var elements = _a.elements, onSelectElement = _a.onSelectElement;
    return (React__namespace.createElement("div", { className: "table-container", style: { overflowY: "auto", maxHeight: "250px" } },
        React__namespace.createElement("table", { className: "table is-striped is-hoverable is-fullwidth" },
            React__namespace.createElement("thead", null,
                React__namespace.createElement("tr", null,
                    React__namespace.createElement("th", { style: {
                            width: "50%",
                        } }, "\u9805\u76EE\u540D"),
                    React__namespace.createElement("th", null, "\u9805\u76EEID"),
                    React__namespace.createElement("th", null, "\u9805\u76EE\u30BF\u30A4\u30D7"))),
            React__namespace.createElement("tbody", null, elements.map(function (e) { return (React__namespace.createElement("tr", { key: e.formFieldId, onClick: function () { return onSelectElement(e.formFieldId); }, className: "is-clickable" },
                React__namespace.createElement("td", null, e.label.text),
                React__namespace.createElement("td", null, e.formFieldId),
                React__namespace.createElement("td", { style: {
                        whiteSpace: "nowrap",
                    } }, formSchema.typeLabel(e.inputType)))); })))));
};

var OptionList = function (_a) {
    var elements = _a.elements, onSelectOption = _a.onSelectOption, onSelectElement = _a.onSelectElement;
    return (React__namespace.createElement("div", { className: "table-container", style: { overflowY: "auto", maxHeight: "250px" } },
        React__namespace.createElement("table", { className: "table is-fullwidth" },
            React__namespace.createElement("tbody", null, elements.map(function (e) { return (React__namespace.createElement("tr", { key: e.formFieldId },
                React__namespace.createElement("td", { className: "py-4" },
                    React__namespace.createElement("div", { className: "level mb-3" },
                        React__namespace.createElement("div", { className: "level-left" },
                            React__namespace.createElement("div", { className: "level-item is-flex is-align-items-baseline" },
                                React__namespace.createElement("p", { className: "is-size-6 has-text-weight-bold" }, e.label.text),
                                React__namespace.createElement("p", { className: "is-size-7 ml-2" }, e.formFieldId),
                                React__namespace.createElement("p", { className: "is-size-7 ml-2" }, formSchema.typeLabel(e.inputType)))),
                        React__namespace.createElement("div", { className: "level-right" },
                            React__namespace.createElement("button", { className: "button is-small has-background-white has-text-dark", onClick: function () { return onSelectElement(e.formFieldId); } }, "\u9805\u76EE\u3092\u6570\u5F0F\u3078\u8FFD\u52A0"))),
                    React__namespace.createElement("div", { className: "tags mt-2" }, e.enum.map(function (_a) {
                        var label = _a.text, value = _a.value;
                        return (React__namespace.createElement("button", { className: "tag is-medium", key: "".concat(e.formFieldId, "-").concat(value), onClick: function () { return onSelectOption(value); } }, label === value ? label : label + ":" + value));
                    }))))); })))));
};

/**
 * 計算結果を確認するためのFormGeneratorViewPropsを返すProps
 * 数式にて参照されている項目のみにフィルタされ、hidden属性をtrueにする
 */
var useFilteredVisibleFormGenViewModel = function (formSchema$1, formula, formSubmissionContext) {
    var _a = React__namespace.useState(null), formGenProps = _a[0], setFormGenProps = _a[1];
    React__namespace.useEffect(function () {
        var variables;
        try {
            variables = new formSchema.Formula(formula).getVariables(formSchema$1);
        }
        catch (_) {
            variables = [];
        }
        var schema = formSchema.FormSchema.fromJSON(new formSchema.FormSchemaConverter(formSchema$1).filteredVisibleFormSchema(variables));
        var viewModel = new formGenerator.FormGeneratorViewModel(schema, schema.toInitialDocument(), {}, [], {}, function () { return ({}); }, formSubmissionContext);
        setFormGenProps(viewModel.getProps());
        viewModel.setOnUpdated(function (props) {
            setFormGenProps(props);
        });
    }, [formula.formula]);
    var _b = React__namespace.useMemo(function () {
        if (!formGenProps) {
            return [null, null];
        }
        try {
            return formSchema.Formula.fromJSON(formula).evaluate(formGenProps.values, formGenProps.formSchema, {
                useCache: true,
                suppressError: true,
            });
        }
        catch (e) {
            return [null, e];
        }
    }, [formula, formGenProps]), formulaResult = _b[0], formulaError = _b[1];
    return {
        formGenProps: formGenProps,
        formulaResult: formulaResult,
        formulaError: formulaError,
    };
};

/*
form-generator内に同様の関数があるため表示処理の修正の場合はそちらも修正する
*/
var separateFormulaResultByComma = function (value) {
    // 小数点以下の桁をカンマ区切りにする表記は一般的でないため、小数点以下はそのまま表示する
    if (!value) {
        return "";
    }
    var _a = value.split("."), integer = _a[0], decimal = _a[1];
    var separatedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decimal ? "".concat(separatedInteger, ".").concat(decimal) : separatedInteger;
};

var FormulaPreview = function (_a) {
    var formSchema$1 = _a.formSchema, formula = _a.formula;
    var formSubmissionContext = React__namespace.useMemo(formGenerator.defaultFormSubmissionContext, []);
    var _b = useFilteredVisibleFormGenViewModel(formSchema$1, formula, formSubmissionContext), formGenProps = _b.formGenProps, formulaResult = _b.formulaResult, formulaError = _b.formulaError;
    var markdownConfig = useMarkdownConfig();
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns my-0 has-text-weight-bold" },
            React__namespace.createElement("div", { className: "column is-4 is-flex is-size-4-mobile is-size-4-desktop" },
                React__namespace.createElement("span", { style: { marginTop: "auto" } }, "\u8A08\u7B97\u7D50\u679C")),
            React__namespace.createElement("div", { className: "column is-8 py-1 has-text-right" }, formulaError !== null ? (React__namespace.createElement("span", { className: "help has-text-weight-normal is-danger" }, formSchema.FormulaValidator.toErrorMessage(formulaError))) : (React__namespace.createElement("span", { className: "is-size-3-mobile is-size-3-desktop" }, separateFormulaResultByComma(formulaResult))))),
        React__namespace.createElement("hr", null),
        formGenProps && (React__namespace.createElement(formGenerator.FormGeneratorV2, tslib.__assign({}, formGenProps, { submissionContext: formSubmissionContext, markdownConfig: markdownConfig })))));
};

var TabTypes = {
    Element: "ELEMENT",
    Option: "OPTION",
    Preview: "PREVIEW",
};
var FormulaEditorView = function (_a) {
    var formula = _a.formula, formSchema$1 = _a.formSchema, setFormulaValue = _a.setFormulaValue, viewMode = _a.viewMode;
    var _b = React.useState(TabTypes.Element), tabState = _b[0], setTabState = _b[1];
    var _c = React.useState(new formSchema.FormulaValidator(formSchema$1)), schemaValidator = _c[0], setValidator = _c[1];
    React.useEffect(function () {
        setValidator(new formSchema.FormulaValidator(formSchema$1));
    }, [formSchema$1]);
    var _d = React.useState(), selection = _d[0], setSelection = _d[1];
    var textAreaRef = React.useRef(null);
    React.useEffect(function () {
        if (!selection || !textAreaRef.current) {
            return;
        }
        textAreaRef.current.focus();
        textAreaRef.current.setSelectionRange(selection, selection);
    }, [selection]);
    var getSubstrings = React.useCallback(function () {
        if (textAreaRef.current !== null) {
            var currentSelection = textAreaRef.current.selectionStart;
            var value = textAreaRef.current.value;
            return {
                forward: value.substring(0, currentSelection),
                backward: value.substring(currentSelection, value.length),
            };
        }
        return;
    }, [textAreaRef]);
    var elements = React.useMemo(function () { return formSchema.FormSchema.fromJSON(formSchema$1).flattenDeep(); }, [formSchema$1]);
    var onSelectElement = React.useCallback(function (formFieldId) {
        var substrings = getSubstrings();
        if (substrings) {
            var forward = substrings.forward, backward = substrings.backward;
            setFormulaValue(tslib.__assign(tslib.__assign({}, formula), { formula: "".concat(forward, "{{").concat(formFieldId, "}}").concat(backward) }));
            setSelection("".concat(forward, "{{").concat(formFieldId, "}}").length);
        }
    }, [getSubstrings, formula, setFormulaValue]);
    var onSelectOption = React.useCallback(function (option) {
        var substrings = getSubstrings();
        if (substrings) {
            var forward = substrings.forward, backward = substrings.backward;
            setFormulaValue(tslib.__assign(tslib.__assign({}, formula), { formula: "".concat(forward, "\"").concat(option, "\"").concat(backward) }));
            setSelection("".concat(forward, "\"").concat(option, "\"").length);
        }
    }, [getSubstrings, formula, setFormulaValue]);
    return (React__namespace.createElement("div", null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("div", { className: "label" }, "\u6570\u5F0FID"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("input", { className: "input", type: "text", value: formula.id, disabled: true }))),
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("div", { className: "label" }, "\u81EA\u52D5\u8A08\u7B97\u6570\u5F0F"),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("textarea", { ref: textAreaRef, className: "textarea", value: formula.formula, disabled: viewMode === "READONLY", onChange: function (e) {
                        return setFormulaValue(tslib.__assign(tslib.__assign({}, formula), { formula: e.target.value }));
                    } })),
            React__namespace.createElement(ErrorMessage$1, { msg: schemaValidator.checkFormula(formula) })),
        React__namespace.createElement(Tab, { tabs: [
                { literal: TabTypes.Element, label: "項目" },
                { literal: TabTypes.Option, label: "選択肢" },
                { literal: TabTypes.Preview, label: "検証" },
            ], tabState: tabState, setTabState: setTabState }),
        matchType(tabState, {
            ELEMENT: (React__namespace.createElement(ElementList, { elements: elements.filter(formSchema.isInputClassElement), onSelectElement: onSelectElement })),
            OPTION: (React__namespace.createElement(OptionList, { elements: elements.filter(function (e) { return formSchema.isInputClassElement(e) && formSchema.isSelectableClassElement(e); }), onSelectOption: onSelectOption, onSelectElement: onSelectElement })),
            PREVIEW: React__namespace.createElement(FormulaPreview, { formula: formula, formSchema: formSchema$1 }),
        })));
};

var FormulaEditor = function (_a) {
    var formula = _a.formula, formSchema$1 = _a.formSchema, _b = _a.viewMode, viewMode = _b === void 0 ? "EDITABLE" : _b, onClose = _a.onClose, onSave = _a.onSave;
    var _c = React.useState(JSON.parse(JSON.stringify(formula))), formulaValue = _c[0], setFormulaValue = _c[1];
    var _d = React.useState(new formSchema.FormulaValidator(formSchema$1)), schemaValidator = _d[0], setValidator = _d[1];
    React.useEffect(function () {
        setValidator(new formSchema.FormulaValidator(formSchema$1));
    }, [formSchema$1]);
    return (React__namespace.createElement("div", null,
        React__namespace.createElement("div", { className: "level", style: { marginBottom: 0 } },
            React__namespace.createElement("div", { className: "level-right" }),
            React__namespace.createElement("div", { className: "level-right" },
                React__namespace.createElement("div", { className: "level-item buttons" },
                    React__namespace.createElement("button", { className: "button is-outlined", onClick: onClose }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                    viewMode === "EDITABLE" && (React__namespace.createElement("button", { className: "button is-outlined", onClick: function () {
                            onSave(formulaValue);
                        }, disabled: !!schemaValidator.checkFormula(formulaValue) ||
                            JSON.stringify(formula) === JSON.stringify(formulaValue) }, "\u4FDD\u5B58"))))),
        React__namespace.createElement(FormulaEditorView, { formSchema: formSchema$1, formula: formulaValue, setFormulaValue: setFormulaValue, viewMode: viewMode })));
};

var FormulaListComponent = function (_a) {
    var schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, setEditState = _a.setEditState;
    var _b = useAddingState(), addingState = _b.addingState, setAddingState = _b.setAddingState, finishAddingState = _b.finishAddingState;
    var _c = React__namespace.useState(true), showNotification = _c[0], setShowNotification = _c[1];
    var _d = useFormEditorContext().formulaViewMode, viewMode = _d === void 0 ? "EDITABLE" : _d;
    var onEditState = function (idx) {
        setEditState({
            type: "formula",
            index: idx,
            element: schemaBuilder.currentSchema().formulaSet.formulas[idx],
        });
    };
    return (React__namespace.createElement(React__namespace.Fragment, null,
        matcher.matchType(viewMode, {
            EDITABLE: (React__namespace.createElement(React__namespace.Fragment, null,
                showNotification && viewMode === "EDITABLE" && (React__namespace.createElement("div", { className: "notification is-link is-light" },
                    React__namespace.createElement("button", { className: "delete", onClick: function () { return setShowNotification(false); } }),
                    "\u8A08\u7B97\u7D50\u679C\u306F\u5C0F\u6570\u7B2C20\u4F4D\u307E\u3067\u8A08\u7B97\u3055\u308C\u3001\u5C0F\u6570\u7B2C21\u4F4D\u304C\u56DB\u6368\u4E94\u5165\u3055\u308C\u307E\u3059\u3002",
                    React__namespace.createElement("br", null),
                    "\u3064\u307E\u308A\u3001",
                    React__namespace.createElement("strong", null, "2/3"),
                    "\u3092\u8A08\u7B97\u3059\u308B\u3068",
                    React__namespace.createElement("strong", null, "0.66666666666666666667"),
                    "\u306B\u306A\u308A\u307E\u3059\u3002",
                    React__namespace.createElement("br", null),
                    "\u3053\u306E\u3088\u3046\u306A\u5834\u5408\u306F\u5B9F\u969B\u306E\u5024\u3068\u306E\u8AA4\u5DEE\u304C\u751F\u3058\u308B\u306E\u3067\u3001\u95A2\u6570\u3092\u4F7F\u3063\u3066\u610F\u56F3\u3057\u305F\u5024\u306B\u4E38\u3081\u3066\u304F\u3060\u3055\u3044\u3002",
                    React__namespace.createElement("br", null),
                    "\u4F8B\u3048\u3070\u3001",
                    React__namespace.createElement("strong", null, "round(2/3,2)"),
                    "\u3068\u3059\u308B\u3053\u3068\u3067\u5C0F\u6570\u7B2C3\u4F4D\u304C\u56DB\u6368\u4E94\u5165\u3055\u308C",
                    React__namespace.createElement("strong", null, "0.67"),
                    "\u306B\u306A\u308A\u307E\u3059\u3002")),
                React__namespace.createElement(FormulasList, { formSchema: schemaBuilder.currentSchema(), isAddable: true, onAdd: function () {
                        setAddingState({
                            state: {
                                id: schemaBuilder.generateId(),
                                formula: "",
                            },
                        });
                    }, onEdit: onEditState, onDelete: function (idx) {
                        setNewBuilder(schemaBuilder.removeFormulaByIndex(idx));
                    } }))),
            READONLY: (React__namespace.createElement(FormulasReadonlyList, { formSchema: schemaBuilder.currentSchema(), onEdit: onEditState })),
        }),
        addingState && (React__namespace.createElement("div", { className: "modal is-active" },
            React__namespace.createElement("div", { className: "modal-background" }),
            React__namespace.createElement("section", { className: "modal-content box" },
                React__namespace.createElement(FormulaEditor, { formSchema: schemaBuilder.currentSchema(), formula: addingState.state, onSave: function (formula) {
                        setNewBuilder(schemaBuilder.addFormula(formula));
                        finishAddingState();
                    }, onClose: finishAddingState }))))));
};

var ConditionalRulesReadonlyList = function (_a) {
    var formSchema$1 = _a.formSchema, onShowDetail = _a.onShowDetail, _b = _a.shouldHide, shouldHide = _b === void 0 ? function () { return false; } : _b;
    var converter = new formSchema.FormSchemaConverter(formSchema$1);
    var ifCandidates = converter.ifCandidates();
    var conditionalRules = formSchema$1.getConditionalRules();
    return (React__namespace.createElement("div", null,
        conditionalRules.map(function (r, index) {
            if (shouldHide(r, index)) {
                return null;
            }
            var key = JSON.stringify(r) + index.toString();
            return (React__namespace.createElement("div", { key: index, id: key, className: "columns is-vcentered is-marginless mb-4", style: {
                    borderBottom: "1px solid lightgrey",
                    cursor: "pointer",
                } },
                React__namespace.createElement("div", { className: "column is-narrow" },
                    React__namespace.createElement("span", { className: "has-text-weight-bold is-size-5" }, index + 1)),
                React__namespace.createElement("div", { className: "column" },
                    React__namespace.createElement("p", null,
                        React__namespace.createElement(IfConditionsViewer, { ifConditions: r.if, ifCandidates: ifCandidates })),
                    React__namespace.createElement("p", null,
                        React__namespace.createElement(ThenRuleViewer, { thenRule: r.then.rules, thenCandidates: converter.flatten() }))),
                React__namespace.createElement("div", { className: "column is-narrow has-text-right is-flex is-align-items-center is-flex-wrap-wrap" },
                    React__namespace.createElement(consoleDesignKit.TextButton, { onClick: function () { return onShowDetail(index); }, text: "詳細", icon: "EditIcon" }))));
        }),
        conditionalRules.filter(function (r, idx) { return !shouldHide(r, idx); }).length ===
            0 && (React__namespace.createElement(NoResource, { title: "", subtitle: React__namespace.createElement("p", null, "\u6761\u4EF6\u5206\u5C90\u30EB\u30FC\u30EB\u306F\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002") }))));
};

var ConditionalRulesListComponent = function (_a) {
    var schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, setEditState = _a.setEditState;
    var _b = useFormEditorContext(), shouldHide = _b.shouldHide, insertRuleIndex = _b.insertRuleIndex, _c = _b.thenInputFilter, thenInputFilter = _c === void 0 ? function () { return true; } : _c, _d = _b.conditionalRuleViewMode, viewMode = _d === void 0 ? "EDITABLE" : _d;
    var _e = useAddingState(), addingState = _e.addingState, setAddingState = _e.setAddingState, finishAddingState = _e.finishAddingState;
    var onEdit = function (idx) {
        setEditState({
            type: "conditional_rule",
            element: schemaBuilder.currentSchema().conditionalRuleSet.conditionalRules[idx],
            index: idx,
        });
    };
    return (React__namespace.createElement(React__namespace.Fragment, null,
        matchType(viewMode, {
            EDITABLE: (React__namespace.createElement(ConditionalRulesList, { schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, formSchema: schemaBuilder.currentSchema(), shouldHide: shouldHide, isAddable: formSchema.ConditionalFactory.checkRuleAddable(schemaBuilder.currentSchema(), thenInputFilter), onAdd: function () {
                    var initial = formSchema.ConditionalFactory.createNewInitialRule(schemaBuilder.currentSchema(), thenInputFilter);
                    setAddingState({
                        state: initial,
                    });
                }, onEdit: onEdit, onDelete: function (idx) {
                    setNewBuilder(schemaBuilder.removeRuleByIndex(idx));
                } })),
            READONLY: (React__namespace.createElement(ConditionalRulesReadonlyList, { formSchema: schemaBuilder.currentSchema(), shouldHide: shouldHide, onShowDetail: onEdit })),
        }),
        addingState && (React__namespace.createElement("div", { className: "modal is-active" },
            React__namespace.createElement("div", { className: "modal-background" }),
            React__namespace.createElement("section", { className: "modal-content box" },
                React__namespace.createElement(ConditionalRuleEditor, { formSchema: schemaBuilder.currentSchema(), rule: addingState.state, onSave: function (r) {
                        if (insertRuleIndex !== undefined) {
                            setNewBuilder(schemaBuilder.insertRule(r, insertRuleIndex));
                        }
                        else {
                            setNewBuilder(schemaBuilder.addRule(r));
                        }
                        finishAddingState();
                    }, onClose: finishAddingState }))))));
};

var EditorBox = function (_a) {
    var children = _a.children;
    return (React__namespace.createElement("div", { className: "box", style: {
            borderRadius: 0,
        }, "data-testid": TEST_ID.EditorBox }, children));
};

var ConditionalRuleEditorRightPane = function (_a) {
    var formSchema$1 = _a.formSchema, editingElement = _a.editingElement, rule = _a.rule, ruleIndex = _a.ruleIndex, onSave = _a.onSave, onClose = _a.onClose;
    var _b = React.useState(JSON.parse(JSON.stringify(rule))), currentRule = _b[0], setCurrentRule = _b[1];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "level mb-1", style: { marginBottom: 0 } },
            React__namespace.createElement("div", { className: "level-left" },
                React__namespace.createElement("p", { className: "title is-size-5" },
                    "\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A # ",
                    ruleIndex !== undefined ? ruleIndex + 1 : "")),
            React__namespace.createElement("div", { className: "level-right" },
                React__namespace.createElement("div", { className: "level-item buttons" },
                    onClose && (React__namespace.createElement("button", { className: "button is-outlined", onClick: onClose }, "\u9589\u3058\u308B")),
                    React__namespace.createElement("button", { className: "button is-outlined", onClick: function () {
                            onSave(currentRule);
                        }, disabled: !new formSchema.ConditionalRuleValidator(formSchema$1).checkRule(currentRule) || JSON.stringify(rule) === JSON.stringify(currentRule) }, "\u4FDD\u5B58\u3059\u308B")))),
        React__namespace.createElement(ConditionalRuleEditorView, { editingElement: editingElement, formSchema: formSchema$1, rule: currentRule, onUpdate: setCurrentRule })));
};

function useDirty(initialValue) {
    var _a = React.useState(initialValue), initial = _a[0], setState = _a[1];
    return {
        isDirty: function (currentValue) {
            return JSON.stringify(currentValue) !== JSON.stringify(initial);
        },
        setNewInitialState: setState,
    };
}

var ElementTags = function (_a) {
    var element = _a.element;
    return (React__default["default"].createElement("div", { className: "field is-grouped is-grouped-multiline" },
        React__default["default"].createElement("div", { className: "control" },
            React__default["default"].createElement("div", { className: "tags has-addons" },
                React__default["default"].createElement("span", { className: "tag is-light" }, "\u9805\u76EEID"),
                React__default["default"].createElement("span", { className: "tag is-link is-light" }, element.id))),
        React__default["default"].createElement("div", { className: "control" },
            React__default["default"].createElement("div", { className: "tags has-addons" },
                React__default["default"].createElement("span", { className: "tag" }, formSchema.typeLabel(formSchema.isInputElement(element)
                    ? element.inputType
                    : formSchema.isFunctionElement(element)
                        ? element.functionType
                        : formSchema.isStaticElement(element)
                            ? element.staticType
                            : element.elementType))))));
};

/**
 * 新しいenumでfilterされたpdfAdapterRuleを返す
 * */
var filterAdapterRuleWithNewEnum = function (initialPdfAdapterRule, newEnum) {
    var filteredAreas = tslib.__spreadArray([], initialPdfAdapterRule.areas, true).filter(function (area) {
        return newEnum.some(function (e) { return e.value === area.value; });
    });
    if (filteredAreas.length === 0) {
        return undefined;
    }
    return tslib.__assign(tslib.__assign({}, initialPdfAdapterRule), { areas: filteredAreas });
};
var filterSelectableParentAdapter = function (initialPdfAdapterRule, newEnum) {
    // TODO isSelectableAdapterRuleにTextAdapterRuleを含めるようにしたらisSelectableAdapterRuleだけを使用する
    if (!formSchema.isSelectableAdapterRule(initialPdfAdapterRule) &&
        initialPdfAdapterRule.type !== "text") {
        throw new Error("pdfAdapterRule has to be either TextAdapterRule, EllipseAdapterRule or CheckAdapterRule");
    }
    return filterAdapterRuleWithNewEnum(initialPdfAdapterRule, newEnum);
};
/**
 * repeatableのschemaAtIndexから古いvalueを持ったareaを削除する
 * */
var filterOverrideSchemaWithNewEnum = function (overrideSchemas, unitIndex, newEnum) {
    var _a;
    if (!overrideSchemas) {
        return undefined;
    }
    var initialPdfAdapterRule = (_a = overrideSchemas[unitIndex]) === null || _a === void 0 ? void 0 : _a.pdfAdapterRule;
    if (!initialPdfAdapterRule) {
        return tslib.__spreadArray([], overrideSchemas, true);
    }
    var newPdfAdapterRule = filterSelectableParentAdapter(initialPdfAdapterRule, newEnum);
    var newOverrideSchemas = tslib.__spreadArray([], overrideSchemas, true);
    // PdfFormBuilderでのエラーを防ぐためにpdfAdapterRuleが存在しない時はoverrideSchemaをundefinedにするという実装方法にする。
    // (詳細: https://github.com/graffer-inc/graffer-schemas/pull/1381/files/420168bd60d07b8ddce1d3e8c1ca68540800600c#r801253261)
    // この実装方法のリスクとしては、overrideSchemaにpdfAdapterRule以外のプロパティが入ってきた時に、
    // この処理によってそれらのプロパティが意図せず消えてしまうことである。
    // もし以下の実装方法を変える時は、上述のPdfFormBuilderのエラーに注意すること。
    newOverrideSchemas[unitIndex] = newPdfAdapterRule && {
        pdfAdapterRule: newPdfAdapterRule,
    };
    return newOverrideSchemas;
};
/**
 * enum(選択肢)に変更があった場合それをrepeatableのschemaAtIndexに反映させる
 * @param unitIndex 変更があったelementのbaseUnit内のindex
 * @param newEnum 新しいenum
 * @param repeatableParent 変更したいrepeatableの要素（baseUnitの親）
 * */
var filterRepeatableSchemaAtIndex = function (unitIndex, newEnum, repeatableParent) {
    var newSchemaAtIndex = repeatableParent.schemaAtIndex.map(function (overrideSchemas) {
        return filterOverrideSchemaWithNewEnum(overrideSchemas, unitIndex, newEnum);
    });
    return tslib.__assign(tslib.__assign({}, repeatableParent), { schemaAtIndex: newSchemaAtIndex });
};
/**
 * 非repeatableなelementにて、pdfAdapterRuleを選択肢に合わせてフィルターする
 * */
var filterSelectableAdapter = function (selectableElement) {
    var initialPdfAdapterRule = selectableElement.pdfAdapterRule;
    var newEnum = selectableElement.enum;
    var newPdfAdapterRule = initialPdfAdapterRule &&
        filterAdapterRuleWithNewEnum(initialPdfAdapterRule, newEnum);
    return tslib.__assign(tslib.__assign({}, selectableElement), { pdfAdapterRule: newPdfAdapterRule });
};
/**
 * selectable要素の時はpdfAdapterRuleが更新されることがあるので、builderもそれに合わせて更新する。
 * */
var updateSelectableAdapterInBuilder = function (builder, newElement, initialSate) {
    var copiedBuilder = builder.copy();
    // repeatableの時
    if (initialSate.parent) {
        var parent_1 = initialSate.parent, index = initialSate.index;
        var newParent = filterRepeatableSchemaAtIndex(index, newElement.enum, parent_1);
        return (copiedBuilder
            // まず更新された親を元にbuilderをupdate
            .update(newParent)
            // その後更新された子を元にbuilderをupdate
            .repeatableOf(newParent)
            .replaceByIndex(newElement, index));
    }
    // 非repeatableかつ元からpdfAdapterRuleがない時
    // ※ repeatableの時newElement.pdfAdapterRuleは常にundefinedになるためこの条件分岐はrepeatableの処理の後に書く
    if (!newElement.pdfAdapterRule) {
        return copiedBuilder;
    }
    // 非repeatableの時
    var elementWithNewAdapter = filterSelectableAdapter(newElement);
    return copiedBuilder.update(elementWithNewAdapter);
};

var ElementEditor = function (_a) {
    var schemaBuilder = _a.schemaBuilder, setNewBuilder = _a.setNewBuilder, editState = _a.editState, onClose = _a.onClose;
    var _b = useFormEditorContext(), thenInputFilter = _b.thenInputFilter, insertRuleIndex = _b.insertRuleIndex;
    var editorRegistry = useEditorRegistry();
    var _c = React.useState({
        element: editState.element,
        conditionalRules: schemaBuilder.conditionalRuleConverter.getAttachedRule(editState.element.id),
    }), state = _c[0], onStateUpdate = _c[1];
    var _d = useDirty(state), isDirty = _d.isDirty, setNewInitialState = _d.setNewInitialState;
    var isElementDirty = useDirty(state.element).isDirty;
    React.useEffect(function () {
        var state = {
            // TODO: elementのstateも更新するように変更する
            element: editState.element,
            conditionalRules: schemaBuilder.conditionalRuleConverter.getAttachedRule(editState.element.id),
        };
        onStateUpdate(state);
        setNewInitialState(state);
    }, [schemaBuilder, onStateUpdate, setNewInitialState]);
    var editingSchemaBuilder = React.useMemo(function () {
        var builder = schemaBuilder.copy();
        builder = builder.replaceByIndexes(state.element, editState.index, editState.parent);
        // selectableの時は必要に応じてbuilderをupdate
        if (formSchema.isInputElement(state.element) && formSchema.isSelectableElement(state.element)) {
            builder = updateSelectableAdapterInBuilder(builder, state.element, editState);
        }
        // conditionalRulesの内容に応じてbuilderをupdate
        for (var _i = 0, _a = state.conditionalRules; _i < _a.length; _i++) {
            var r = _a[_i];
            builder = builder.updateRuleByIndex(r.index, r.rule);
        }
        return builder;
    }, [schemaBuilder, state, editState]);
    var updatable = React.useMemo(function () {
        return isDirty(state) &&
            formSchema.validateElementSchemaWithAdditionalRestriction(state.element) &&
            editingSchemaBuilder.isConditionalRuleValid();
    }, [isDirty, state, editingSchemaBuilder]);
    var ElementEditorComponentType = editorRegistry.getElementEditor(editState.element, editState.parent) ||
        ElementRulesEditorView;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(EditorBox, { key: editState.element.id },
            React__namespace.createElement("div", { className: "px-3 py-3 is-clearfix" },
                React__namespace.createElement("div", { className: "is-pulled-right buttons" },
                    React__namespace.createElement("button", { className: "button is-outlined", onClick: onClose }, "\u9589\u3058\u308B"),
                    React__namespace.createElement("button", { className: "button is-outlined", onClick: function () {
                            setNewBuilder(editingSchemaBuilder);
                            onClose();
                        }, disabled: !updatable }, "\u4FDD\u5B58\u3059\u308B"))),
            React__namespace.createElement("div", { className: "px-3 py-3" },
                React__namespace.createElement(ElementTags, { element: state.element })),
            React__namespace.createElement("div", { className: "px-3 py-3" },
                React__namespace.createElement("p", { className: "title is-size-5" }, state.element.label.text)),
            React__namespace.createElement(ElementEditorComponentType, { schemaBuilder: editingSchemaBuilder, setNewBuilder: setNewBuilder, editState: state, onStateUpdate: onStateUpdate, isDirty: isDirty, isElementDirty: isElementDirty, insertRuleIndex: insertRuleIndex, thenInputFilter: thenInputFilter }))));
};

var css_248z = ".index-module_markdownApplyBanner__yhQbp {\n  max-width: 696px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background-color: #e8e9f9;\n  border-radius: 16px;\n}\n\n.index-module_markdownApplyBanner__yhQbp .index-module_header__NgdB8 {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  gap: 16px;\n}\n\n.index-module_markdownApplyBanner__yhQbp .index-module_header__NgdB8 p {\n  font-size: 16px;\n  color: #353ebd;\n}\n\n.index-module_markdownApplyBanner__yhQbp .index-module_content__py4fq {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.index-module_markdownApplyBanner__yhQbp .index-module_content__py4fq p {\n  font-size: 14px;\n  color: #262b38;\n  flex-grow: 1;\n}\n";
var styles = {"markdownApplyBanner":"index-module_markdownApplyBanner__yhQbp","header":"index-module_header__NgdB8","content":"index-module_content__py4fq"};
styleInject(css_248z);

var MarkdownApplyBanner = function (_a) {
    var disabled = _a.disabled, note = _a.note, onClick = _a.onClick, onClose = _a.onClose;
    /**
     * GCDKのInformationBannerではボタンやリンクの配置ができないため独自実装としている。
     * https://graffer.slack.com/archives/CM4RHTJE9/p1743582180968429
     * GDCKで実現できるようになれば、移行することが望ましい。
     */
    return (React__namespace.createElement("div", { className: styles.markdownApplyBanner },
        React__namespace.createElement("div", { className: styles.header },
            React__namespace.createElement("p", null, "\u8AAC\u660E\u6587\u3067\u592A\u5B57\u3084\u30EA\u30F3\u30AF\u304C\u4F7F\u7528\u53EF\u80FD\u306B\u306A\u308A\u307E\u3057\u305F\u3002"),
            React__namespace.createElement("button", { onClick: onClose, "aria-label": "\u9589\u3058\u308B" },
                React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTimes, size: "xl" }))),
        React__namespace.createElement("div", { className: styles.content },
            note ? (React__namespace.createElement("p", null, note)) : (React__namespace.createElement("p", null, "\u300C\u6709\u52B9\u5316\u3059\u308B\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u4F7F\u7528\u53EF\u80FD\u3067\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u8AAC\u660E\u6587\u3092\u8ABF\u6574\u5F8C\u3001\u300C\u66F4\u65B0\u3059\u308B\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u624B\u7D9A\u304D\u306B\u53CD\u6620\u3055\u308C\u307E\u3059\u3002\u306A\u304A\u3001\u66F4\u65B0\u3059\u308B\u3068\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002")),
            React__namespace.createElement("div", null,
                React__namespace.createElement(consoleDesignKit.SecondaryButton, { text: "\u6709\u52B9\u5316\u3059\u308B", onClick: onClick, disabled: disabled })))));
};

var FormEditorV2 = function (_a) {
    var initialSchema = _a.initialSchema, initialSection = _a.initialSection, _b = _a.onChangeCurrentSection, onChangeCurrentSection = _b === void 0 ? function () {
        return;
    } : _b, onChange = _a.onChange, _c = _a.editorOpt, editorOpt = _c === void 0 ? {} : _c;
    var _d = editorOpt.toolbarItemList, toolbarItemList = _d === void 0 ? DefaultToolbarItemList : _d, _e = editorOpt.editConfigRegistry, editConfigRegistry = _e === void 0 ? DefaultElementConfigRegistry : _e, _f = editorOpt.editorRegistry, editorRegistry = _f === void 0 ? DefaultEditorRegistry : _f, _g = editorOpt.validatorRegistry, validatorRegistry = _g === void 0 ? DefaultValidatorRegistry : _g, customSectionContent = editorOpt.customSectionContent, _h = editorOpt.thenInputFilter, thenInputFilter = _h === void 0 ? function () { return true; } : _h, sectionLimit = editorOpt.sectionLimit, fieldLimitPerSection = editorOpt.fieldLimitPerSection, markdownConfig = editorOpt.markdownConfig;
    var _j = useFormBuilderV2(initialSchema, onChange, initialSection, onChangeCurrentSection, editorOpt), schemaBuilder = _j.schemaBuilder, setNewBuilder = _j.setNewBuilder, insertElements = _j.insertElements, updateSchema = _j.updateSchema, removeElement = _j.removeElement, moveSection = _j.moveSection, moveElement = _j.moveElement, changeSection = _j.changeSection, insertSection = _j.insertSection, ruleSetMap = _j.ruleSetMap, editState = _j.editState, setEditState = _j.setEditState, finishEditState = _j.finishEditState, tabs = _j.tabs, tabState = _j.tabState, changeTab = _j.changeTab, showMarkdownApplyBanner = _j.showMarkdownApplyBanner, setShowMarkdownApplyBanner = _j.setShowMarkdownApplyBanner, isClickableMarkdownApplyButton = _j.isClickableMarkdownApplyButton, applyDescriptionMarkdown = _j.applyDescriptionMarkdown;
    var CustomSectionComponent = customSectionContent && customSectionContent(schemaBuilder.currentSection);
    return (React__namespace.createElement(FormEditorInnerWrapper, tslib.__assign({}, editorOpt, { editConfigRegistry: editConfigRegistry, editorRegistry: editorRegistry, toolbarItemList: toolbarItemList, validatorRegistry: validatorRegistry, thenInputFilter: thenInputFilter }),
        React__namespace.createElement(Tab, { tabs: tabs, tabState: tabState, setTabState: changeTab }),
        tabState === "FORM" && showMarkdownApplyBanner && (React__namespace.createElement(MarkdownApplyBanner, { disabled: !isClickableMarkdownApplyButton(), note: markdownConfig === null || markdownConfig === void 0 ? void 0 : markdownConfig.markdownApplyBannerNote, onClick: applyDescriptionMarkdown, onClose: function () { return setShowMarkdownApplyBanner(false); } })),
        React__namespace.createElement("div", { className: "columns" },
            React__namespace.createElement("div", { className: "column", style: {
                    maxWidth: "720px",
                    marginBottom: "80px",
                } }, matchType(tabState, {
                FORM: (React__namespace.createElement(React__namespace.Fragment, null,
                    React__namespace.createElement(FormListPaneV2, { schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, ruleMap: ruleSetMap, changeSection: changeSection, currentSection: schemaBuilder.currentSection, moveSection: moveSection, insertSection: insertSection, moveElement: moveElement, insertElements: insertElements, updateElement: updateSchema, removeElement: removeElement, setEditState: setEditState, sectionLimit: sectionLimit, fieldLimitPerSection: fieldLimitPerSection, CustomComponent: CustomSectionComponent, markdownConfig: markdownConfig }))),
                RULE: (React__namespace.createElement(ConditionalRulesListComponent, { schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, setEditState: setEditState })),
                FORMULA: (React__namespace.createElement(FormulaListComponent, { schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, setEditState: setEditState })),
            })),
            editState && (React__namespace.createElement("div", { className: "column is-paddingless" }, matchType(editState.type, {
                element: isElementEditTarget(editState) && (React__namespace.createElement(ElementEditor, { key: editState.element.id, schemaBuilder: schemaBuilder, setNewBuilder: setNewBuilder, editState: editState, onClose: finishEditState })),
                section: isSectionEditTarget(editState) && (React__namespace.createElement(EditorBox, { key: editState.element.id },
                    React__namespace.createElement(SectionEditor, { key: editState.element.id, element: editState.element, onElementUpdate: function (elem) {
                            setNewBuilder(schemaBuilder.updateSection(elem));
                            finishEditState();
                        }, onClose: finishEditState }))),
                conditional_rule: isConditionalRuleEditTarget(editState) && (React__namespace.createElement(React__namespace.Fragment, null,
                    React__namespace.createElement(EditorBox, { key: editState.index },
                        React__namespace.createElement(ConditionalRuleEditor, { key: editState.index, formSchema: schemaBuilder.currentSchema(), rule: editState.element, ruleIndex: editState.index, onSave: function (r) {
                                setNewBuilder(schemaBuilder.updateRuleByIndex(editState.index, r));
                                finishEditState();
                            }, onClose: finishEditState, viewMode: editorOpt.conditionalRuleViewMode })))),
                conditional_rules: isConditionalRulesEditTarget(editState) && (React__namespace.createElement(React__namespace.Fragment, null,
                    React__namespace.createElement("div", { className: "notification" },
                        React__namespace.createElement("span", { className: "has-text-weight-bold" },
                            "\u300C",
                            editState.attached.label.text,
                            "\u300D"),
                        "\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u6761\u4EF6\u5206\u5C90\u8A2D\u5B9A"),
                    editState.targets.map(function (target, idx) { return (React__namespace.createElement(EditorBox, { key: JSON.stringify(target.rule.then) + idx.toString() },
                        React__namespace.createElement(ConditionalRuleEditorRightPane, { formSchema: schemaBuilder.currentSchema(), rule: schemaBuilder.currentSchema().conditionalRuleSet
                                .conditionalRules[target.index], ruleIndex: target.index, onSave: function (r) {
                                setNewBuilder(schemaBuilder.updateRuleByIndex(target.index, r));
                            }, onClose: function () {
                                if (editState.targets.length === 1) {
                                    finishEditState();
                                }
                                else {
                                    setEditState(tslib.__assign(tslib.__assign({}, editState), { targets: editState.targets.filter(function (_, index) { return idx !== index; }) }));
                                }
                            } }))); }))),
                formula: isFormulaEditTarget(editState) && (React__namespace.createElement(EditorBox, { key: editState.element.id },
                    React__namespace.createElement(FormulaEditor, { key: editState.element.id, formSchema: schemaBuilder.currentSchema(), formula: editState.element, viewMode: editorOpt.formulaViewMode, onSave: function (formula) {
                            setNewBuilder(schemaBuilder.updateFormulaByIndex(editState.index, formula));
                            finishEditState();
                        }, onClose: finishEditState }))),
            }))))));
};

exports.ConditionalRequiredHiddenButtons = ConditionalRequiredHiddenButtons;
exports.ConditionalRuleEditorView = ConditionalRuleEditorView;
exports.ConditionalRulesList = ConditionalRulesList;
exports.ConditionalShowHideButtons = ConditionalShowHideButtons;
exports.DefaultEditorRegistry = DefaultEditorRegistry;
exports.DefaultElementConfigRegistry = DefaultElementConfigRegistry;
exports.DefaultToolbarItemList = DefaultToolbarItemList;
exports.ElementEditorView = ElementEditorView;
exports.FormEditor = FormEditorV2;
exports.FormEditorContext = FormEditorContext;
exports.FormEditorInnerWrapper = FormEditorInnerWrapper;
exports.FormSorter = FormSorter;
exports.RepeatableEditor = RepeatableEditor;
exports.RequiredHiddenButtons = RequiredHiddenButtons;
exports.SectionEditor = SectionEditor;
exports.TabTypes = TabTypes$1;
exports.ThenRuleEditor = ThenRuleEditor;
exports.defaultFormEditorMarkdownConfig = defaultFormEditorMarkdownConfig;
exports.useEditConfig = useEditConfig;
exports.useEditConfigRegistry = useEditConfigRegistry;
exports.useEditorRegistry = useEditorRegistry;
exports.useFormEditorContext = useFormEditorContext;
exports.useImageRefkeyExchanger = useImageRefkeyExchanger;
exports.useMarkdownConfig = useMarkdownConfig;
exports.useValidatoRegistry = useValidatoRegistry;
